(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1702],{

/***/ 65449:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page",
      function () {
        return __webpack_require__(43111);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Shared_DisplayDiscountPrice_index_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77360);
/* harmony import */ var _components_Shared_DisplayDiscountPrice_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_DisplayDiscountPrice_index_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57333);



const DisplayDiscountPrice = (param)=>{
    let { discountedPrice =0 , price =0 , currencySign ="$"  } = param;
    if (discountedPrice && discountedPrice !== price) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_components_Shared_DisplayDiscountPrice_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default().discountprice),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "price",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "price-discount",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_2__/* .NumericFormat */ .h3, {
                            value: discountedPrice,
                            displayType: "text",
                            thousandSeparator: true,
                            prefix: currencySign,
                            decimalScale: 2,
                            fixedDecimalScale: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "discount",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_2__/* .NumericFormat */ .h3, {
                                value: price,
                                displayType: "text",
                                thousandSeparator: true,
                                prefix: currencySign,
                                decimalScale: 2,
                                fixedDecimalScale: true
                            })
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "original-price",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_2__/* .NumericFormat */ .h3, {
            value: price,
            displayType: "text",
            thousandSeparator: true,
            prefix: currencySign,
            decimalScale: 2,
            fixedDecimalScale: true
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DisplayDiscountPrice);


/***/ }),

/***/ 43111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
// EXTERNAL MODULE: ./src/hooks/usePageAuth.js
var usePageAuth = __webpack_require__(85614);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 107 modules
var AemGrid = __webpack_require__(64704);
// EXTERNAL MODULE: ./src/components/core/Head/NextHead.jsx
var NextHead = __webpack_require__(46760);
// EXTERNAL MODULE: ./src/components/Default/BreadCrumb.jsx
var BreadCrumb = __webpack_require__(42053);
// EXTERNAL MODULE: ./components/ContactUs/v1/ContactUs.jsx + 9 modules
var ContactUs = __webpack_require__(2788);
// EXTERNAL MODULE: ./src/components/KeySpecifier/v1/KeySpecifier.jsx + 3 modules
var KeySpecifier = __webpack_require__(48440);
// EXTERNAL MODULE: ./src/components/AssociateMembership/v1/AssociateMembership.jsx + 4 modules
var AssociateMembership = __webpack_require__(21137);
// EXTERNAL MODULE: ./src/components/Literature/v1/Literature/index.jsx + 4 modules
var Literature = __webpack_require__(11419);
// EXTERNAL MODULE: ./src/components/TechnicalSpecs/v1/TechnicalSpecs.jsx + 7 modules
var TechnicalSpecs = __webpack_require__(25778);
// EXTERNAL MODULE: ./src/components/ProductDetail/v3/ProductAccordion/index.jsx + 1 modules
var ProductAccordion = __webpack_require__(22644);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx
var GlobalPageHeader = __webpack_require__(81169);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./src/components/KnowledgeArticle/v1/KnowledgeArticle.jsx + 2 modules
var KnowledgeArticle = __webpack_require__(99056);
// EXTERNAL MODULE: ./src/components/KnowledgeArticle/v1/KnowledgeArticleFiller.jsx
var KnowledgeArticleFiller = __webpack_require__(79491);
// EXTERNAL MODULE: ./components/BrowseAllStores/v1/BrowseAllStores.jsx + 3 modules
var BrowseAllStores = __webpack_require__(53087);
// EXTERNAL MODULE: ./src/components/FriendsAndFamily/v1/FriendsAndFamily.jsx + 3 modules
var FriendsAndFamily = __webpack_require__(5619);
// EXTERNAL MODULE: ./src/components/InstallDesignServices/v1/InstallDesignServices.jsx + 4 modules
var InstallDesignServices = __webpack_require__(5642);
// EXTERNAL MODULE: ./src/components/FindStore/v1/FindStore.jsx + 4 modules
var FindStore = __webpack_require__(79125);
// EXTERNAL MODULE: ./components/LeadGeneration/index.jsx + 3 modules
var LeadGeneration = __webpack_require__(43769);
// EXTERNAL MODULE: ./constants/api.js
var constants_api = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./src/components/FindStore/v1/analytics.js
var analytics = __webpack_require__(82423);
// EXTERNAL MODULE: ./node_modules/react-bingmaps/lib/index.js
var react_bingmaps_lib = __webpack_require__(20604);
// EXTERNAL MODULE: ./components/core/AutoSuggestion/v1/AutoSuggestion.jsx
var AutoSuggestion = __webpack_require__(36130);
// EXTERNAL MODULE: ./public/icons/filter.svg
var filter = __webpack_require__(24495);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(34846);
// EXTERNAL MODULE: ./src/utils/location.js
var utils_location = __webpack_require__(78800);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./components/Findashowroom/StoreCard/StoreCard.jsx







const StoreCard = (param)=>{
    let { data , store , staticTexts , findStoreDetails , findStoreCheckedId , isChecked , handleFindStoreCheck , isMobile , activeTab , FIRST_TAB  } = param;
    var ref, ref1;
    const [entityIDURL, setEntityIDURL] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,utils_location/* getShortenedUrl */.Pp)(findStoreDetails[(0,helper/* removeCharactersAfterNumber */.Z5P)(data === null || data === void 0 ? void 0 : data.EntityID)]).then((res)=>{
            setEntityIDURL(res);
        });
    }, [
        data === null || data === void 0 ? void 0 : data.EntityID
    ]);
    const formatPhoneNumber = (phoneNumberString)=>{
        let cleaned = ("" + phoneNumberString).replace(/\D/g, "");
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return "(" + match[1] + ") " + match[2] + "-" + match[3];
        }
        return null;
    };
    const getInternalLinkTypeBasedOnLink = (type)=>{
        const internalLinkType = (0,helper/* getInternalLinkTypeForFindStore */.dhb)(data.LocationName, data.Locality, data.StateLong);
        if (type === "store name" || type === "book appointment" || type === "view store details" || type === "set as preferred store" || type === "unset as preferred store") {
            return "find a store:".concat(internalLinkType);
        }
        return (0,helper/* sanitizeTextForAnalytics */.T68)(data.LocationName);
    };
    const getEventInfo = (type, link)=>{
        return JSON.stringify({
            eventAction: "find a store:landing:map:" + type,
            eventName: "find a store:landing:map:" + type,
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: type === "store name" ? (0,helper/* sanitizeTextForAnalytics */.T68)(data.LocationName) : type === "store contact number" ? formatPhoneNumber(data.Phone) : type,
            internalLinkPosition: "find a store",
            internalLinkType: getInternalLinkTypeBasedOnLink(type),
            internalLinkURL: link ? (type !== "store contact number" && link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
            internalLinkZoneName: "find a store:landing:map​",
            clickInternalLinks: "true"
        });
    };
    const isPreferredStore = findStoreCheckedId === (data === null || data === void 0 ? void 0 : data.EntityID);
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "store-card col-12 pr-0 ".concat(!store && "showroom", " wow animate__fadeInUp"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "store-card__details",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "store-card__address",
                        children: [
                            store && data.LocationName.split("by")[1] ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: entityIDURL !== null && entityIDURL !== void 0 ? entityIDURL : "/",
                                className: "store-card__name gbh-data-layer",
                                "data-gbh-data-layer": getEventInfo("store name", (ref2 = findStoreDetails[(0,helper/* removeCharactersAfterNumber */.Z5P)(data === null || data === void 0 ? void 0 : data.EntityID)]) !== null && ref2 !== void 0 ? ref2 : "/"),
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: data.LocationName.split("by")[0]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "by ",
                                            data.LocationName.split("by")[1]
                                        ]
                                    }),
                                    " "
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "store-card__name",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: data.LocationName
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: data.AddressLine + ","
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: (data === null || data === void 0 ? void 0 : data.AddressLine2) ? (data === null || data === void 0 ? void 0 : data.AddressLine2) + "," : ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            data.Locality,
                                            ", ",
                                            data.AdminDistrict,
                                            " ",
                                            data.PostalCode
                                        ]
                                    })
                                ]
                            }),
                            (data === null || data === void 0 ? void 0 : data.Phone) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "store-card-phone",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "tel:".concat(data.Phone),
                                    className: "gbh-data-layer",
                                    "data-gbh-data-layer": getEventInfo("store contact number", "tel:".concat(data.Phone)),
                                    children: staticTexts.ariaLabel.contact(formatPhoneNumber(data.Phone))
                                })
                            })
                        ]
                    }),
                    (data === null || data === void 0 ? void 0 : data.__Distance) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "store-card__time",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "store-card__open",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "distance",
                                        children: [
                                            (ref = data.__Distance) === null || ref === void 0 ? void 0 : ref.toFixed(2),
                                            " ",
                                            staticTexts.miles,
                                            " ",
                                            staticTexts.away
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: (ref1 = data.WeekdayHours) === null || ref1 === void 0 ? void 0 : ref1.replaceAll(" - ", "-")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: data.WeekendHours
                                    }),
                                    activeTab === FIRST_TAB && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            checked: isPreferredStore,
                                            value: isChecked && isPreferredStore ? staticTexts.setAsMyShowroom : staticTexts.setAsMyShowroom,
                                            id: "store-card__set-store",
                                            onChange: (e)=>{
                                                return handleFindStoreCheck(e.target.checked ? data === null || data === void 0 ? void 0 : data.EntityID : 0);
                                            },
                                            analyticsData: getEventInfo((isPreferredStore ? "unset" : "set") + " as preferred store")
                                        })
                                    })
                                ]
                            }),
                            activeTab === FIRST_TAB && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: entityIDURL !== null && entityIDURL !== void 0 ? entityIDURL : "/",
                                className: "store-card__view-details gbh-data-layer",
                                "data-gbh-data-layer": getEventInfo("view store details"),
                                children: isMobile ? staticTexts.storeDetail : staticTexts.viewShowroomDetails
                            })
                        ]
                    })
                ]
            }),
            (!store || !isMobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "store-card__image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    onError: (e)=>e.target.src = image_missing/* default */.Z,
                    src: !isEmpty_default()(data.Image) ? data.Image : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                    alt: (data === null || data === void 0 ? void 0 : data.AltText) || (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.annsacksShowroomImgAlt)
                })
            })
        ]
    });
};
/* harmony default export */ var StoreCard_StoreCard = (StoreCard);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Findashowroom/Filter.jsx
var Filter = __webpack_require__(77679);
;// CONCATENATED MODULE: ./components/Findashowroom/StoreList.jsx






const StoreList = (param)=>{
    let { data , active , activeTab , staticTexts , findStoreDetails , findStoreCheckedId , handleFindStoreCheck , index , FIRST_TAB , isMobile  } = param;
    var ref;
    const [entityIDURL, setEntityIDURL] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,helper/* getShortenedUrl */.Ppy)(findStoreDetails[(0,helper/* removeCharactersAfterNumber */.Z5P)(data === null || data === void 0 ? void 0 : data.EntityID)]).then((res)=>{
            setEntityIDURL(res);
        });
    }, [
        data === null || data === void 0 ? void 0 : data.EntityID
    ]);
    const formatPhoneNumber = (phoneNumberString)=>{
        let cleaned = ("" + phoneNumberString).replace(/\D/g, "");
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return "(" + match[1] + ") " + match[2] + "-" + match[3];
        }
        return null;
    };
    const getEventInfo = (type, link)=>{
        let internalLinkName;
        let internalLinkType = (0,helper/* sanitizeTextForAnalytics */.T68)(data === null || data === void 0 ? void 0 : data.LocationName);
        const internalLinkTypeForFindStore = (0,helper/* getInternalLinkTypeForFindStore */.dhb)(data === null || data === void 0 ? void 0 : data.LocationName, data === null || data === void 0 ? void 0 : data.Locality, data === null || data === void 0 ? void 0 : data.StateLong);
        if (type === "store name") {
            internalLinkName = (0,helper/* sanitizeTextForAnalytics */.T68)(data === null || data === void 0 ? void 0 : data.LocationName);
            internalLinkType = "find a store".concat(internalLinkTypeForFindStore);
        } else if (type === "contact number") {
            internalLinkName = formatPhoneNumber(data === null || data === void 0 ? void 0 : data.Phone);
            internalLinkType = "find a store:".concat((0,helper/* sanitizeTextForAnalytics */.T68)(data === null || data === void 0 ? void 0 : data.LocationName));
        } else if (type === "set as preferred store" || type === "unset as preferred store") {
            internalLinkType = "find a store:".concat(internalLinkTypeForFindStore);
        }
        return JSON.stringify({
            eventAction: "find a store:landing:location info:".concat(type),
            eventName: "find a store:landing:location info:".concat(type),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: internalLinkName || type,
            internalLinkPosition: "find a store",
            internalLinkType,
            internalLinkZoneName: "find a store:landing:location info​",
            internalLinkURL: link ? (type !== "contact number" && (link === null || link === void 0 ? void 0 : link.indexOf("http")) === -1 ? window.location.origin : "") + link : "n/a",
            clickInternalLinks: "true"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "store-list ".concat(active && "store-list--active"),
        role: "listitem",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-8 col-md-4 store-list__name-col px-0",
                        children: activeTab !== FIRST_TAB || findStoreDetails && !((0,helper/* removeCharactersAfterNumber */.Z5P)(data === null || data === void 0 ? void 0 : data.EntityID) in findStoreDetails) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "store-list__name store-list__genuine-dealers gbh-data-layer",
                            children: data === null || data === void 0 ? void 0 : data.LocationName
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: entityIDURL !== null && entityIDURL !== void 0 ? entityIDURL : "/",
                                className: "store-list__name gbh-data-layer",
                                "aria-label": "link to store name",
                                "data-gbh-data-layer": getEventInfo("store name", entityIDURL !== null && entityIDURL !== void 0 ? entityIDURL : "/"),
                                children: data === null || data === void 0 ? void 0 : data.LocationName
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-md-4 store-list__address-col px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "store-list__address",
                                children: !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: (data === null || data === void 0 ? void 0 : data.AddressLine) + ","
                                        }),
                                        !isEmpty_default()(data === null || data === void 0 ? void 0 : data.AddressLine2) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                data === null || data === void 0 ? void 0 : data.AddressLine2,
                                                ","
                                            ]
                                        }) : "",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: (data === null || data === void 0 ? void 0 : data.Locality) + ", " + (data === null || data === void 0 ? void 0 : data.AdminDistrict) + " " + (data === null || data === void 0 ? void 0 : data.PostalCode)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: lib/* isIOS */.gn === true ? "maps://maps.google.com/maps?daddr=".concat(data === null || data === void 0 ? void 0 : data.Latitude, ",").concat(data === null || data === void 0 ? void 0 : data.Longitude, "&amp;ll=") : "http://www.google.com/maps?q=".concat(data === null || data === void 0 ? void 0 : data.Latitude, ",").concat(data === null || data === void 0 ? void 0 : data.Longitude),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: data === null || data === void 0 ? void 0 : data.AddressLine
                                        }),
                                        isEmpty_default()(data === null || data === void 0 ? void 0 : data.AddressLine2) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: data === null || data === void 0 ? void 0 : data.AddressLine2
                                        }) : "",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: (data === null || data === void 0 ? void 0 : data.Locality) + ", " + (data === null || data === void 0 ? void 0 : data.AdminDistrict) + " " + (data === null || data === void 0 ? void 0 : data.PostalCode)
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "tel:+".concat(data === null || data === void 0 ? void 0 : data.Phone),
                                className: "store-list__phone gbh-data-layer",
                                "aria-label": "".concat(data === null || data === void 0 ? void 0 : data.Phone, " Dial this number to contact ").concat(data === null || data === void 0 ? void 0 : data.LocationName, " store"),
                                "data-gbh-data-layer": getEventInfo("contact number", "tel:".concat(formatPhoneNumber(data === null || data === void 0 ? void 0 : data.Phone))),
                                children: formatPhoneNumber(data === null || data === void 0 ? void 0 : data.Phone)
                            })
                        ]
                    }),
                    (data === null || data === void 0 ? void 0 : data.__Distance) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-3 col-md-2 store-list__distance-col px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "store-list__distance",
                                children: (data === null || data === void 0 ? void 0 : (ref = data.__Distance) === null || ref === void 0 ? void 0 : ref.toFixed(1)) + " mi"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "store-list__time",
                                children: data === null || data === void 0 ? void 0 : data.OpenUntil
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    activeTab === FIRST_TAB && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-7 px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "store-list__set-store",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                analyticsData: getEventInfo("".concat(!(findStoreCheckedId === (data === null || data === void 0 ? void 0 : data.EntityID)) ? "unset" : "set", " as preferred store")),
                                id: "store-list__set-store_".concat(index),
                                checked: findStoreCheckedId === (data === null || data === void 0 ? void 0 : data.EntityID),
                                value: findStoreCheckedId === (data === null || data === void 0 ? void 0 : data.EntityID) ? staticTexts.myStore : staticTexts.setAsMyStore,
                                onChange: (e)=>{
                                    return handleFindStoreCheck(e.target.checked ? data === null || data === void 0 ? void 0 : data.EntityID : 0);
                                }
                            })
                        })
                    }),
                    (data === null || data === void 0 ? void 0 : data.OpenUntil) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-5 px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "store-list__set-store-time",
                            children: data === null || data === void 0 ? void 0 : data.OpenUntil
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Findashowroom_StoreList = (StoreList);

;// CONCATENATED MODULE: ./components/Findashowroom/analytics/index.js

const locationIconDataAnalytics = (res)=>{
    const { message ="n/a" , LocationName  } = res;
    const internalLinkType = (0,helper/* getInternalLinkTypeForFindStore */.dhb)(res.LocationName, res.Locality, res.StateLong);
    const eventInfo = {
        eventAction: "find a store:landing:map:location icon",
        eventName: "find a store:landing:map:location icon",
        eventType: "navigation",
        eventMsg: message === null || message === void 0 ? void 0 : message.toLowerCase(),
        eventStatus: "n/a",
        internalLinkName: LocationName === null || LocationName === void 0 ? void 0 : LocationName.toLowerCase(),
        internalLinkPosition: "find a store landing map​",
        internalLinkType: "find a store:".concat(internalLinkType),
        internalLinkZoneName: "find a store:landing:map",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo: eventInfo,
        page: page
    });
};

// EXTERNAL MODULE: ./src/components/core/Modal/ZipCodeInfoModal.jsx
var ZipCodeInfoModal = __webpack_require__(4801);
;// CONCATENATED MODULE: ./components/Findashowroom/FindShowroomLanding.jsx



















const FindShowroomLanding = (param)=>{
    let { staticTexts , tabList , activeTab , findStoresBingKey , latitude , longitude , handleChange , searchTerm , citySuggestData , responseData , changeTab , findStoreDetails , handleFindStoreCheck , findStoreCheckedId , facets , selectedFilterCount , totalResults , getStoreDetails , getGeoLocation , ...props } = param;
    var ref, ref1;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [showFilter, setShowFilter] = (0,react.useState)(false);
    const [showMap, setShowMap] = (0,react.useState)(false);
    const [tabList_] = (0,react.useState)(tabList === null || tabList === void 0 ? void 0 : tabList.filter((t)=>!t.inActive));
    const [FIRST_TAB, SECOND_TAB, THIRD_TAB] = [
        0,
        1,
        2
    ];
    const [browseAllStoreUrl, setBrowseAllStoreUrl] = (0,react.useState)("");
    const [curStore, selectStore] = (0,react.useState)(null);
    const [center, setCenter] = (0,react.useState)([
        latitude,
        longitude
    ]);
    const [infoboxes, setInfoboxes] = (0,react.useState)([]);
    const [mapInfo, setMapInfo] = (0,react.useState)([]);
    const [showStoreCard, setShowStoreCard] = (0,react.useState)(false);
    const activeTabs = [];
    const prevShowFilter = (0,react.useRef)(false);
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { isLandscape  } = props;
    const dataKeys = (responseData === null || responseData === void 0 ? void 0 : responseData.length) > 0 && ((ref = responseData === null || responseData === void 0 ? void 0 : responseData.map((d)=>Object.keys(d))) === null || ref === void 0 ? void 0 : ref.flat());
    const filterClass = classnames_default()({
        "find-store-landing__filter": true,
        "pl-0": lib/* isMobile */.tq ? false : !showFilter,
        "find-store-landing__filter--hide": !showFilter,
        "find-store-landing__filter--modal": lib/* isMobile */.tq ? showFilter : false
    });
    (0,react.useEffect)(()=>{
        var ref;
        if (responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.length) > 0) {
            if (tabList_[activeTab].tabDetail) {
                if (responseData) {
                    const handleCreateMapData = (extractStores)=>{
                        return extractStores === null || extractStores === void 0 ? void 0 : extractStores.map((store)=>{
                            var ref;
                            return {
                                location: [
                                    store.Latitude,
                                    store.Longitude
                                ],
                                option: {
                                    icon: "".concat("https://annsacks.kohler.com").concat((ref = tabList_[activeTab]) === null || ref === void 0 ? void 0 : ref.icon)
                                },
                                addHandler: {
                                    type: "click",
                                    callback: ()=>handleClickLocationIcon(store)
                                }
                            };
                        });
                    };
                    const pins = [];
                    responseData.map((d)=>{
                        for (const [k, v] of Object.entries(d)){
                            pins[k] = handleCreateMapData(v);
                        }
                    });
                    if (pins[activeTab]) {
                        var ref1, ref2;
                        setCenter([
                            (ref1 = pins[activeTab][0]) === null || ref1 === void 0 ? void 0 : ref1.location[0],
                            (ref2 = pins[activeTab][0]) === null || ref2 === void 0 ? void 0 : ref2.location[1]
                        ]);
                    }
                    setMapInfo(pins);
                } else {
                    setMapInfo([]);
                }
            }
        } else {
            setCenter([]);
            setMapInfo([]);
        }
        (ref = window.wow) === null || ref === void 0 ? void 0 : ref.sync();
    }, [
        activeTab,
        responseData
    ]);
    (0,react.useEffect)(()=>{
        if (showFilter) {
            const storeFilterEle = document.getElementById("kf-store-filter");
            if (storeFilterEle) {
                var ref, ref1;
                (storeFilterEle === null || storeFilterEle === void 0 ? void 0 : storeFilterEle.childNodes) && ((ref1 = (ref = storeFilterEle.childNodes[0]) === null || ref === void 0 ? void 0 : ref.querySelector('[tabindex="0"]')) === null || ref1 === void 0 ? void 0 : ref1.focus());
            }
        }
        if ((prevShowFilter === null || prevShowFilter === void 0 ? void 0 : prevShowFilter.current) !== showFilter) {
            (0,analytics/* getFilterEventInfo */.Us)(showFilter);
            prevShowFilter.current = showFilter;
        }
    }, [
        showFilter
    ]);
    const handleClickLocationIcon = (store)=>{
        setInfoboxes([
            {
                location: [
                    store.Latitude,
                    store.Longitude
                ],
                option: {
                    title: store.LocationName,
                    description: store.AddressLine
                },
                addHandler: {
                    type: "mouseenter",
                    callback: ()=>{
                        const closeIcon = document === null || document === void 0 ? void 0 : document.getElementsByClassName("infobox-close")[0];
                        if (closeIcon) {
                            closeIcon.addEventListener("click", ()=>setShowStoreCard(false));
                        }
                    }
                }
            }
        ]);
        setCenter([
            store.Latitude,
            store.Longitude
        ]);
        selectStore(store);
        setShowStoreCard(true);
        locationIconDataAnalytics(store);
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const { general  } = config;
            const browseAllStoreUrl_ = await (0,helper/* getShortenedUrl */.Ppy)((staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.ctaLink) || (general === null || general === void 0 ? void 0 : general.allStoresPagePath) || "/");
            setBrowseAllStoreUrl(browseAllStoreUrl_);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!searchTerm) {
            getGeoLocation(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.userMyLocation);
        }
    }, []);
    const handleTabChange = function(tabIdx) {
        let type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, title = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        changeTab(tabIdx);
        selectStore(null);
        setInfoboxes([]);
        const eventInfo = JSON.parse((0,analytics/* getStoreEventInfo */.B8)(type, title));
        if (type || title) {
            (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
        }
    };
    const handleKeyPress = (e)=>{
        if (e.keyCode === 37 || e.keyCode === 39) {
            var ref;
            let tab;
            if (e.keyCode === 37) {
                tab = activeTab - 1;
            } else if (e.keyCode === 39) {
                tab = activeTab + 1;
            }
            if (tab < 0) tab = tabList_.length - 1;
            if (tab >= tabList_.length) tab = 0;
            document.getElementById("find-store__".concat((ref = tabList_[tab].key) === null || ref === void 0 ? void 0 : ref.toLowerCase(), "--tab")).focus();
        }
    };
    var _ctaLabel, _ctaLabel1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "find-store-landing",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeInfoModal/* default */.Z, {
                handleModalClose: ()=>{
                    props.InfoModal();
                },
                show: props.infoModal,
                data: props.infoModalError,
                store: true,
                labelledBy: "Geo-Location-store-error-message",
                className: "message-modal",
                staticTexts: {
                    ...staticTexts,
                    continue: staticTexts.continue_
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row ml-0 mr-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            id: "find-store-crumb",
                            className: "find-store-landing__breadcrumb"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: filterClass,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "find-store-landing__filter-panel",
                                children: showFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter/* default */.Z, {
                                    facets: facets,
                                    close: (isShow)=>setShowFilter(isShow),
                                    onFilter: (curfilters, preventUnwantedDataLayer)=>getStoreDetails(curfilters, preventUnwantedDataLayer),
                                    displayShare: false,
                                    texts: staticTexts,
                                    selectedFilterCount: selectedFilterCount,
                                    totalResults: totalResults,
                                    showFilter: showFilter,
                                    addToUrl: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "find-store-landing__result-container ".concat(lib/* isMobile */.tq ? width >= 1024 ? showFilter ? " " : " find-store-landing__result-full" : " col-12" : showFilter ? " " : " find-store-landing__result-full"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "\n                  find-store-landing__search-container ".concat(width <= 1024 ? showMap ? lib/* isMobile */.tq && (lib/* isTablet */.Em || isLandscape) ? "col-lg-5 col-5" : "col-lg-12 col-12" : "col-lg-12 col-12" : "col-lg-5 col-5"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-store-landing__search",
                                                children: !isSsr && /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSuggestion/* default */.Z, {
                                                    placeholderLabel: staticTexts.countryPlaceholder,
                                                    selectedValue: searchTerm,
                                                    handleChange: (selectedVal)=>handleChange(selectedVal),
                                                    handleSelect: (selectedVal)=>handleChange(selectedVal),
                                                    optionList: citySuggestData,
                                                    borderValue: "bottom",
                                                    suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        role: "button",
                                                        tabIndex: "0",
                                                        "aria-label": showFilter ? staticTexts.ariaLabel.hideFilter : staticTexts.ariaLabel.showFilter,
                                                        src: filter/* default */.Z === null || filter/* default */.Z === void 0 ? void 0 : filter/* default.src */.Z.src,
                                                        alt: staticTexts.ariaLabel.showFilter,
                                                        onClick: ()=>setShowFilter(!showFilter),
                                                        id: "find-store-landing__search-auto-suggest"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                role: "button",
                                                tabIndex: "0",
                                                id: "kf-store-use-location",
                                                className: "find-store-landing__use-location",
                                                onClick: ()=>getGeoLocation(staticTexts.userMyLocation),
                                                children: staticTexts.userMyLocation
                                            }),
                                            width <= 1025 ? !showMap ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                role: "button",
                                                tabIndex: "0",
                                                className: "find-store-landing__view-list",
                                                onClick: ()=>setShowMap(!showMap),
                                                children: staticTexts.viewMap
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                role: "button",
                                                tabIndex: "0",
                                                className: "find-store-landing__view-list",
                                                onClick: ()=>{
                                                    setShowMap(!showMap);
                                                    setShowStoreCard(false);
                                                },
                                                children: staticTexts.viewList
                                            }) : "",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-store-landing__store-card --ml",
                                                children: curStore && showStoreCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCard_StoreCard, {
                                                    isMobile: lib/* isMobile */.tq,
                                                    data: curStore,
                                                    store: (curStore === null || curStore === void 0 ? void 0 : curStore.DealerShowroom) === "AS Showroom" ? true : false,
                                                    staticTexts: staticTexts,
                                                    findStoreDetails: findStoreDetails,
                                                    handleFindStoreCheck: handleFindStoreCheck,
                                                    findStoreCheckedId: findStoreCheckedId,
                                                    isChecked: Boolean(findStoreCheckedId),
                                                    activeTab: activeTab,
                                                    FIRST_TAB: FIRST_TAB
                                                })
                                            }),
                                            !showMap && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.length) > 0 && !isEmpty_default()(searchTerm) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "find-store-landing__tabs wow animate__fadeInUp",
                                                        role: "tablist_",
                                                        children: tabList_.map((tab, i)=>{
                                                            var ref;
                                                            return !tab.inActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "find-store-landing__tab ".concat(activeTab === i ? "find-store-landing__tab--active" : ""),
                                                                onClick: ()=>handleTabChange(i, "inner tabs", tab.title),
                                                                onKeyDown: handleKeyPress,
                                                                role: "tab",
                                                                tabIndex: 0,
                                                                "aria-selected": activeTab === i,
                                                                id: "find-store__".concat((ref = tab.key) === null || ref === void 0 ? void 0 : ref.toLowerCase(), "--tab"),
                                                                children: tab.title
                                                            }, i) : null;
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "list",
                                                        className: "find-store-landing__list ".concat(responseData && responseData.length > 0 ? "find-store-landing__show-list" : "", " ").concat((tabList_ === null || tabList_ === void 0 ? void 0 : tabList_.length) > 0 && ((ref1 = tabList_[activeTab]) === null || ref1 === void 0 ? void 0 : ref1.key) !== staticTexts.kohlerStore ? "find-store-landing__list-mb" : ""),
                                                        children: responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.length) > 0 && !isEmpty_default()(searchTerm) && (responseData === null || responseData === void 0 ? void 0 : responseData.length) > 0 ? responseData === null || responseData === void 0 ? void 0 : responseData.map((store)=>{
                                                            var ref, ref1;
                                                            if (((ref = store[activeTab]) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                                                                return store[activeTab].map((store, i)=>{
                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Findashowroom_StoreList, {
                                                                        data: store,
                                                                        index: i,
                                                                        activeTab: activeTab,
                                                                        staticTexts: staticTexts,
                                                                        active: (curStore === null || curStore === void 0 ? void 0 : curStore.EntityID) === store.EntityID ? true : false,
                                                                        findStoreDetails: findStoreDetails,
                                                                        handleFindStoreCheck: handleFindStoreCheck,
                                                                        findStoreCheckedId: findStoreCheckedId,
                                                                        isChecked: Boolean(findStoreCheckedId),
                                                                        FIRST_TAB: FIRST_TAB,
                                                                        isMobile: lib/* isMobile */.tq
                                                                    }, i);
                                                                });
                                                            } else if (dataKeys && !((ref1 = dataKeys.map(Number)) === null || ref1 === void 0 ? void 0 : ref1.includes(activeTab)) && !activeTabs.includes(activeTab)) {
                                                                activeTabs.push(activeTab);
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "find-store-landing__message find-store-landing__store-message",
                                                                    children: staticTexts.locationErrormessage
                                                                });
                                                            } else return null;
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "find-store-landing__message ".concat(!(responseData === null || responseData === void 0 ? void 0 : responseData.length) && (responseData === null || responseData === void 0 ? void 0 : responseData.length) > 0 ? "find-store-landing__store-message" : ""),
                                                            children: staticTexts.locationErrormessage
                                                        })
                                                    }),
                                                    activeTab === FIRST_TAB && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "find-store-browseall-div",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            label: (_ctaLabel = staticTexts.ctaLabel) !== null && _ctaLabel !== void 0 ? _ctaLabel : staticTexts.browseAllStore,
                                                            size: "large",
                                                            type: "ghost",
                                                            role: "link",
                                                            tag: "anchor",
                                                            target: staticTexts.isNewTab ? "_blank" : "_self",
                                                            rel: staticTexts.isNewTab ? "noopener" : "",
                                                            "aria-label": staticTexts.ariaLabel.browseAll,
                                                            className: "gbh-data-layer find-store-browseall-link",
                                                            useDefaultClass: true,
                                                            "data-gbh-data-layer": (0,analytics/* getStoreEventInfo */.B8)("browse all stores", (_ctaLabel1 = staticTexts.ctaLabel) !== null && _ctaLabel1 !== void 0 ? _ctaLabel1 : staticTexts.browseAllStore, browseAllStoreUrl),
                                                            to: browseAllStoreUrl
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "find-store-landing__map ".concat(showMap ? width <= 1024 ? lib/* isTablet */.Em || isLandscape ? "col-7 find-store-landing__show-map" : "col-12 find-store-landing__show-map" : "col-7" : "col-7", " wow animate__fadeInUp"),
                                        children: [
                                            !isEmpty_default()(findStoresBingKey) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bingmaps_lib/* ReactBingmaps */.a, {
                                                bingmapKey: findStoresBingKey,
                                                center: center,
                                                mapTypeId: "grayscale",
                                                disableStreetside: true,
                                                navigationBarMode: "square",
                                                zoom: 12,
                                                mapOptions: {
                                                    showMapTypeSelector: false,
                                                    NavigationBarMode: "square"
                                                },
                                                infoboxes: infoboxes,
                                                pushPins: mapInfo[activeTab]
                                            }, mapInfo[activeTab]),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-store-landing__store-card",
                                                children: curStore && showStoreCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCard_StoreCard, {
                                                    isMobile: lib/* isMobile */.tq,
                                                    data: curStore,
                                                    store: (curStore === null || curStore === void 0 ? void 0 : curStore.DealerShowroom) === "AS Showroom" ? true : false,
                                                    staticTexts: staticTexts,
                                                    findStoreDetails: findStoreDetails,
                                                    handleFindStoreCheck: handleFindStoreCheck,
                                                    findStoreCheckedId: findStoreCheckedId,
                                                    isChecked: Boolean(findStoreCheckedId),
                                                    FIRST_TAB: FIRST_TAB,
                                                    activeTab: activeTab
                                                })
                                            }),
                                            findStoresBingKey && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-store-landing__location-note",
                                                "aria-label": staticTexts.ariaLabel.mapGuidelines,
                                                children: tabList_ && tabList_.map((tab, i)=>{
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                role: "presentation",
                                                                "aria-label": staticTexts.ariaLabel.mapMarker,
                                                                src: "".concat("https://annsacks.kohler.com").concat(tab === null || tab === void 0 ? void 0 : tab.icon),
                                                                alt: "",
                                                                className: "img-fluid"
                                                            }),
                                                            lib/* isMobile */.tq ? tab.locationNoteMobile : tab.locationNote
                                                        ]
                                                    }, i);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Findashowroom_FindShowroomLanding = ((0,lib/* withOrientationChange */.Qe)(FindShowroomLanding));

// EXTERNAL MODULE: ./i18n/useFindashowroomi18n.js
var useFindashowroomi18n = __webpack_require__(75185);
// EXTERNAL MODULE: ./public/icons/locator-big-chacrol.svg
var locator_big_chacrol = __webpack_require__(59537);
// EXTERNAL MODULE: ./public/icons/locator-big-red.svg
var locator_big_red = __webpack_require__(38015);
// EXTERNAL MODULE: ./public/icons/locator-big-green.svg
var locator_big_green = __webpack_require__(18146);
// EXTERNAL MODULE: ./src/store/features/locationSlice.js
var locationSlice = __webpack_require__(13644);
;// CONCATENATED MODULE: ./components/Findashowroom/index.jsx

















const FindShowroom = (props)=>{
    const { data  } = props;
    const { findStoreItemsTab1 , findStoreItemsTab2 , findStoreItemsTab3 , inactiveTab1 =false , inactiveTab2 =false , inactiveTab3 =false , mapPinIconTab1 ="" , mapPinIconTab2 ="" , mapPinIconTab3 ="" , tabTitleTab1 ="" , tabTitleTab2 ="" , tabTitleTab3 ="" , noResultMessage =""  } = data;
    const onceRef = (0,react.useRef)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const { myStoreId , browseLocationsStoreFilterData  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const [tabList, setTabList] = (0,react.useState)([]);
    const [findStoreDetails, setFindStoreDetails] = (0,react.useState)("");
    const [findStores, setFindStores] = (0,react.useState)("");
    const [findaStoreQuery, setFindaStoreQuery] = (0,react.useState)("");
    const [siteName, setSiteName] = (0,react.useState)("");
    const [searchTerm, setSearchTerm] = (0,react.useState)("");
    const [findStoresBingKey, setFindStoresBingKey] = (0,react.useState)("");
    const [infoModal, setInfoModal] = (0,react.useState)(false);
    const [infoModalError, setinfoModalError] = (0,react.useState)({});
    const [info, setInfo] = (0,react.useState)({});
    const [curFilters, setCurFilters] = (0,react.useState)([]);
    const [citySuggestData, setCitySuggestData] = (0,react.useState)([]);
    const [latitude, setLatitude] = (0,react.useState)(0);
    const [longitude, setLongitude] = (0,react.useState)(0);
    const [responseData, setResponseData] = (0,react.useState)([]);
    const [curFilterQueries] = (0,react.useState)([]);
    const [distanceInMiles] = (0,react.useState)(161);
    const [activeTab, setActiveTab] = (0,react.useState)(0);
    const [findStoreCheckedId, setFindStoreCheckedId] = (0,react.useState)("");
    const [findStoreFilterData] = (0,react.useState)(get_default()(browseLocationsStoreFilterData, "storefilter", {}));
    (0,react.useEffect)(()=>{
        var ref;
        setFindStoreCheckedId((ref = localStorage.getItem("myStoreId")) !== null && ref !== void 0 ? ref : 0);
    }, []);
    const fetchZipCodeFromUrl = ()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const urlZipCode = urlParams.get("q");
        setSearchTerm(urlZipCode ? urlZipCode : "");
    };
    const getGeoLocation = (type)=>{
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            var ref;
            setSearchTerm((ref = getLocation === null || getLocation === void 0 ? void 0 : getLocation.zipcode) !== null && ref !== void 0 ? ref : "");
        }).catch((error)=>{
            var ref;
            addFindAStoreAnalytics({
                status: "failure",
                total: 0,
                errorMessage: (staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.messageZipcode) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || (error === null || error === void 0 ? void 0 : error.message),
                type
            });
            setinfoModalError("");
            setInfoModal(true);
        });
    };
    const handleChange = (inputVal)=>{
        setSearchTerm(inputVal);
        localStorage.setItem("searchTerm", inputVal);
    };
    (0,react.useEffect)(()=>{
        if (myStoreId !== findStoreCheckedId) {
            localStorage.setItem("myStoreId", myStoreId);
            setFindStoreCheckedId(myStoreId);
        }
    }, [
        myStoreId
    ]);
    (0,react.useEffect)(()=>{
        if (myStoreId !== 0 && !isEmpty_default()(info)) {
            getUtilityDataById();
        }
    }, [
        myStoreId,
        info
    ]);
    const getUtilityDataById = async ()=>{
        const utilityData = await (0,utils_location/* getStoreDataById */.e)({
            myStoreId: myStoreId,
            findStores: findStores,
            siteName: info.siteName
        });
        dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
    };
    const handleFindStoreCheck = (entity)=>{
        localStorage.setItem("myStoreId", entity);
        dispatch((0,locationSlice/* setMyStore */.h9)(entity));
        setFindStoreCheckedId(entity);
    };
    const addFindAStoreAnalytics = (params)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        const { total , errorMessage , status , type =null , searchItem =null  } = params;
        let errMsg = (ref1 = (0,helper/* sanitizeText */.oOy)((staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.locationErrormessage) ? staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.locationErrormessage) === null || ref === void 0 ? void 0 : ref.toLowerCase() : undefined.props.t("kf.findstore.label.locationErrormessage"))) === null || ref1 === void 0 ? void 0 : ref1.replace("\n", "");
        if (total == 0) errMsg = (ref2 = (0,helper/* sanitizeText */.oOy)("".concat(noResultMessage))) === null || ref2 === void 0 ? void 0 : ref2.replace("\n", "");
        const pageObj = window === null || window === void 0 ? void 0 : (ref3 = window.adobeDataLayer) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.page;
        const event = !(0,helper/* isShowAnalyticsEventLoaded */.xJ2)() ? "cmp:show" : "cmp:click";
        const pageComponent = event === "cmp:show" ? pageObj === null || pageObj === void 0 ? void 0 : (ref5 = pageObj.category) === null || ref5 === void 0 ? void 0 : ref5.subCategoryID : "find a store";
        const storeSearchType = (ref6 = pageComponent === null || pageComponent === void 0 ? void 0 : pageComponent.split(" ")) === null || ref6 === void 0 ? void 0 : ref6[2];
        const currDate = new Date();
        const eventInfo = {
            searchCount: sessionStorage.getItem("findStores") ? Number(sessionStorage.getItem("findStores")) + 1 : 1,
            searchResult: total,
            internalLinkName: type && type.length > 0 && (type === null || type === void 0 ? void 0 : type.toLowerCase()) || "".concat(storeSearchType, " search"),
            internalLinkPosition: "".concat(pageComponent),
            internalLinkType: "".concat(pageComponent, ":navigation"),
            searchType: isNaN(searchTerm) ? "Location" : "ZipCode",
            searchTerm: searchItem || searchTerm,
            eventAction: "".concat(pageComponent, ":landing:location info​:").concat(storeSearchType, " search"),
            eventName: "".concat(pageComponent, ":landing:location info​:").concat(storeSearchType, " search"),
            eventType: "navigation",
            clickInternalLinks: "true",
            internalLinkURL: window.location.origin + window.location.pathname,
            internalLinkZoneName: "".concat(pageComponent, ":landing:location info"),
            eventMsg: status === "success" ? "n/a" : errorMessage || errMsg || "n/a",
            eventStatus: status === "success" ? "success" : "failure",
            pageName: "".concat(pageComponent, " result"),
            pageURL: window.location.href,
            referrer: document.referrer || "n/a",
            previousPage: document.referrer || "n/a",
            timeStamp: currDate.toISOString().split("T")[0] + " " + currDate.toTimeString().split(" ")[0]
        };
        if (event === "cmp:show" && !(0,helper/* isShowAnalyticsEventLoaded */.xJ2)() || event !== "cmp:show") {
            sessionStorage.setItem("findStores", eventInfo.searchCount);
            const dtLayerObj = {
                event,
                page: pageObj
            };
            if ((0,helper/* navigationType */.UsO)() !== 1 && event === "cmp:show" || event === "cmp:click") {
                dtLayerObj.eventInfo = eventInfo;
            }
            window.adobeDataLayer.push({
                ...dtLayerObj
            });
            delete window.pageObj;
        }
    };
    const { all , annSacks , annSacksText , annsacksShowroom , annsacksShowroomImgAlt , applyFilters , ariaLabel , away , backToTop , browseAllStore , clearAll , countryPlaceholder , ctaLabel , ctaLink , filterImgAlt , filters , findStore , genuinePartsDealers , home , homeCenter , isNewTab , items , kohler , kohlerStore , kohlerStoreImgAlt , kohlerStores , loadMore , locationErrormessage , miles , mostPopular , myStore , partsDealer , readArticleText , results , retailMobileText , retailStore , setAsMyShowroom , setAsMyStore , showrooms , storeDetail , userMyLocation , view , viewList , viewMap , viewResults , viewShowroomDetails , viewStoreDetail , expanded , collapsed , filterTitle , MessageZipcode: messageZipcode , messageTitleZipcode: infoModalTitle , continue: continue_ , filterSort  } = (0,useFindashowroomi18n/* default */.Z)(data);
    const staticTexts = {
        all,
        annSacks,
        annSacksText,
        annsacksShowroom,
        annsacksShowroomImgAlt,
        applyFilters,
        ariaLabel,
        away,
        backToTop,
        browseAllStore,
        clearAll,
        countryPlaceholder,
        ctaLabel,
        ctaLink,
        filterImgAlt,
        filters,
        findStore,
        genuinePartsDealers,
        home,
        homeCenter,
        isNewTab,
        items,
        kohler,
        kohlerStore,
        kohlerStoreImgAlt,
        kohlerStores,
        loadMore,
        locationErrormessage,
        miles,
        mostPopular,
        myStore,
        partsDealer,
        readArticleText,
        results,
        retailMobileText,
        retailStore,
        setAsMyShowroom,
        setAsMyStore,
        showrooms,
        storeDetail,
        userMyLocation,
        view,
        viewList,
        viewMap,
        viewResults,
        viewShowroomDetails,
        viewStoreDetail,
        expanded,
        collapsed,
        filterTitle,
        messageZipcode,
        infoModalTitle,
        continue_,
        filterSort
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const findStoreDetailsUrl = get_default()(config, "general.storeDetailsServletPath", "");
            const reverseGeo = get_default()(config, "apiEndpoints.reverseGeo", "");
            const findStoresBingKey_ = get_default()(config, "apiEndpoints.findStoresBingKey", "");
            setFindStoresBingKey(findStoresBingKey_);
            const siteName = get_default()(config, "general.siteName", "");
            setFindaStoreQuery(get_default()(config, "general.findaStorequery", ""));
            const findStores_ = get_default()(config, "apiEndpoints.findStores", "");
            setFindStores(findStores_);
            setSiteName(siteName);
            const info = {
                locale: locale,
                currencySign: currencySign,
                currencyCode: currencyCode,
                findStores: findStores_,
                reverseGeo: reverseGeo,
                findStoresBingKey: findStoresBingKey,
                siteName: siteName,
                findStoreDetailsUrl
            };
            setInfo(info);
            (0,constants_api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: findStoreDetailsUrl
                }
            }).then((response)=>{
                if (response && response.data) {
                    setFindStoreDetails(response.data);
                }
            }).catch((err)=>{
                console.log("Failed to get compare attributes JSON file", err);
            });
        });
        fetchZipCodeFromUrl();
        changeTab(0);
    }, [
        findStores
    ]);
    (0,react.useEffect)(()=>{
        const tabList_ = [
            {
                tabDetail: "tabDetail1",
                title: tabTitleTab1,
                qryDetail: findStoreItemsTab1,
                key: kohlerStore,
                id: 0,
                icon: mapPinIconTab1 !== null && mapPinIconTab1 !== void 0 ? mapPinIconTab1 : locator_big_chacrol/* default */.Z,
                locationNote: tabTitleTab1,
                locationNoteMobile: kohler,
                inActive: inactiveTab1 !== null && inactiveTab1 !== void 0 ? inactiveTab1 : false
            },
            {
                tabDetail: "tabDetail2",
                title: tabTitleTab2,
                qryDetail: findStoreItemsTab2,
                key: showrooms,
                id: 1,
                icon: mapPinIconTab2 !== null && mapPinIconTab2 !== void 0 ? mapPinIconTab2 : locator_big_red/* default */.Z,
                locationNote: tabTitleTab2,
                locationNoteMobile: showrooms,
                inActive: inactiveTab2 !== null && inactiveTab2 !== void 0 ? inactiveTab2 : false
            },
            {
                tabDetail: "tabDetail3",
                title: tabTitleTab3,
                qryDetail: findStoreItemsTab3,
                key: genuinePartsDealers,
                id: 2,
                icon: mapPinIconTab3 !== null && mapPinIconTab3 !== void 0 ? mapPinIconTab3 : locator_big_green/* default */.Z,
                locationNote: tabTitleTab3,
                locationNoteMobile: genuinePartsDealers,
                inActive: inactiveTab3 !== null && inactiveTab3 !== void 0 ? inactiveTab3 : false
            }
        ];
        setTabList(tabList_);
    }, []);
    const setUrlParam = (keyword)=>{
        if (keyword) {
            const url = new URL(window.location.href);
            let searchParams = url.searchParams;
            searchParams.set("q", keyword);
            const urlSearch = "?" + searchParams.toString();
            window.history.replaceState(window.location.pathname, document.title, urlSearch);
        }
    };
    const changeTab = (tab)=>{
        setActiveTab(tab);
    };
    const callOnceNoRenderOnTabChange = (cb)=>{
        if (cb && onceRef.current) {
            onceRef.current = null;
            cb([], distanceInMiles, true, false, []);
        }
    };
    const finalIndividualQueries = [];
    finalIndividualQueries.push(...(0,helper/* findStoreBuildQuery */.ZAs)([
        findStoreItemsTab1,
        findStoreItemsTab2,
        findStoreItemsTab3
    ]));
    (0,react.useEffect)(()=>{
        const urlFilters = (0,helper/* getFacetsFromUrl */.bZU)();
        let urlQueryFilters = [];
        if (urlFilters.length > 0) {
            urlQueryFilters = [
                ...urlFilters.filter((urlFilter)=>urlFilter.facet !== "q")
            ];
            if (urlQueryFilters.length > 0) {
                var ref;
                Object.assign(urlQueryFilters[0], {
                    query: [
                        ...(ref = urlQueryFilters[0]) === null || ref === void 0 ? void 0 : ref.value
                    ]
                });
            }
        }
        setCurFilters(urlQueryFilters);
    }, []);
    const filterSelect = function(tabs, selectQuery, searchTerm) {
        let curFilters = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
        const activeTabs = tabs.filter((tab)=>!tab.inActive);
        const api = (index)=>constants_api/* apim.get */.TH.get(findStores, {
                params: {
                    $format: "json",
                    brand: siteName.toLowerCase(),
                    spatialFilter: "nearby('".concat(searchTerm, "',").concat(distanceInMiles, ")"),
                    $select: selectQuery,
                    $filter: (0,helper/* findStoreBuildQueryFromUrl */.$$z)(curFilters, constants.BOOLEAN_VALUE_RESPONSE) + finalIndividualQueries[index]
                }
            });
        return Promise.allSettled(activeTabs.map((aT)=>api(aT.id)));
    };
    const func = function() {
        let curFilters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], preventUnwantedDataLayer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, searchTerm = arguments.length > 2 ? arguments[2] : void 0, isAutoComplete = arguments.length > 3 ? arguments[3] : void 0, type = arguments.length > 4 ? arguments[4] : void 0;
        setResponseData([]);
        if (findStores) {
            if (searchTerm.length > 2) {
                filterSelect(tabList, findaStoreQuery, searchTerm, curFilters).then((responses)=>{
                    let totalResults = 0;
                    responses && (responses === null || responses === void 0 ? void 0 : responses.map((response, idx)=>{
                        var ref;
                        if (response.status === "fulfilled" && response.value && response.value.data) {
                            var ref1, ref2;
                            setResponseData((prevState)=>{
                                if (response.value.data.d.results.length > 0) {
                                    return [
                                        ...prevState,
                                        {
                                            [idx]: response.value.data.d.results
                                        }
                                    ];
                                } else return prevState;
                            });
                            setLatitude(response.value.data.d.results.length > 0 ? (ref1 = response.value.data.d.results[idx]) === null || ref1 === void 0 ? void 0 : ref1.Latitude : 0);
                            setLongitude(response.value.data.d.results.length > 0 ? (ref2 = response.value.data.d.results[idx]) === null || ref2 === void 0 ? void 0 : ref2.Longitude : 0);
                            setUrlParam(searchTerm);
                        }
                        if (response.status === "fulfilled" && response.value && response.value.data) {
                            const results = response.value.data.d.results.map((city)=>city.Locality);
                            var ref3;
                            setCitySuggestData((ref3 = [
                                ...new Set(results)
                            ]) !== null && ref3 !== void 0 ? ref3 : []);
                        }
                        totalResults += (response === null || response === void 0 ? void 0 : (ref = response.value) === null || ref === void 0 ? void 0 : ref.data.d.results.length) || 0;
                    }));
                    if (!preventUnwantedDataLayer) {
                        if (!isNaN(searchTerm)) {
                            addFindAStoreAnalytics({
                                status: "success",
                                total: totalResults,
                                type,
                                searchItem: searchTerm
                            });
                        } else {
                            addFindAStoreAnalytics({
                                status: "success",
                                total: totalResults,
                                type,
                                searchItem: searchTerm
                            });
                        }
                    }
                }).catch((err)=>{
                    console.error("Error occured while fetching Search data", err);
                });
            } else {
                if (!preventUnwantedDataLayer) {
                    addFindAStoreAnalytics({
                        status: type ? "failure" : "n/a",
                        total: 0,
                        type,
                        searchItem: searchTerm
                    });
                }
                setResponseData([]);
                setLatitude([]);
                setLongitude([]);
                setCitySuggestData([]);
            }
        }
    };
    const getStoreDetails = (0,react.useCallback)((0,helper/* debounce */.DsO)(func, 2000), [
        tabList,
        findStores
    ]);
    (0,react.useEffect)(()=>{
        getStoreDetails(curFilters, false, searchTerm);
        callOnceNoRenderOnTabChange((0,helper/* debounce */.DsO)(func, 3000));
    }, [
        searchTerm
    ]);
    let facets = {};
    if (findStoreFilterData) {
        facets = (0,helper/* storeFilterData */.TeW)(findStoreFilterData);
    }
    return tabList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Findashowroom_FindShowroomLanding, {
        infoModalError: infoModalError,
        infoModal: infoModal,
        InfoModal: ()=>setInfoModal(false),
        responseData: responseData,
        staticTexts: staticTexts,
        tabList: tabList,
        activeTab: activeTab,
        findStoresBingKey: findStoresBingKey,
        latitude: latitude,
        longitude: longitude,
        getStoreDetails: (curFilters, preventUnwantedDataLayer)=>getStoreDetails(curFilters, preventUnwantedDataLayer, searchTerm),
        handleChange: handleChange,
        searchTerm: searchTerm,
        citySuggestData: citySuggestData,
        changeTab: changeTab,
        findStoreDetails: findStoreDetails,
        handleFindStoreCheck: (entity)=>handleFindStoreCheck(entity),
        findStoreCheckedId: findStoreCheckedId,
        facets: facets,
        getGeoLocation: (type)=>getGeoLocation(type),
        selectedFilterCount: responseData ? (responseData === null || responseData === void 0 ? void 0 : responseData.length) > 0 && responseData.map((b)=>Object.values(b).flat().length).reduce((item, acc)=>acc + item, 0) : curFilterQueries && curFilterQueries.reduce((acc, item)=>{
            return acc + item.value.length;
        }, 0),
        totalResults: data && data.length
    });
};
/* harmony default export */ var Findashowroom = (FindShowroom);

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./store/features/inspirationSlice.js
var inspirationSlice = __webpack_require__(32665);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
// EXTERNAL MODULE: ./src/store/features/authSlice.js
var authSlice = __webpack_require__(2693);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var react_sticky_el_lib = __webpack_require__(75198);
var lib_default = /*#__PURE__*/__webpack_require__.n(react_sticky_el_lib);
// EXTERNAL MODULE: ./node_modules/react-lazy-load/dist/LazyLoad.js
var LazyLoad = __webpack_require__(25043);
// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./public/icons/print.svg
var print = __webpack_require__(30402);
// EXTERNAL MODULE: ./public/icons/share.svg
var share = __webpack_require__(66773);
// EXTERNAL MODULE: ./public/icons/close-filter.svg
var close_filter = __webpack_require__(8327);
// EXTERNAL MODULE: ./src/components/FriendsAndFamily/v1/friendsAndFamilyHelper.js
var friendsAndFamilyHelper = __webpack_require__(91960);
// EXTERNAL MODULE: ./components/SocialShare/v1/SocialShare.jsx + 1 modules
var SocialShare = __webpack_require__(24636);
// EXTERNAL MODULE: ./public/icons/search.svg
var search = __webpack_require__(83790);
;// CONCATENATED MODULE: ./components/InspirationLanding/analytics.js
const addDataLayer = (params)=>{
    var ref;
    const { title , productInfo =null , cart_ID =null , isOverlay =false , isFavorite =false , url =null , imageName =null , tileName =null , filterProps =null , resultLimit =null , searchProps =null , status =null , eventMsg =null  } = params;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const componentName = "".concat(page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.subCategoryID);
    const eventType = title === "add to compare" || title === "remove compare" ? "n/a" : "navigation";
    const productInfoJSON = productInfo && productInfo.length > 0 // analytics data for productInfo
     ? {
        productInfo: JSON.parse(productInfo)
    } : null;
    const filterArrayJSON = filterProps && filterProps.appliedFilters && filterProps.appliedFilters.length > 0 // analytics data for filters
     ? {
        filterArray: filterProps === null || filterProps === void 0 ? void 0 : filterProps.appliedFilters
    } : null;
    const searchResultsJSON = searchProps && (searchProps === null || searchProps === void 0 // analytics data for search input box
     ? void 0 : searchProps.isSearch) ? {
        searchTerm: searchProps === null || searchProps === void 0 ? void 0 : searchProps.searchTerm,
        searchResult: searchProps === null || searchProps === void 0 ? void 0 : searchProps.searchResult,
        searchCount: searchProps === null || searchProps === void 0 ? void 0 : searchProps.searchCount
    } : null;
    const image_Name = imageName ? imageName.replace(/-|_|--|__/g, " ") : "";
    cart_ID && (page.cart = {
        cartID: cart_ID
    });
    searchProps && searchProps.searchCount && sessionStorage.setItem("inspiration_searches", searchProps === null || searchProps === void 0 ? void 0 : searchProps.searchCount);
    let eventAction, internalLinkZoneName, internalLinkPosition, internalLinkName, internalLinkType, internalLinkURL;
    if (title === "inspiration image") {
        internalLinkName = image_Name;
        internalLinkURL = url && "".concat(url) || "n/a";
    } else if (title === "sample navigation") {
        internalLinkName = tileName;
        internalLinkZoneName = "".concat(componentName, ":").concat(isOverlay ? "inspiration detail overlay" : "inspiration image");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
        internalLinkType = "".concat(componentName, ":").concat(image_Name);
    } else if (isFavorite) {
        internalLinkZoneName = "".concat(componentName, ":").concat(isOverlay ? "inspiration detail overlay" : "inspiration image");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
        internalLinkType = "".concat(componentName, ":").concat(image_Name);
    } else if (title === "load more" || title === "back to top") {
        internalLinkType = "".concat(componentName, ":navigation");
    } else if (title === "bottom pagination") {
        internalLinkName = "view ".concat(resultLimit), internalLinkType = "".concat(componentName, ":pagination");
    } else if (filterProps === null || filterProps === void 0 ? void 0 : filterProps.isFilter) {
        internalLinkZoneName = "".concat(componentName, ":filters");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
        if (title === "accordion expand" || title === "accordion collapse") {
            internalLinkType = "".concat(componentName, ":").concat(filterProps === null || filterProps === void 0 ? void 0 : filterProps.facetName);
        } else if (title === "show filters" || title === "hide filters") {
            internalLinkType = "".concat(internalLinkZoneName);
        } else if (title === "filter canceled") {
            internalLinkName = "".concat(filterProps === null || filterProps === void 0 ? void 0 : filterProps.filterName, ":canceled");
            internalLinkType = "".concat(componentName, ":").concat(filterProps === null || filterProps === void 0 ? void 0 : filterProps.facetName);
        } else if (title === "view all" || title === "view less") {
            internalLinkType = "".concat(componentName, ":collection");
        } else if (title === "show more filters" || title === "show less filters") {
            internalLinkType = "".concat(internalLinkZoneName);
        } else if (title === "filter removed" || title === "filter applied") {
            const isRemoved = title === "filter removed" ? true : false;
            internalLinkName = "".concat(filterProps === null || filterProps === void 0 ? void 0 : filterProps.filterName, ":").concat(isRemoved ? "removed" : "applied");
            internalLinkType = "".concat(componentName, ":").concat(filterProps === null || filterProps === void 0 ? void 0 : filterProps.facetName);
        }
    } else if (searchProps === null || searchProps === void 0 ? void 0 : searchProps.isSearch) {
        internalLinkZoneName = "".concat(componentName, ":search box");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
    } else if (isOverlay) {
        internalLinkZoneName = "".concat(componentName, ":inspiration detail overlay");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
        internalLinkType = "".concat(componentName, ":").concat(image_Name);
        if (title === "custom order sample image") {
            internalLinkName = "".concat(image_Name);
            internalLinkType = "".concat(componentName, ":custom order sample");
            internalLinkURL = url && "".concat(url) || "n/a";
        }
    }
    const eventInfo = {
        eventAction: eventAction || "".concat(componentName, ":main content area:").concat(title),
        eventName: eventAction || "".concat(componentName, ":main content area:").concat(title),
        eventType: eventType,
        eventMsg: eventMsg || "n/a",
        eventStatus: status || "n/a",
        internalLinkName: internalLinkName || "".concat(title),
        internalLinkPosition: internalLinkPosition || "".concat(componentName),
        internalLinkType: internalLinkType || "".concat(componentName, ":").concat(title),
        internalLinkZoneName: internalLinkZoneName || "".concat(componentName, ":main content area"),
        internalLinkURL: internalLinkURL || url && "".concat(window.location.origin + url) || "n/a",
        clickInternalLinks: "true",
        ...searchResultsJSON,
        ...filterArrayJSON
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        ...productInfoJSON
    });
};
const getSocialAnalyticsData = (params)=>{
    var ref;
    const { title , isOverlay =false , isFilter =false , imageName =null  } = params;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const componentName = "".concat(page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.subCategoryID);
    const image_Name = imageName ? imageName.replace(/-|_|--|__/g, " ") : "";
    let eventAction, internalLinkType, internalLinkZoneName;
    if (isFilter) {
        internalLinkZoneName = "".concat(componentName, ":filters");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
        internalLinkType = "".concat(componentName, ":").concat(title);
    }
    const analyticsData = {
        eventAction: eventAction || "".concat(componentName, ":").concat(isOverlay ? "inspiration detail overlay" : "inspiration image", ":").concat(title),
        eventName: eventAction || "".concat(componentName, ":").concat(isOverlay ? "inspiration detail overlay" : "inspiration image", ":").concat(title),
        internalLinkPosition: "".concat(componentName),
        internalLinkType: internalLinkType || "".concat(componentName, ":").concat(image_Name),
        internalLinkZoneName: internalLinkZoneName || "".concat(componentName, ":").concat(isOverlay ? "inspiration detail overlay" : "inspiration image")
    };
    return JSON.stringify(analyticsData);
};

;// CONCATENATED MODULE: ./components/InspirationLanding/v1/Filter.jsx















const Filter_Filter = (props)=>{
    const [showMore, setShowMore] = (0,react.useState)(false);
    const [showAllCollection, setShowAllCollection] = (0,react.useState)({});
    const [collapse, setCollapse] = (0,react.useState)({});
    const [appliedFilters, setAppliedFilters] = (0,react.useState)([]);
    const plus = /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "plus",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line-1 line"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line line-2"
            })
        ]
    });
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    const [collectionFilterValue, setCollectionFilterValue] = (0,react.useState)({});
    const collectionSearchVal = (0,react.useRef)(0);
    const shareImg = (0,react.useRef)(null);
    const formatFacetName = (name, filter)=>{
        let val = name.replace(/\./g, "/").replace(/_/g, " ").replace(/^\*{2}/, "");
        if (filter) val += " - ".concat(filter);
        return val.toLowerCase();
    };
    (0,react.useEffect)(()=>{
        if (props.currFilters && props.currFilters.length > 0) {
            setAppliedFilters(props.currFilters);
        }
    }, [
        props.currFilters
    ]);
    //delete unwanted facets
    let filterList = props.facets;
    delete filterList["New_Products"];
    delete filterList["Available_Now"];
    delete filterList["**Products"];
    delete filterList["**Inspiration"];
    delete filterList["**Technical"];
    delete filterList["**Parts"];
    delete filterList["**Help"];
    delete filterList["**Resource"];
    const userGroup = [
        "ANY",
        "CTR",
        "FF",
        "GST",
        "KEMP",
        "KYS",
        "TPR",
        "TVS"
    ];
    userGroup.forEach((group)=>{
        delete filterList["".concat(group, "_Price_Range")];
    });
    if (props.hidePriceRange) {
        delete filterList["Price_Range"];
    } else if (filterList["Price_Range"]) {
        filterList = {
            Price_Range: filterList["Price_Range"],
            ...filterList
        };
    }
    let facets = Object.entries(filterList).filter((facet)=>facet[1].length > 0);
    const getAppliedFiltersForAnalytics = (appliedFilters)=>{
        let filterArray = [];
        appliedFilters.forEach((filter)=>{
            filter.display.forEach((filtervalue)=>{
                filterArray.push("".concat(formatFacetName(facetLabels[filter.facet]), ":").concat(filtervalue));
            });
        });
        return filterArray.length ? filterArray.join("|") : "";
    };
    const isSelected = (obj)=>{
        let facet = appliedFilters.find((filter)=>filter.facet === obj.facet);
        if (!facet) return false;
        return facet.display.includes(obj.display) ? true : false;
    };
    const handleFilter = function(checked, obj) {
        let needClearAllDataLayer = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        let curFilters = appliedFilters;
        let facet = curFilters.find((filter)=>filter.facet === obj.facet);
        if (checked) {
            if (facet) {
                facet.value.push(obj.value.replace(/"/g, '\\"'));
                facet.display.push(obj.display);
            } else curFilters.push({
                facet: obj.facet,
                value: [
                    obj.value.replace(/"/g, '\\"')
                ],
                display: [
                    obj.display
                ]
            });
        } else {
            let index = facet.display.indexOf(obj.display);
            facet.value.splice(index, 1);
            facet.display.splice(index, 1);
            if (!facet.value.length) {
                curFilters = curFilters.filter((f)=>f.facet !== obj.facet);
            }
        }
        setAppliedFilters([
            ...curFilters
        ]);
        props.addToUrl && setUrlParams(curFilters, needClearAllDataLayer);
        props.onFilter(curFilters);
        if (props.handleScroll) props.handleScroll();
    };
    const handleFilterCheckbox = (checked, obj, facet, filter)=>{
        handleFilter(checked, obj);
        addDataLayer({
            title: isSelected(obj) ? "filter applied" : "filter removed",
            cart_ID: props === null || props === void 0 ? void 0 : props.cartId,
            filterProps: {
                isFilter: true,
                appliedFilters: getAppliedFiltersForAnalytics(appliedFilters),
                facetName: facetLabels["".concat(facet)].toLowerCase(),
                filterName: filter.toLowerCase()
            }
        });
    };
    const setUrlParams = (filters, needClearAllDataLayer)=>{
        let query = "";
        if (filters.length > 0) {
            filters.forEach((filter, i)=>{
                let values = [
                    ...filter.value
                ];
                if (filter.value.indexOf(props.attributevalue) !== -1) {
                    let valueIndex = values.indexOf(props.attributevalue);
                    values.splice(valueIndex, 1);
                }
                if (values.length !== 0) query += "".concat(filter.facet, "=").concat(filter.facet === "Price_Range" ? filter.value : encodeURIComponent(values)).concat(i !== filters.length - 1 ? "&" : "");
            });
            window.history.replaceState(window.location.pathname, document.title, query.toString().length === 0 ? window.location.pathname : "?".concat(query.toString()));
            if (props.resetTitle) props.resetTitle();
        } else {
            clearAllFilters(needClearAllDataLayer);
        }
    };
    const handleCollapse = (facet, state)=>{
        addDataLayer({
            title: state ? "accordion expand" : "accordion collapse",
            cart_ID: props === null || props === void 0 ? void 0 : props.cartId,
            filterProps: {
                isFilter: true,
                facetName: facetLabels["".concat(facet)].toLowerCase()
            }
        });
        setCollapse({
            ...collapse,
            [facet]: state
        });
    };
    const clearAllFilters = function() {
        let needClearAllDataLayer = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        needClearAllDataLayer && addDataLayer({
            title: props.texts.clearAll.toLowerCase(),
            cart_ID: props === null || props === void 0 ? void 0 : props.cartId,
            filterProps: {
                isFilter: true
            }
        });
        setAppliedFilters([]);
        setCollectionFilterValue("");
        props.onFilter([]);
        window.history.replaceState({}, document.title, window.location.pathname);
        if (props.resetTitle) props.resetTitle();
    };
    const handleShowMore = ()=>{
        addDataLayer({
            title: (showMore ? props.texts.showLess : props.texts.showMore).toLowerCase(),
            cart_ID: props === null || props === void 0 ? void 0 : props.cartId,
            filterProps: {
                isFilter: true
            }
        });
        if (showMore) {
            const newCollapseState = {};
            facets.forEach((facet, i)=>{
                if (i > 4) newCollapseState[facet[0]] = false;
            });
            setCollapse({
                ...collapse,
                ...newCollapseState
            });
        }
        setShowMore(!showMore);
    };
    (0,react.useEffect)(()=>{
        if (showMore) {
            var ref, ref1, ref2;
            ((ref = document.getElementById("kf-filter-facets")) === null || ref === void 0 ? void 0 : ref.childNodes) && ((ref2 = (ref1 = document.getElementById("kf-filter-facets").childNodes[7]) === null || ref1 === void 0 ? void 0 : ref1.childNodes[0]) === null || ref2 === void 0 ? void 0 : ref2.focus());
        }
    }, [
        showMore
    ]);
    const formatPriceRange = (filter)=>{
        let values = filter.match(/\d+/g);
        return "$".concat(values[0], " - $").concat(values[1]);
    };
    (0,react.useEffect)(()=>{
        if (lib/* isMobile */.tq && !lib/* isTablet */.Em) {
            props.showFilter ? document.body.style.overflow = "hidden" : document.body.style.overflow = "visible";
        } else if (lib/* isTablet */.Em && !props.isLandscape) {
            props.showFilter ? document.body.style.overflow = "hidden" : document.body.style.overflow = "visible";
        }
    }, [
        props.showFilter
    ]);
    const filterChipsClearHandler = (facet, filter)=>{
        handleFilter(false, {
            facet: facet,
            display: filter
        }, false);
        addDataLayer({
            title: "filter canceled",
            cart_ID: props === null || props === void 0 ? void 0 : props.cartId,
            filterProps: {
                isFilter: true,
                facetName: facetLabels["".concat(facet)].toLowerCase(),
                filterName: filter.toLowerCase(),
                appliedFilters: getAppliedFiltersForAnalytics(appliedFilters)
            }
        });
    };
    const showAllCollectionHandler = (title, facetName)=>{
        addDataLayer({
            title: title.toLowerCase(),
            cart_ID: props === null || props === void 0 ? void 0 : props.cartId,
            filterProps: {
                isFilter: true
            }
        });
        setShowAllCollection({
            ...showAllCollection,
            [facetName]: !showAllCollection[facetName]
        });
    };
    const printHandler = ()=>{
        addDataLayer({
            title: props.texts.print.toLowerCase(),
            cart_ID: props === null || props === void 0 ? void 0 : props.cartId,
            filterProps: {
                isFilter: true
            }
        });
        window.print();
    };
    const handleChange = (event, facetName)=>{
        if (event.target.value === "") {
            setCollectionFilterValue({
                ...collectionFilterValue,
                [facetName]: ""
            });
            return;
        }
        if (event.target.value.length >= 2 || event.key === "Enter") {
            setCollectionFilterValue({
                ...collectionFilterValue,
                [facetName]: event.target.value
            });
        }
    };
    const handleSearch = (event, facetName, facetLabelNames)=>{
        event.target.placeholder = "Search ".concat(facetLabelNames && facetLabelNames[facetName]);
        if (event.target.value.length < 3) {
            setCollectionFilterValue({
                ...collectionFilterValue,
                [facetName]: event.target.value
            });
        }
    };
    const facetLabels = props.facetLabels;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("filter", !showMore && "filter--show-less"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "filter__inner-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inspiration-list__controls filter__mobile-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "inspiration-list__filter-toggle",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: filter/* default.src */.Z.src,
                                        className: "inspiration-list__filter-toggle-icon",
                                        role: "presentation",
                                        alt: "Toggle Filter"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            props.texts.filters,
                                            " ",
                                            props.selectedFilterCount > 0 && " (".concat(props.selectedFilterCount, ")")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: close_filter/* default.src */.Z.src,
                                className: "inspiration-list__close-icon",
                                alt: "Close Filter",
                                onClick: ()=>props.close(false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter__chips",
                        children: [
                            appliedFilters.map((facet)=>{
                                return facet.display.map((filter)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "filter__chips-tag",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    filter === "Yes" || filter === "No" ? formatFacetName(facet["facet"], filter) : filter
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: close_filter/* default.src */.Z.src,
                                                tabIndex: "0",
                                                role: "button",
                                                "aria-label": "Remove filter ".concat(filter === "Yes" || filter === "No" ? formatFacetName(facet["facet"], filter) : filter),
                                                className: "filter__chips-close-icon",
                                                onClick: ()=>filterChipsClearHandler(facet.facet, filter)
                                            })
                                        ]
                                    }, filter));
                            }),
                            appliedFilters.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "filter__chips-clear-all",
                                tabIndex: "0",
                                role: "button",
                                "aria-label": "".concat(props.texts.clearAll, " ").concat(props.texts.filters),
                                onClick: clearAllFilters,
                                children: props.texts.clearAll
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "kf-filter-facets",
                        children: facets.map((facet)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)((dist_default()), {
                                role: "group",
                                tabIndex: "0",
                                open: collapse[facet[0]],
                                onTriggerOpening: ()=>handleCollapse(facet[0], true),
                                onTriggerClosing: ()=>handleCollapse(facet[0], false),
                                openedClassName: "is-open",
                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: facetLabels && facetLabels["".concat(facet[0])].toUpperCase()
                                        }),
                                        " ",
                                        plus
                                    ]
                                }),
                                transitionTime: 400,
                                easing: "ease-in-out",
                                children: facet[1].map((filter, i, arr)=>{
                                    if (i % 2 === 0) {
                                        var ref, ref1;
                                        let displayText = null;
                                        if (facet[0] === "Price_Range") {
                                            displayText = formatPriceRange(filter);
                                        }
                                        if (facet[0] === "Color_Family" || facet[0] === "colorList_ss") {
                                            displayText = filter.split("|")[0];
                                        }
                                        if (!filter.toLowerCase().includes((collectionFilterValue === null || collectionFilterValue === void 0 ? void 0 : (ref = collectionFilterValue[facet[0]]) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "")) {
                                            if (i === 0) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "inputWithIcon",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "text",
                                                                id: "search-collections",
                                                                name: "search-collections",
                                                                className: "form__input search-collections",
                                                                onKeyUp: (e)=>handleChange(e, facet[0]),
                                                                onBlur: (e)=>handleSearch(e, facet[0], facetLabels),
                                                                placeholder: "Search ".concat(facetLabels && facetLabels["".concat(facet[0])]),
                                                                onFocus: (e)=>e.target.placeholder = "",
                                                                ref: collectionSearchVal
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                role: "presentation",
                                                                className: "search-icon",
                                                                src: search/* default.src */.Z.src,
                                                                alt: "search-icon"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: close_filter/* default.src */.Z.src,
                                                                className: "search-collections__close-icon",
                                                                alt: "Close Filter",
                                                                onClick: ()=>{
                                                                    setCollectionFilterValue({
                                                                        ...collectionFilterValue,
                                                                        [facet[0]]: ""
                                                                    });
                                                                    collectionSearchVal.current.value = "";
                                                                }
                                                            })
                                                        ]
                                                    })
                                                });
                                            }
                                            return;
                                        }
                                        if (i > 10 && !showAllCollection[facet[0]] && !filter.toLowerCase().includes((collectionFilterValue === null || collectionFilterValue === void 0 ? void 0 : (ref1 = collectionFilterValue[facet[0]]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || null)) {
                                            if (i > 12) {
                                                return;
                                            }
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "filter__show-more",
                                                onClick: ()=>{
                                                    showAllCollectionHandler(props.texts.viewAll, facet[0]);
                                                },
                                                children: props.texts.viewAll
                                            });
                                        }
                                        let obj = {
                                            facet: facet[0],
                                            value: filter,
                                            display: displayText !== null && displayText !== void 0 ? displayText : filter
                                        };
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                i === 0 && arr.length > 11 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "inputWithIcon",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            id: "search-collections",
                                                            name: "search-collections",
                                                            className: "form__input search-collections",
                                                            onKeyUp: (e)=>handleChange(e, facet[0]),
                                                            onBlur: (e)=>handleSearch(e, facet[0], facetLabels),
                                                            placeholder: "Search ".concat(facetLabels && facetLabels["".concat(facet[0])]),
                                                            onFocus: (e)=>e.target.placeholder = "",
                                                            ref: collectionSearchVal
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            role: "presentation",
                                                            className: "search-icon",
                                                            src: search/* default.src */.Z.src,
                                                            alt: "search-icon"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: close_filter/* default.src */.Z.src,
                                                            className: "search-collections__close-icon",
                                                            alt: "Close Filter",
                                                            onClick: ()=>{
                                                                setCollectionFilterValue({
                                                                    ...collectionFilterValue,
                                                                    [facet[0]]: ""
                                                                });
                                                            // collectionSearchVal.current.value = ""
                                                            },
                                                            tabIndex: 0
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                    id: facet[0] + filter,
                                                    checkBoxAria: "".concat(obj.display, " (").concat(arr[i + 1], ")"),
                                                    tabIndex: collapse[facet[0]] ? 0 : -1,
                                                    value: "".concat(obj.display, " (").concat(arr[i + 1], ")"),
                                                    onChange: (e)=>handleFilterCheckbox(e.target.checked, obj, facet[0], filter),
                                                    checked: isSelected(obj),
                                                    swatch: facet[0] === "Color.Finish" || facet[0] === "Color" || facet[0] === "Finish" || facet[0] === "Color_Family" || facet[0] === "colorList_ss" ? props.colors[filter] : null
                                                }, filter),
                                                showAllCollection[facet[0]] && i === facet[1].length - 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "filter__show-more",
                                                    onClick: ()=>{
                                                        showAllCollectionHandler(props.texts.viewLess, facet[0]);
                                                    },
                                                    children: props.texts.viewLess
                                                })
                                            ]
                                        });
                                    }
                                })
                            }, facet);
                        })
                    }),
                    facets.length > 7 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "filter__show-more",
                        onClick: handleShowMore,
                        children: showMore ? props.texts.showLess : props.texts.showMore
                    }) : "",
                    props.discontinuedCheck && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "filter__hide-discontinued",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                id: "discontinued",
                                onChange: (e)=>handleFilter(e.target.checked, {
                                        facet: "Available_Now",
                                        value: "true",
                                        display: "Discontinued"
                                    }),
                                checked: isSelected({
                                    facet: "Available_Now",
                                    value: "true",
                                    display: "Discontinued"
                                }),
                                value: props.texts.hideDiscontinued
                            })
                        })
                    }),
                    props.page !== "article" && !props.isCurated && (props.buyingGuideDescription || props.buyingGuideLink || props.buyingGuideFieldLabel) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter__buying-guide d-none d-sm-none d-md-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: (0,friendsAndFamilyHelper/* entityToCharacter */.F)(props.buyingGuideDescription)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: (0,helper/* getShortenedUrl */.Ppy)(props.buyingGuideLink),
                                target: props.newTab && "_blank",
                                children: props.buyingGuideFieldLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter__print-and-share",
                        children: [
                            (props.displayPrint !== undefined ? props.displayPrint : true) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                role: "button",
                                onClick: printHandler,
                                tabIndex: "0",
                                "aria-label": props.texts.print,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: print/* default.src */.Z.src,
                                        alt: props.texts.print,
                                        role: "presentation"
                                    }),
                                    props.texts.print
                                ]
                            }),
                            props.displayShare && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                role: "button",
                                onClick: ()=>setShowSocialLink(!showSocialLink),
                                ref: shareImg,
                                tabIndex: "0",
                                "aria-label": props.texts.share,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: share/* default.src */.Z.src,
                                        alt: props.texts.share,
                                        role: "presentation"
                                    }),
                                    props.texts.share
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                        showModal: showSocialLink,
                        id: "kf-plp-filter",
                        onClose: ()=>{
                            setShowSocialLink(false);
                            shareImg === null || shareImg === void 0 ? void 0 : shareImg.current.focus();
                        },
                        shareBtn: shareImg,
                        analyticData: JSON.parse(getSocialAnalyticsData({
                            title: props.texts.share.toLowerCase(),
                            isFilter: true
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "filter__footer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: classnames_default()("filter__apply", appliedFilters.length > 0 && "filter__apply--active"),
                        disabled: appliedFilters.length < 1,
                        onClick: ()=>props.close(false),
                        children: props.selectedFilterCount > 0 ? "".concat(props.texts.view, " ").concat(props.texts.results, " (").concat(props.totalResults, ")") : props.texts.viewResults
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter__buying-guide d-block d-sm-block d-md-none",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: props.buyingGuideDescription
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: (0,helper/* getShortenedUrl */.Ppy)(props.buyingGuideLink),
                                target: props.newTab && "_blank",
                                children: props.buyingGuideFieldLabel
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v1_Filter = (Filter_Filter);

// EXTERNAL MODULE: ./public/icons/wish.svg
var wish = __webpack_require__(29875);
// EXTERNAL MODULE: ./public/icons/wishlist-gray-filled.svg
var wishlist_gray_filled = __webpack_require__(62084);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(5702);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var dist_es = __webpack_require__(67421);
// EXTERNAL MODULE: ./src/components/sharedCart/shareCartHelper.js
var shareCartHelper = __webpack_require__(88611);
;// CONCATENATED MODULE: ./components/InspirationLanding/v1/ProductTile.jsx



//import _get from 'lodash/get'









//import _isEmpty from 'lodash/isEmpty';






const ProductTile = (param)=>{
    let { data , lite , loading , staticTexts , displayShare , displayPrint , isModalShow , setIsModalShow , onInspirationSelect , getVarientProductInfo , ...props } = param;
    var ref, ref1, ref2;
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const { isAuth , access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const isFavorite = ((ref = props.favorites) === null || ref === void 0 ? void 0 : ref.find((vl)=>vl.name["en-US"] === data.id)) ? true : false;
    const [showShare, setShowShare] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const CONFIG = (0,constants_config/* getConfig */.i)();
    const shareImg = (0,react.useRef)(null);
    const [inspirationUrl, setinspirationUrl] = (0,react.useState)("");
    const [onHover, setOnHover] = (0,react.useState)(false);
    const [width] = (0,useWindowResize/* default */.Z)();
    const [general, setGeneral] = (0,react.useState)();
    const { toaster ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const imageName = data.url_s.split("/")[6];
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const { general  } = await (0,constants_config/* getConfig */.i)();
            setinspirationUrl(general === null || general === void 0 ? void 0 : general.inspirationDetailPath);
            setGeneral(general);
        };
        configFn();
    }, []);
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "inspiration-landing-tile--loading",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-image shimmer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-title shimmer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-description shimmer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "loading-swatch",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    })
                ]
            })
        ]
    });
    const handleCallBack = ()=>{
        var ref;
        addDataLayer({
            title: isFavorite ? "remove favorite" : "add favorite",
            imageName: "".concat(imageName.toLowerCase()),
            isFavorite: true,
            cart_ID: props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : ref.id
        });
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.loginFavouriteCallback = ()=>{
            setLoginFavouriteCallback(e);
        };
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const handleFavorite = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.preActiveElement = e.target;
        if (isFavorite === true) {
            var ref;
            (ref = props.favorites) === null || ref === void 0 ? void 0 : ref.map((fav)=>{
                if (fav.name["en-US"] === data.id) {
                    if (!isAuth) {
                        handleLogin(e);
                    } else {
                        dispatch((0,favoritesSlice/* removeItems */.Er)({
                            ids: [
                                fav.id
                            ],
                            isDataLayerNeeded: false
                        })).unwrap().then(()=>{
                            var ref;
                            handleCallBack();
                            dispatch((0,genericSlice/* showToast */.CF)({
                                message: (0,helper/* getShortenedUrlwithGeneral */.vu1)(toaster === null || toaster === void 0 ? void 0 : (ref = toaster.content) === null || ref === void 0 ? void 0 : ref.unfavoriteSuccessMessage, general) || (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.removeItem),
                                isVisible: true
                            }));
                        }).catch((err)=>{
                            dispatch((0,genericSlice/* showToast */.CF)({
                                message: staticTexts.removeItemError,
                                isVisible: true
                            }));
                            handleCallBack();
                        });
                    }
                }
            });
        } else {
            if (!isAuth) {
                handleLogin(e);
            } else {
                const payload = {
                    type: "image",
                    name: data === null || data === void 0 ? void 0 : data.id,
                    url: data === null || data === void 0 ? void 0 : data.url_s
                };
                dispatch((0,favoritesSlice/* addMedia */.rA)(payload)).unwrap().then(()=>{
                    var ref;
                    handleCallBack();
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: (0,helper/* getShortenedUrlwithGeneral */.vu1)(toaster === null || toaster === void 0 ? void 0 : (ref = toaster.content) === null || ref === void 0 ? void 0 : ref.successMessage, general) || staticTexts.favSuccessMsg,
                        isVisible: true
                    }));
                }).catch((err)=>{
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: staticTexts.favErrorMsg,
                        isVisible: true
                    }));
                    handleCallBack();
                });
            }
        }
    };
    const handleShare = (e)=>{
        e.preventDefault();
        setShowShare(true);
    };
    const showProductModal = (showVal)=>{
        var ref;
        addDataLayer({
            title: !showVal ? "inspiration image" : "close",
            url: !showVal ? "".concat(data.url_s).replace(" ", "%20") : null,
            imageName: "".concat(imageName.toLowerCase()),
            isOverlay: showVal ? true : null,
            cart_ID: props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : ref.id
        });
        onInspirationSelect(data);
    };
    const onClickVarientItem = async (varient, key)=>{
        let sku, category, slug, tileUrl, pageRedirectUrl;
        let varientData = varient && varient.split("|");
        if (varientData && varientData.length >= 3) {
            sku = varientData[0];
            category = varientData[1];
            slug = varientData[2];
            tileUrl = await (0,helper/* getPDPUrl */.ir5)(category, slug).then((res)=>res);
            pageRedirectUrl = "".concat(tileUrl).concat(sku ? "?skuId=" + sku : "");
            location.href = decodeURIComponent(pageRedirectUrl);
        }
        (data === null || data === void 0 ? void 0 : data.ProductMappingSKUID_s) && (0,shareCartHelper/* getProductsBySku */.uX)((data === null || data === void 0 ? void 0 : data.ProductMappingSKUID_s).split(",").map((x)=>x.trim())).then((vdata)=>{
            var ref, ref1;
            addDataLayer({
                title: "sample navigation",
                url: "".concat(decodeURIComponent(pageRedirectUrl)),
                tileName: (ref = vdata[key]) === null || ref === void 0 ? void 0 : ref.name["en-US"].toLowerCase(),
                imageName: "".concat(imageName.toLowerCase()),
                productInfo: getVarientProductInfo(vdata[key]),
                cart_ID: props === null || props === void 0 ? void 0 : (ref1 = props.cart) === null || ref1 === void 0 ? void 0 : ref1.id
            });
        });
    };
    const setHover = ()=>{
        document.getElementById("inspiration-landing-tile__wrapper_".concat(data.id)).classList.add("--hover");
        setOnHover(true);
    };
    const removeHover = ()=>{
        document.getElementById("inspiration-landing-tile__wrapper_".concat(data.id)).classList.remove("--hover");
        setOnHover(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inspiration-landing-tile__wrapper",
            onMouseLeave: ()=>setShowShare(false),
            onFocus: setHover,
            onBlur: removeHover,
            id: "inspiration-landing-tile__wrapper_".concat(data.id),
            tabIndex: 0,
            children: [
                displayShare && /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                    showModal: showShare,
                    id: "kf-product-detail",
                    onClose: ()=>{
                        setShowShare(false);
                        shareImg === null || shareImg === void 0 ? void 0 : shareImg.current.focus();
                    },
                    shareBtn: shareImg,
                    url: "".concat(window.location.origin).concat(inspirationUrl, "?q=").concat(data === null || data === void 0 ? void 0 : data.id),
                    analyticData: JSON.parse(getSocialAnalyticsData({
                        title: staticTexts.share.toLowerCase(),
                        imageName: imageName
                    }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()({
                        "inspiration-landing-tile": true,
                        "inspiration-landing-tile--lite": lite
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inspiration-landing-tile__share",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "inspiration-landing-tile__share-icon",
                                    onClick: handleFavorite,
                                    "aria-hidden": width > 1024 ? onHover ? false : true : false,
                                    tabIndex: "0",
                                    "aria-label": staticTexts.wishlist,
                                    role: "button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: isFavorite ? wishlist_gray_filled/* default.src */.Z.src : wish/* default.src */.Z.src,
                                        alt: staticTexts.wishlist,
                                        role: "presentation"
                                    })
                                }),
                                displayShare && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "inspiration-landing-tile__share-icon inspiration-landing-tile__shareicon",
                                    ref: shareImg,
                                    onClick: handleShare,
                                    tabIndex: "0",
                                    "aria-label": staticTexts.share,
                                    "aria-hidden": width > 1024 ? onHover ? false : true : false,
                                    role: "button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: share/* default.src */.Z.src,
                                        alt: staticTexts.share,
                                        role: "presentation"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: ()=>{
                                showProductModal(isModalShow);
                            },
                            className: "inspiration-landing-tile__image",
                            "aria-label": data === null || data === void 0 ? void 0 : data.title_s,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inspiration-landing-tile__image",
                                tabIndex: "-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    onError: (e)=>e.target.src = image_missing/* default.src */.Z.src,
                                    src: data.url_s,
                                    className: "inspiration-landing-tile__image--hover",
                                    alt: data.url_s
                                }, data.id)
                            })
                        }),
                        (data === null || data === void 0 ? void 0 : (ref1 = data.productDetailsList_ss) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inspiration-landing-tile__varient-list",
                            children: data === null || data === void 0 ? void 0 : (ref2 = data.productDetailsList_ss) === null || ref2 === void 0 ? void 0 : ref2.slice(0, 4).map((product, key)=>{
                                if (key === 3) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inspiration-landing-tile__image__varient-loadmore",
                                        children: "+".concat((data === null || data === void 0 ? void 0 : data.productDetailsList_ss.length) - 3, " more products")
                                    }, key);
                                } else {
                                    var ref, ref1;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inspiration-landing-tile__image__varient",
                                        onClick: ()=>{
                                            onClickVarientItem(data.productDetailsList_ss[key], key);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            onError: (e)=>{
                                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                            },
                                            src: (data === null || data === void 0 ? void 0 : data.productImagesList_ss) ? ((ref1 = (ref = data.productImagesList_ss[key]) === null || ref === void 0 ? void 0 : ref.split("|")) === null || ref1 === void 0 ? void 0 : ref1.pop()) || image_missing/* default */.Z : image_missing/* default */.Z,
                                            className: "inspiration-landing-tile__image__varient-image",
                                            alt: "No Image"
                                        }, key)
                                    }, key);
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_ProductTile = (ProductTile);

;// CONCATENATED MODULE: ./components/InspirationLanding/v1/ProductsPerPage.jsx


const ProductsPerPage = (param)=>{
    let { data =[] , texts , onChange , totalResults , curRows =30 , addDataLayer , cartId =null  } = param;
    const limitOnChangeHandler = (limit)=>{
        addDataLayer({
            title: "bottom pagination",
            resultLimit: "".concat(limit),
            cart_ID: cartId
        });
        onChange(limit);
    };
    const viewAllItemsHandler = (totalResults)=>{
        addDataLayer({
            title: "bottom pagination",
            resultLimit: "".concat(texts.all.toLowerCase()),
            cart_ID: cartId
        });
        onChange(totalResults);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "products-per-page",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            role: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "disabled",
                    "aria-hidden": true,
                    children: texts.view
                }),
                data.map((limit, i, arr)=>{
                    if (i === 0 || totalResults > limit || totalResults < limit && totalResults > arr[i - 1]) return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        "aria-disabled": curRows == limit,
                        role: "button",
                        tabIndex: "0",
                        "aria-label": "".concat(texts.view, " ").concat(limit, " ").concat(texts.items),
                        className: curRows == limit && "disabled",
                        onClick: ()=>limitOnChangeHandler(limit),
                        children: limit
                    }, i);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    role: "button",
                    tabIndex: "0",
                    "aria-label": "".concat(texts.view, " ").concat(texts.all, " ").concat(texts.items),
                    className: curRows == totalResults && "disabled",
                    onClick: ()=>viewAllItemsHandler(totalResults),
                    children: texts.all
                })
            ]
        })
    });
};
/* harmony default export */ var v1_ProductsPerPage = (ProductsPerPage);

// EXTERNAL MODULE: ./public/icons/back-top-arrow.svg
var back_top_arrow = __webpack_require__(12522);
// EXTERNAL MODULE: ./public/icons/column-off.svg
var column_off = __webpack_require__(4419);
// EXTERNAL MODULE: ./public/icons/column-on.svg
var column_on = __webpack_require__(84923);
// EXTERNAL MODULE: ./public/icons/grid-off.svg
var grid_off = __webpack_require__(8909);
// EXTERNAL MODULE: ./public/icons/grid-on.svg
var grid_on = __webpack_require__(7520);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./src/hooks/useSmartCrop.js
var useSmartCrop = __webpack_require__(83839);
// EXTERNAL MODULE: ./src/components/core/SmartCropImage/index.jsx
var SmartCropImage = __webpack_require__(97729);
;// CONCATENATED MODULE: ./components/InspirationDetail/v1/InspirationDetail.view/index.jsx











// import { addToCart } from "@Store/actions"













const InspirationDetailView = (param)=>{
    let { selectedInspiration , productData , staticTexts , i18n , componentProps , sku , ...props } = param;
    var ref, ref1;
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    const [displayPrint, setDisplayPrint] = (0,react.useState)(false);
    const [displayShare, setDisplayShare] = (0,react.useState)(false);
    const [brandName, setBrandName] = (0,react.useState)("");
    const [currencySign, setCurrencySign] = (0,react.useState)("");
    const [inspirationUrl, setInspirationUrl] = (0,react.useState)("");
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    const [shortendPagePath, setShortendPagePath] = (0,react.useState)("");
    const { isAuth , access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { toaster ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [general, setGeneral] = (0,react.useState)();
    const shareImg = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (CONFIG)=>{
            var ref, ref1;
            var ref2;
            setBrandName((ref2 = CONFIG === null || CONFIG === void 0 ? void 0 : (ref = CONFIG.general) === null || ref === void 0 ? void 0 : ref.siteName.toLowerCase()) !== null && ref2 !== void 0 ? ref2 : "");
            setInspirationUrl(CONFIG === null || CONFIG === void 0 ? void 0 : CONFIG.general.inspirationDetailPath);
            setCurrencySign(get_default()(CONFIG, "internationalization.currencySign", ""));
            setGeneral(CONFIG === null || CONFIG === void 0 ? void 0 : CONFIG.general);
            (0,helper/* getShortenedUrl */.Ppy)(get_default()(CONFIG, "general.cartLandingPagePath", "")).then((ret)=>{
                setCartUrl(ret);
            });
            setShortendPagePath(CONFIG === null || CONFIG === void 0 ? void 0 : (ref1 = CONFIG.general) === null || ref1 === void 0 ? void 0 : ref1.shortendPagePath);
        });
    }, []);
    const shortendcustomCtaLink = componentProps === null || componentProps === void 0 ? void 0 : componentProps.customCtaLink.replace(shortendPagePath, "");
    const shortendreplaceAddToCartCtaLink = (componentProps === null || componentProps === void 0 ? void 0 : (ref = componentProps.replaceAddToCartCtaLink) === null || ref === void 0 ? void 0 : ref.replace(shortendPagePath, "")) || "";
    const dispatch = (0,es/* useDispatch */.I0)();
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const [toasters, setToaster] = (0,react.useState)({
        show: false,
        message: "",
        isError: false
    });
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { isOverlay =false  } = props;
    const imageName = selectedInspiration.url_s.split("/")[6];
    const isFavorite = ((ref1 = props.favorites) === null || ref1 === void 0 ? void 0 : ref1.find((vl)=>vl.name["en-US"] === selectedInspiration.id)) ? true : false;
    const { customerGroup ="" , fallbackCustomerGroup =""  } = (0,helper/* getCustomerGroup */.CIf)();
    const [pdpNavigationURL, setPdpNavigationURL] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const isDisplaySharePrint = ()=>{
            var ref;
            const el = (ref = document.querySelector("[data-component='InspirationDetail']")) !== null && ref !== void 0 ? ref : "";
            if (el) {
                var ref1;
                const staticText = JSON === null || JSON === void 0 ? void 0 : JSON.parse(el === null || el === void 0 ? void 0 : (ref1 = el.dataset) === null || ref1 === void 0 ? void 0 : ref1.staticText);
                setDisplayShare(staticText.enableFavorite === "true" ? true : false);
                setDisplayPrint(staticText.enablePrint === "true" ? true : false);
            }
        };
        isDisplaySharePrint();
    }, []);
    (0,react.useEffect)(()=>{
        async function fetchPDPUrls() {
            for (const product of productData){
                const imageVariant = sku.includes(product.masterVariant.sku) ? product.masterVariant : product.variants.filter((item)=>sku.includes(item.sku))[0];
                if (imageVariant && imageVariant.attributes.length !== 0) {
                    let ProdCatgory = "";
                    imageVariant.attributes.forEach((value)=>{
                        if (value.name === "ProductLocalCategory") {
                            ProdCatgory = value.value;
                        }
                    });
                    await (0,helper/* getPDPUrl */.ir5)(ProdCatgory, product.slug["en-US"]).then((res)=>setPdpNavigationURL(res));
                }
            }
        }
        fetchPDPUrls();
    }, [
        productData,
        sku
    ]);
    const printPDP = ()=>{
        var ref;
        let printNoteLen = document.getElementsByClassName("product-details__print-note").length;
        if (printNoteLen === 0) {
            const printNote = "<div class='product-details__print-note'><div class='container'><div class='row'><div class='col-12'><h6>".concat(staticTexts.priceFootnoteTitle, "</h6><p>").concat(staticTexts.priceFootnote, "</p><h6>").concat(staticTexts.colorFootnoteTitle, "</h6> <p>").concat(staticTexts.colorFootnote, "</p></div></div></div></div>");
            let printNoteDiv = document.createElement("div");
            printNoteDiv.innerHTML = printNote;
            document.body.appendChild(printNoteDiv);
        }
        addDataLayer({
            title: staticTexts.print.toLowerCase(),
            imageName: "".concat(imageName.toLowerCase()),
            isOverlay: isOverlay,
            cart_ID: props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : ref.id
        });
        window.print();
    };
    const addToCart = async (product)=>{
        var ref;
        const quantity = 1;
        const result = await props.addToCart([
            {
                sku: product.masterVariant.sku,
                quantity: quantity,
                isBundle: false,
                brand: brandName
            }
        ], false, null, null, true);
        showToaster(result.message, result.status);
        addDataLayer({
            title: componentProps === null || componentProps === void 0 ? void 0 : componentProps.ctaLabel.toLowerCase(),
            imageName: "".concat(imageName.toLowerCase()),
            isOverlay: isOverlay,
            productInfo: props === null || props === void 0 ? void 0 : props.getVarientProductInfo(product),
            cart_ID: props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : ref.id
        });
    };
    const showToaster = (message, status)=>{
        if (status == 200 || status == 201) {
            setToaster({
                ...toasters,
                show: true,
                message,
                isError: false
            });
        } else {
            setToaster({
                ...toasters,
                show: true,
                message,
                isError: true
            });
        }
        setTimeout(()=>setToaster({
                ...toasters,
                show: false,
                message: "",
                isError: false
            }), 3000);
    };
    const handleCallBack = ()=>{
        var ref;
        addDataLayer({
            title: isFavorite ? "remove favorite" : "add favorite",
            imageName: "".concat(imageName.toLowerCase()),
            isFavorite: true,
            isOverlay: isOverlay,
            cart_ID: props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : ref.id
        });
    };
    const customOrderClickHandler = (text)=>{
        var ref;
        addDataLayer({
            title: text ? text : staticTexts.customOrderContactUs.toLowerCase(),
            imageName: "".concat(imageName.toLowerCase()),
            isOverlay: isOverlay,
            url: text ? shortendreplaceAddToCartCtaLink : "".concat(componentProps === null || componentProps === void 0 ? void 0 : componentProps.customCtaLink),
            cart_ID: props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : ref.id
        });
    };
    const sampleCardClickHandler = (url, data)=>{
        var ref;
        addDataLayer({
            title: "sample navigation",
            imageName: "".concat(imageName.toLowerCase()),
            isOverlay: isOverlay,
            tileName: data.name["en-US"].toLowerCase(),
            url: "".concat(url),
            productInfo: props === null || props === void 0 ? void 0 : props.getVarientProductInfo(data),
            cart_ID: props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : ref.id
        });
    };
    const customOrderImageClickHandler = (url)=>{
        var ref;
        addDataLayer({
            title: "custom order sample image",
            imageName: "".concat(imageName.toLowerCase()),
            isOverlay: isOverlay,
            url: "".concat(url),
            cart_ID: props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : ref.id
        });
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.loginFavouriteCallback = ()=>{
            setLoginFavouriteCallback(e);
        };
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const handleFavorite = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (isFavorite === true) {
            var ref;
            (ref = props.favorites) === null || ref === void 0 ? void 0 : ref.map((fav)=>{
                if (fav.name["en-US"] === selectedInspiration.id) {
                    if (!isAuth) {
                        handleLogin(e);
                    } else {
                        dispatch((0,favoritesSlice/* removeItems */.Er)({
                            ids: [
                                fav.id
                            ],
                            isDataLayerNeeded: false
                        })).unwrap().then(()=>{
                            var ref;
                            handleCallBack();
                            dispatch((0,genericSlice/* showToast */.CF)({
                                message: (0,helper/* getShortenedUrlwithGeneral */.vu1)(toaster === null || toaster === void 0 ? void 0 : (ref = toaster.content) === null || ref === void 0 ? void 0 : ref.unfavoriteSuccessMessage, general) || (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.removeItem),
                                isVisible: true
                            }));
                        }).catch((err)=>{
                            dispatch((0,genericSlice/* showToast */.CF)({
                                message: staticTexts.removeItemError,
                                isVisible: true
                            }));
                            handleCallBack();
                        });
                    }
                }
            });
        } else {
            if (!isAuth) {
                handleLogin(e);
            } else {
                const payload = {
                    type: "image",
                    name: selectedInspiration === null || selectedInspiration === void 0 ? void 0 : selectedInspiration.id,
                    url: selectedInspiration === null || selectedInspiration === void 0 ? void 0 : selectedInspiration.url_s
                };
                dispatch((0,favoritesSlice/* addMedia */.rA)(payload)).unwrap().then(()=>{
                    var ref;
                    handleCallBack();
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: (0,helper/* getShortenedUrlwithGeneral */.vu1)(toaster === null || toaster === void 0 ? void 0 : (ref = toaster.content) === null || ref === void 0 ? void 0 : ref.successMessage, general) || staticTexts.favSuccessMsg,
                        isVisible: true
                    }));
                }).catch((err)=>{
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: staticTexts.favErrorMsg,
                        isVisible: true
                    }));
                    handleCallBack();
                });
            }
        }
    };
    let itemCountMessage = "".concat(1, " ").concat(t("kf.pdp.label.itemAdded"), " ");
    let addTocartFailureMessage = "".concat(1, " ").concat(t("kf.pdp.label.itemAddedFailed"), " ");
    const ToasterMssg = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                toasters.isError ? addTocartFailureMessage : itemCountMessage,
                toasters.isError == false && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: cartUrl,
                            children: t("kf.pdp.label.yourCart")
                        }),
                        "."
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "inspiration-detail",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-lg-7 col-md-6 col-sm-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inspiration-detail__gallery",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "inspiration-detail-tile",
                                    children: [
                                        (componentProps === null || componentProps === void 0 ? void 0 : componentProps.enableFavorite) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inspiration-detail-tile__share",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "inspiration-detail-tile__share-icon",
                                                onClick: handleFavorite,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: isFavorite ? wishlist_gray_filled/* default.src */.Z.src : wish/* default.src */.Z.src,
                                                    alt: staticTexts.wishlist
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inspiration-detail-tile__image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "inspiration-detail-tile__image gbh-data-layer",
                                                "data-gbh-data-layer": '{"eventAction":"inspiration landing navigation","eventName":"inspiration landing navigation","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + selectedInspiration.id + '","internalLinkPosition":"inspiration","internalLinkType":"inspiration:navigation","internalLinkZoneName":"inspiration:promo tiles","clickInternalLinks":"true","frequency":"n/a","productColor":"n/a","productCoupondiscount":"n/a","productID":""}',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                                                    url: selectedInspiration["url_s"],
                                                    altText: selectedInspiration["title_s"] || "",
                                                    smartCrop: smartCrop
                                                }, selectedInspiration["thumbnailImageURL_s"])
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "print-share",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "print-and-share",
                                        children: [
                                            displayPrint && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "print-button",
                                                tabIndex: "0",
                                                role: "button",
                                                onClick: ()=>printPDP(),
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "print-image",
                                                        src: print/* default.src */.Z.src,
                                                        alt: staticTexts.print
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        "aria-hidden": "true",
                                                        tabIndex: "-1",
                                                        children: [
                                                            staticTexts.print,
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            }),
                                            displayShare && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "share-button",
                                                onClick: ()=>setShowSocialLink(!showSocialLink),
                                                ref: shareImg,
                                                tabIndex: "0",
                                                role: "button",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "share-image",
                                                        src: share/* default.src */.Z.src,
                                                        alt: staticTexts.share
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        "aria-hidden": "true",
                                                        tabIndex: "-1",
                                                        children: staticTexts.share
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                                                        showModal: showSocialLink,
                                                        id: "kf-product-detail",
                                                        onClose: ()=>{
                                                            setShowSocialLink(false);
                                                            shareImg === null || shareImg === void 0 ? void 0 : shareImg.current.focus();
                                                        },
                                                        shareBtn: shareImg,
                                                        url: "".concat(window.location.origin).concat(inspirationUrl, "?q=").concat(selectedInspiration === null || selectedInspiration === void 0 ? void 0 : selectedInspiration.id),
                                                        analyticData: JSON.parse(getSocialAnalyticsData({
                                                            title: staticTexts.share.toLowerCase(),
                                                            isOverlay: isOverlay,
                                                            imageName: imageName
                                                        }))
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-lg-5 col-md-6 col-sm-6 product-details__content-section print-overview-right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inspiration-detail__cart",
                            children: [
                                productData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "order-sample__heading",
                                    children: componentProps === null || componentProps === void 0 ? void 0 : componentProps.sectionLabel
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "order-sample__body",
                                    children: productData.map((product, key)=>{
                                        let imageVariant = sku.includes(product.masterVariant.sku) ? product.masterVariant : product.variants.filter((item)=>sku.includes(item.sku))[0];
                                        const priceData = (0,helper/* getAsPrice */.mkK)([
                                            imageVariant
                                        ], [
                                            "stand-alone-price",
                                            "prices"
                                        ], customerGroup, fallbackCustomerGroup);
                                        const finalPrice = (0,helper/* getAsFinalPrice */.OIu)(priceData[imageVariant.sku], true) ? (0,helper/* getAsFinalPrice */.OIu)(priceData[imageVariant.sku], true) : (0,helper/* getAsFinalPrice */.OIu)(priceData[imageVariant.sku], null);
                                        if (imageVariant && imageVariant.attributes.length !== 0) {
                                            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                                            let displayName = imageVariant.attributes.filter((value)=>{
                                                if (value.name === "ProductBrandNameDisplay") {
                                                    return value.value;
                                                }
                                            });
                                            let ProdDesc = imageVariant.attributes.filter((value)=>{
                                                if (value.name === "ProductDescriptionProductShort") {
                                                    return value.value["en-US"];
                                                }
                                            });
                                            let ProdCatgory = "";
                                            imageVariant.attributes.filter((value)=>{
                                                if (value.name === "ProductLocalCategory") {
                                                    ProdCatgory = value.value;
                                                }
                                            });
                                            let isSample = (ProdCatgory === null || ProdCatgory === void 0 ? void 0 : ProdCatgory.toLowerCase()) === "samples";
                                            var ref7, ref8;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "order-sample__card",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "".concat(pdpNavigationURL, "?skuId=").concat(imageVariant.sku),
                                                        rel: "noopener noreferrer",
                                                        onClick: ()=>sampleCardClickHandler(pdpNavigationURL, product),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            onError: (e)=>e.target.src = image_missing/* default */.Z,
                                                            src: ((ref = imageVariant.images[0]) === null || ref === void 0 ? void 0 : ref.url) || image_missing/* default.src */.Z.src,
                                                            className: "order-sample__image",
                                                            alt: (ref8 = (ref7 = (ref1 = displayName[0]) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref7 !== void 0 ? ref7 : (ref2 = ProdDesc[0]) === null || ref2 === void 0 ? void 0 : ref2.value["en-US"]) !== null && ref8 !== void 0 ? ref8 : ""
                                                        }, product.id)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "order-sample__name",
                                                        children: displayName ? (ref3 = displayName[0]) === null || ref3 === void 0 ? void 0 : ref3.value : ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "order-sample__description",
                                                        children: ProdDesc ? (ref4 = ProdDesc[0]) === null || ref4 === void 0 ? void 0 : ref4.value["en-US"] : ""
                                                    }),
                                                    !isSample && finalPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "order-sample__price",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                            value: finalPrice ? finalPrice : 0,
                                                            displayType: "text",
                                                            thousandSeparator: true,
                                                            prefix: currencySign,
                                                            decimalScale: 2,
                                                            fixedDecimalScale: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            (componentProps === null || componentProps === void 0 ? void 0 : componentProps.disableEcommerce) && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.replaceAddToCart) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: shortendreplaceAddToCartCtaLink,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    className: "kf-react-button button small secondary order-sample__button",
                                                                    size: "small",
                                                                    label: componentProps === null || componentProps === void 0 ? void 0 : componentProps.replaceAddToCartCtaLabel,
                                                                    target: (componentProps === null || componentProps === void 0 ? void 0 : componentProps.ecomLinkNewTab) ? "_blank" : "_self",
                                                                    onClick: ()=>{
                                                                        return customOrderClickHandler(componentProps === null || componentProps === void 0 ? void 0 : componentProps.replaceAddToCartCtaLabel);
                                                                    },
                                                                    children: componentProps === null || componentProps === void 0 ? void 0 : componentProps.replaceAddToCartCtaLabel
                                                                })
                                                            }),
                                                            !(componentProps === null || componentProps === void 0 ? void 0 : componentProps.disableEcommerce) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                disabled: !(imageVariant === null || imageVariant === void 0 ? void 0 : (ref5 = imageVariant.availability) === null || ref5 === void 0 ? void 0 : ref5.channels[Object.keys(imageVariant === null || imageVariant === void 0 ? void 0 : (ref6 = imageVariant.availability) === null || ref6 === void 0 ? void 0 : ref6.channels)[0]].isOnStock),
                                                                className: "order-sample__button",
                                                                onClick: ()=>addToCart(product),
                                                                children: componentProps === null || componentProps === void 0 ? void 0 : componentProps.ctaLabel
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, key);
                                        }
                                    })
                                }),
                                selectedInspiration.customSampleProductName_s && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "order-sample__heading",
                                            children: [
                                                " ",
                                                componentProps === null || componentProps === void 0 ? void 0 : componentProps.customSectionLabel
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "order-sample__body",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "order-sample__card",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-tile__badge",
                                                        children: !isEmpty_default()(selectedInspiration.badge_s) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "product-tile__new",
                                                            children: selectedInspiration.badge_s
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: selectedInspiration.url_s,
                                                        rel: "noopener noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            onError: (e)=>e.target.src = image_missing/* default */.Z,
                                                            src: (selectedInspiration === null || selectedInspiration === void 0 ? void 0 : selectedInspiration.url_s) || image_missing/* default.src */.Z.src,
                                                            className: "order-sample__image",
                                                            alt: selectedInspiration.title_s,
                                                            onClick: ()=>customOrderImageClickHandler(selectedInspiration.url_s)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "order-sample__name",
                                                        children: [
                                                            " ",
                                                            selectedInspiration.customSampleProductName_s
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "order-sample__name",
                                                        children: selectedInspiration.title_s
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "order-sample__description",
                                                        children: selectedInspiration.description_s
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: shortendcustomCtaLink,
                                                            rel: "noopener noreferrer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "order-sample__button",
                                                                onClick: ()=>customOrderClickHandler(null),
                                                                children: staticTexts.customOrderContactUs
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var InspirationDetail_view = (InspirationDetailView);

;// CONCATENATED MODULE: ./components/InspirationDetail/v1/InspirationDetail/index.jsx











const InspirationDetail = (props)=>{
    var ref, ref1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const [productData, setProductData] = (0,react.useState)([]);
    const [selectedInspiration, setSelectedInspiration] = (0,react.useState)({});
    const [authComponentProps, setAuthComponentProps] = (0,react.useState)(props.authorData);
    const [curFilterQueries, setCurFilterQueries] = (0,react.useState)(null);
    const [start, setStart] = (0,react.useState)(0);
    const [rows, setRows] = (0,react.useState)(10) // Example default value
    ;
    const [selectedSort, setSelectedSort] = (0,react.useState)(null);
    const { inspirations , favorites , cart  } = (0,es/* useSelector */.v9)((state)=>state);
    const { selectedInspiration: selectedInspirationState  } = (inspirations === null || inspirations === void 0 ? void 0 : inspirations.inspirations) || {};
    const detailsPageSelectedInspiration = (selectedInspirationState === null || selectedInspirationState === void 0 ? void 0 : (ref = selectedInspirationState.data) === null || ref === void 0 ? void 0 : ref[0]) || {};
    var ref2;
    const favoritesState = (ref2 = favorites === null || favorites === void 0 ? void 0 : (ref1 = favorites.favorites) === null || ref1 === void 0 ? void 0 : ref1.textLineItems) !== null && ref2 !== void 0 ? ref2 : [];
    const cartState = cart === null || cart === void 0 ? void 0 : cart.cart;
    const getComponentProp = ()=>{
        var ref;
        const el = (ref = document.querySelector("[data-component='InspirationDetail']")) !== null && ref !== void 0 ? ref : "";
        if (el) {
            var ref1;
            const staticText = JSON === null || JSON === void 0 ? void 0 : JSON.parse(el === null || el === void 0 ? void 0 : (ref1 = el.dataset) === null || ref1 === void 0 ? void 0 : ref1.staticText);
            setAuthComponentProps(staticText);
        }
    };
    (0,react.useEffect)(()=>{
        const fetchProductData = async ()=>{
            if (props.selectedInspiration && props.selectedInspiration.ProductMappingSKUID_s) {
                const productData = await (0,shareCartHelper/* getProductsBySku */.uX)(props.selectedInspiration.ProductMappingSKUID_s.split(",").map((x)=>x.trim()));
                setSelectedInspiration(props.selectedInspiration);
                setProductData(productData);
            } else {
                getInspirationItem();
            }
        };
        if (isEmpty_default()(props.authorData)) {
            getComponentProp();
        }
        fetchProductData();
    }, [
        props.selectedInspiration,
        props.authorData
    ]);
    (0,react.useEffect)(()=>{
        const fetchProductData = async ()=>{
            if (selectedInspirationState && selectedInspirationState.data && selectedInspirationState.data.length > 0 && selectedInspirationState.data[0].ProductMappingSKUID_s && !selectedInspiration.id) {
                const productData = await (0,shareCartHelper/* getProductsBySku */.uX)(selectedInspirationState.data[0].ProductMappingSKUID_s.split(",").map((x)=>x.trim()));
                setSelectedInspiration(selectedInspirationState === null || selectedInspirationState === void 0 ? void 0 : selectedInspirationState.data[0]);
                setProductData(productData);
            }
        };
        fetchProductData();
    }, [
        selectedInspirationState,
        detailsPageSelectedInspiration.id
    ]);
    const getInspirationItem = (queries, update)=>{
        let newStart = 0;
        //save queries to handle sorting
        if (queries) {
            setCurFilterQueries(queries);
        } else {
            queries = curFilterQueries;
            newStart = start;
        }
        // let pathName = window.location.pathname
        // const splittedPath = pathName?.split("/")
        // const last = splittedPath[splittedPath.length - 1]
        // const pathId = last?.replace(".html", "")
        const { query: { q  }  } = router;
        const pathId = q;
        let fq = [];
        fq.push('id:("'.concat(pathId, '")'));
        let query = {
            fq,
            rows,
            start: newStart
        };
        if (selectedSort) query.sort = selectedSort;
        dispatch((0,inspirationSlice/* getInspirationDetails */.w4)({
            query,
            update,
            isSingle: true
        }));
    };
    const i18n = {
        photoCredits: "Photo Credit : ",
        orderASample: "Order a Sample",
        addToCart: "Add to Cart"
    };
    const staticTexts = (0,react.useMemo)(()=>({
            print: t("kf.plp.label.print"),
            share: t("kf.plp.label.share"),
            favTxt: t("kf.pdp.label.favTxt"),
            favSuccessMsg: t("kf.favorites.success"),
            favErrorMsg: t("kf.favorites.error"),
            removeItem: t("kf.favorites.removeItem"),
            removeItemError: t("kf.favorites.removeItemError"),
            itemsAdded: t("kf.pdp.label.itemAdded"),
            customOrderContactUs: t("annsacks.customOrderSample.label.contactUsBtn")
        }), []);
    // if (
    //   typeof props.isModalShow === "undefined" &&
    //   !window.location.pathname.includes("inspiration-detail")
    // ) {
    //   return null
    // }
    if ((props === null || props === void 0 ? void 0 : props.isDetailsPage) && !detailsPageSelectedInspiration.id || !(props === null || props === void 0 ? void 0 : props.isDetailsPage) && !selectedInspiration.id) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "inspiration-detail-before-load",
            children: "Loading ..."
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationDetail_view, {
            selectedInspiration: (props === null || props === void 0 ? void 0 : props.isDetailsPage) ? detailsPageSelectedInspiration : selectedInspiration,
            productData: productData,
            favorites: favoritesState,
            staticTexts: staticTexts,
            addToCart: ()=>{},
            i18n: i18n,
            componentProps: authComponentProps,
            sku: (props === null || props === void 0 ? void 0 : props.isDetailsPage) ? detailsPageSelectedInspiration.ProductMappingSKUID_s.split(",").map((x)=>x.trim()) : selectedInspiration.ProductMappingSKUID_s.split(",").map((x)=>x.trim()),
            isOverlay: props.isOverlay,
            getVarientProductInfo: props === null || props === void 0 ? void 0 : props.getVarientProductInfo,
            cart: cartState
        });
    }
};
/* harmony default export */ var v1_InspirationDetail = (InspirationDetail);

// EXTERNAL MODULE: ./src/utils/cart.js
var cart = __webpack_require__(87292);
;// CONCATENATED MODULE: ./components/InspirationLanding/v1/InspirationLandingList.view.jsx






// import Sort from "./Sort"











//import { getSwatchCount } from "@Globals/js/helper";










const InspirationLandingList = (props)=>{
    var ref, ref1, ref2, ref3, ref4;
    const [width] = (0,useWindowResize/* default */.Z)();
    const isGainsboroBg = (props === null || props === void 0 ? void 0 : props.bgColor) === "bg-gainsboro" ? true : false;
    const { isLandscape , selectedFilterCount , facets , facetLabels  } = props;
    const [showFilter, setShowFilter] = (0,react.useState)(props === null || props === void 0 ? void 0 : props.enableFilter);
    const [navSticky, setNavSticky] = (0,react.useState)(false);
    const [isModalShow, setIsModalShow] = (0,react.useState)(false);
    const [currentScrollPosition, setCurrentScrollPosition] = (0,react.useState)(0);
    const [selectedInspiration, setSelectedInspiration] = (0,react.useState)(null);
    // const [showInspirationModal, setShowInspirationModal] = useState(false);
    // const [selectedInspiration, setSelectedInspiration] = useState(null);
    const [filterValue, setFilterValue] = (0,react.useState)("");
    const [rowCols, setRowCols] = (0,react.useState)(width < 1024 ? 1 : 3);
    const [scrollPosition, setScrollPosition] = (0,react.useState)(0);
    const [isDataAvailable, setIsDataAvailable] = (0,react.useState)(false);
    const filterClass = classnames_default()({
        "inspiration-list__filter": true,
        "inspiration-list__filter--hide": width < 1024 && lib/* isMobile */.tq ? lib/* isTablet */.Em ? !showFilter : false : !showFilter,
        "inspiration-list__filter--modal": showFilter
    });
    const filterButtonClass = classnames_default()({
        "inspiration-list__filter-toggle-text": true,
        "inspiration-list__filter-toggle-text--show": !showFilter
    });
    const tileClass = classnames_default()({
        "inspiration-list__tile-col": true,
        "inspiration-list__tile-col--full-width": !showFilter
    });
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    // let width = window.innerWidth
    const searchVal = (0,react.useRef)(0);
    const [brandName, setBrandName] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        var ref;
        document === null || document === void 0 ? void 0 : document.querySelector("title").setAttribute("aria-label", props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.pageTitleAria);
        setShowFilter(!lib/* isMobile */.tq);
    }, []);
    //BackToTop button focus to breadcrumb for ADA
    const handleKeyUp = (event)=>{
        if (event.keyCode === 13) {
            setTimeout(()=>{
                const inactiveBread = document.querySelector(".cmp-breadcrumb__item-link");
                if (inactiveBread) {
                    inactiveBread.focus();
                }
            }, 100);
        }
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("keyup", handleKeyUp);
        return ()=>{
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    (0,react.useEffect)(()=>{
        lib/* isTablet */.Em ? window.outerWidth >= 1024 ? setRowCols(3) : setRowCols(2) : lib/* isMobile */.tq && width < 1024 ? isLandscape ? setRowCols(2) : setRowCols(2) : setRowCols(3);
    }, [
        isLandscape
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if (props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.length) {
            setIsDataAvailable(false);
        } else {
            setIsDataAvailable(true);
        }
    }, [
        props === null || props === void 0 ? void 0 : props.data
    ]);
    const getAvailableStock = async (sku)=>{
        let stock = 0;
        try {
            stock = await (0,cart/* getStock */.K5)(sku);
        } catch (err) {
            console.error("Error | getStock | getAvailablesStock | ProductDetails | ", err);
        }
        return stock;
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (CONFIG)=>{
            var ref;
            var ref1;
            setBrandName((ref1 = CONFIG === null || CONFIG === void 0 ? void 0 : (ref = CONFIG.general) === null || ref === void 0 ? void 0 : ref.siteName.toLowerCase()) !== null && ref1 !== void 0 ? ref1 : "");
        });
    }, []);
    const getVarientProductInfo = (obj)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
        const inStock = getAvailableStock(obj.masterVariant.sku);
        var ref17;
        const productInfo = {
            description: obj.description["en-US"],
            frequency: "n/a",
            globalPromotionPrice: parseFloat((((ref = obj.masterVariant.prices[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.discounted) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.centAmount) || ((ref3 = obj.masterVariant.prices[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : ref4.centAmount)) / 100).toFixed(2),
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            priceState: "regular price",
            productBasePrice: parseFloat(((ref5 = obj.masterVariant.prices[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.value) === null || ref6 === void 0 ? void 0 : ref6.centAmount) / 100).toFixed(2),
            productCategory: obj.masterVariant.attributes.filter((items)=>items.name === "ProductLocalCategory").map((item)=>{
                return item.value;
            })[0] || "n/a",
            productColor: obj.masterVariant.attributes.filter((items)=>items.name === "SKUColorFinishName").map((item)=>{
                return item.value["en-US"];
            })[0] || "n/a",
            productCoupondiscount: 0,
            productCouponCode: "n/a",
            productID: obj.masterVariant.sku,
            productName: obj.name["en-US"],
            productPartnerBuyNow: false,
            productRoom: obj.metaTitle["en-US"].split("|")[0].trim(),
            productSalePrice: parseFloat((((ref7 = obj.masterVariant.prices[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.discounted) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.value) === null || ref9 === void 0 ? void 0 : ref9.centAmount) || ((ref10 = obj.masterVariant.prices[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.value) === null || ref11 === void 0 ? void 0 : ref11.centAmount)) / 100).toFixed(2),
            productSaleable: true,
            productStatus: inStock > 0 ? "in stock" : "out of stock",
            productSuperSku: false,
            productTileName: obj.name["en-US"],
            quantity: 1,
            defaultImageName: ((ref13 = (ref12 = obj.masterVariant) === null || ref12 === void 0 ? void 0 : ref12.images[0]) === null || ref13 === void 0 ? void 0 : ref13.url) || "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: "regular finished Goods",
            productFindingMethod: "n/a",
            productCollectionsName: obj.masterVariant.attributes.filter((items)=>items.name === "ProductBrandName").map((item)=>{
                return item.value;
            })[0] || "n/a",
            productBrand: brandName,
            globalOffer: "n/a",
            globalDiscount: (ref17 = (ref14 = obj.masterVariant.prices[0]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.discounted) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.value) === null || ref16 === void 0 ? void 0 : ref16.centAmount) !== null && ref17 !== void 0 ? ref17 : 0,
            itemType: "product"
        };
        return JSON.stringify(productInfo);
    };
    //calculate promo position
    // const col =
    //   window.outerWidth < 1024
    //     ? {
    //       "one-column": "col-12",
    //       "two-column": "col-12",
    //       "three-column": "col-12",
    //     }
    //     : {
    //       "one-column": "col",
    //       "two-column": "col-8",
    //       "three-column": "col-12",
    //     };
    //const colVal = { "one-column": 1, "two-column": 2, "three-column": 3 };
    // const row = isMobile
    //   ? props?.promoPlacementMobile
    //   : props?.promoPlacementDesktop;
    // const position = (isMobile && window.outerWidth < 1024)
    //   ? rowCols === 1
    //     ? row - 1
    //     : row * rowCols - 2
    //   : row * rowCols - colVal[props?.promoLayout];
    const plpDisplayName = (props === null || props === void 0 ? void 0 : props.urlTitle) ? props === null || props === void 0 ? void 0 : props.urlTitle : props === null || props === void 0 ? void 0 : props.plpDisplayName;
    const executeScroll = ()=>{
        modules/* scroller.scrollTo */.OK.scrollTo("products-tab", {
            duration: 1500,
            delay: 0,
            smooth: "easeInOutQuart"
        });
    };
    const loadMoreClickHandler = ()=>{
        var ref;
        props === null || props === void 0 ? void 0 : props.onLoadMore();
        addDataLayer({
            title: props === null || props === void 0 ? void 0 : props.staticTexts.loadMore.toLowerCase(),
            cart_ID: props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : ref.id
        });
    };
    const onInspirationSelect = (data)=>{
        setSelectedInspiration(data);
        setIsModalShow(true);
        document.body.classList.add("body-scroll-disable");
    };
    const closeModal = (data)=>{
        document.body.classList.remove("body-scroll-disable");
        setIsModalShow(false);
    };
    const backToTopClickHandler = ()=>{
        var ref;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        addDataLayer({
            title: props === null || props === void 0 ? void 0 : props.staticTexts.backToTop.toLowerCase(),
            cart_ID: props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : ref.id
        });
    };
    const handleChange = (event)=>{
        if (event.target.value.length === 0) {
            setFilterValue("");
            props === null || props === void 0 ? void 0 : props.onFilter(null, false, "", addDataLayer);
        }
        if (event.target.value.length > 2 || event.key === "Enter") {
            setFilterValue(event.target.value);
            props === null || props === void 0 ? void 0 : props.onFilter(null, false, event.target.value, addDataLayer);
        }
    };
    const handleSearch = (event)=>{
        if (filterValue !== event.target.value && event.target.value.length < 3) {
            props === null || props === void 0 ? void 0 : props.onFilter(null, false, event.target.value);
        }
        setFilterValue(event.target.value);
        searchVal.current.placeholder = "Search Design Inspiration";
    };
    const removeSearch = ()=>{
        setFilterValue("");
        props === null || props === void 0 ? void 0 : props.onFilter(null, false, "");
        searchVal.current.value = "";
    };
    const onbeforeprint = ()=>{
        forceVisible();
    };
    const filterToogleHandler = ()=>{
        var ref;
        addDataLayer({
            title: showFilter ? "hide filters" : "show filters",
            cart_ID: props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : ref.id,
            filterProps: {
                isFilter: true
            }
        });
        setShowFilter(!showFilter);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "inspiration-landing",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inspiration-list",
            children: [
                !(props === null || props === void 0 ? void 0 : props.isCurated) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("container kf-react-container inspiration-list__header", isGainsboroBg && "inspiration-list--gainsboro"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inspiration-list__title-info col-lg-12 col-xs-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    role: "heading",
                                    tabIndex: "0",
                                    "aria-label": plpDisplayName,
                                    className: "inspiration-list__title",
                                    children: plpDisplayName
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row d-block d-lg-none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "inspiration-list__grid-control",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            "aria-label": props === null || props === void 0 ? void 0 : props.staticTexts.totalResults,
                                            className: "inspiration-list__total",
                                            tabIndex: "0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-block d-sm-none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    onClick: ()=>setRowCols(1),
                                                    className: "inspiration-list__grid-control-icon",
                                                    src: rowCols > 1 ? column_off/* default */.Z : column_on/* default */.Z,
                                                    alt: "Column View"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    onClick: ()=>setRowCols(2),
                                                    className: "inspiration-list__grid-control-icon",
                                                    src: rowCols > 1 ? grid_on/* default */.Z : grid_off/* default */.Z,
                                                    alt: "Grid View"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                (props === null || props === void 0 ? void 0 : props.isCurated) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container kf-react-container inspiration-list__header inspiration-list__curated",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-8 col-xs-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    "aria-label": props === null || props === void 0 ? void 0 : props.staticTexts.totalResults,
                                    className: "inspiration-list__total d-none d-lg-block",
                                    tabIndex: "0",
                                    children: [
                                        props === null || props === void 0 ? void 0 : props.totalResults,
                                        " ",
                                        props === null || props === void 0 ? void 0 : props.staticTexts.results
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row d-block d-lg-none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "inspiration-list__grid-control",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            "aria-label": props === null || props === void 0 ? void 0 : props.staticTexts.totalResults,
                                            className: "inspiration-list__total",
                                            children: [
                                                props === null || props === void 0 ? void 0 : props.totalResults,
                                                " ",
                                                props === null || props === void 0 ? void 0 : props.staticTexts.results
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-block d-sm-none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    onClick: ()=>setRowCols(1),
                                                    className: "inspiration-list__grid-control-icon",
                                                    src: rowCols > 1 ? column_off/* default */.Z : column_on/* default */.Z,
                                                    alt: "Column View"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    onClick: ()=>setRowCols(2),
                                                    className: "inspiration-list__grid-control-icon",
                                                    src: rowCols > 1 ? grid_on/* default */.Z : grid_off/* default */.Z,
                                                    alt: "Grid View"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                    onFixedToggle: ()=>setNavSticky(!navSticky),
                    className: "inspiration-list__sticky-nav-wrap",
                    stickyStyle: {
                        zIndex: 9
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container-fluid inspiration-list__sticky-nav ".concat(navSticky && "inspiration-list__sticky-nav--shadow"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container kf-react-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "inspiration-list__total",
                                                children: [
                                                    !(props === null || props === void 0 ? void 0 : props.loading) && (props === null || props === void 0 ? void 0 : props.data.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "textItem",
                                                        children: [
                                                            props === null || props === void 0 ? void 0 : props.totalResults,
                                                            " ",
                                                            props === null || props === void 0 ? void 0 : props.staticTexts.items
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "inputWithIcon",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "text",
                                                                id: "search",
                                                                name: "search",
                                                                className: "form__input search",
                                                                onKeyUp: handleChange,
                                                                onBlur: handleSearch,
                                                                placeholder: "Search Design Inspiration",
                                                                onFocus: (e)=>e.target.placeholder = "",
                                                                ref: searchVal
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                className: "search-icon",
                                                                src: search/* default */.Z,
                                                                alt: "search-icon"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (props === null || props === void 0 ? void 0 : props.data) && (props === null || props === void 0 ? void 0 : props.data.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "inspiration-list__controls",
                                                children: [
                                                    facets && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        tabIndex: "-1",
                                                        className: "inspiration-list__filter-toggle",
                                                        onClick: filterToogleHandler,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: filter/* default */.Z === null || filter/* default */.Z === void 0 ? void 0 : filter/* default.src */.Z.src,
                                                                className: "inspiration-list__filter-toggle-icon",
                                                                alt: "Toggle Filter"
                                                            }),
                                                            lib/* isMobile */.tq && !isLandscape && !lib/* isTablet */.Em ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    props === null || props === void 0 ? void 0 : props.staticTexts.showFilter,
                                                                    " ",
                                                                    selectedFilterCount > 0 && " (".concat(selectedFilterCount, ")")
                                                                ]
                                                            }) : lib/* isMobile */.tq && isLandscape && !lib/* isTablet */.Em && width < 1024 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    props === null || props === void 0 ? void 0 : props.staticTexts.showFilter,
                                                                    " ",
                                                                    selectedFilterCount > 0 && " (".concat(selectedFilterCount, ")")
                                                                ]
                                                            }) : lib/* isMobile */.tq && !isLandscape && lib/* isTablet */.Em && width < 1024 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    props === null || props === void 0 ? void 0 : props.staticTexts.showFilter,
                                                                    " ",
                                                                    selectedFilterCount > 0 && " (".concat(selectedFilterCount, ")")
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                tabIndex: "0",
                                                                "aria-labelledby": showFilter ? "Hide the filters" : "Show the filters",
                                                                className: filterButtonClass,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        className: showFilter ? "show" : "hide",
                                                                        children: props === null || props === void 0 ? void 0 : props.staticTexts.hideFilter
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        className: !showFilter ? "show" : "hide",
                                                                        children: props === null || props === void 0 ? void 0 : props.staticTexts.showFilter
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                                        className: "sorting-section"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                }),
                (props === null || props === void 0 ? void 0 : props.loading) && ((props === null || props === void 0 ? void 0 : props.data) === null || (props === null || props === void 0 ? void 0 : props.data.length) === 0) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container kf-react-container inspiration-list__tiles",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "inspiration-list__not-found",
                                    children: props === null || props === void 0 ? void 0 : props.i18n.loading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "inspiration-list__try-other",
                                    children: props === null || props === void 0 ? void 0 : props.i18n.pleaseWait
                                })
                            ]
                        })
                    })
                }) : (props === null || props === void 0 ? void 0 : props.data) && (props === null || props === void 0 ? void 0 : props.data.length) === 0 && isDataAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container kf-react-container inspiration-list__tiles",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: filterValue !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "inspiration-list__not-found",
                                    children: props === null || props === void 0 ? void 0 : props.i18n.matchNotFound
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "inspiration-list__try-other",
                                    children: props === null || props === void 0 ? void 0 : props.i18n.otherCombination
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inspiration-list__not-found",
                                children: props === null || props === void 0 ? void 0 : props.i18n.noDataFound
                            })
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container kf-react-container inspiration-list__tiles",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inspiration-landing-main",
                                children: [
                                    isModalShow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "inspiration-modal-display-block",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "inspiration-modal__closeImg",
                                                onClick: ()=>closeModal(),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: icons_close/* default.src */.Z.src
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_InspirationDetail, {
                                                selectedInspiration: selectedInspiration,
                                                displayShare: (props === null || props === void 0 ? void 0 : props.displayShare) ? true : false,
                                                displayPrint: (props === null || props === void 0 ? void 0 : props.displayPrint) ? true : false,
                                                isModalShow: isModalShow,
                                                isOverlay: true,
                                                cart: props === null || props === void 0 ? void 0 : props.cart,
                                                getVarientProductInfo: getVarientProductInfo
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: filterClass,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inspiration-list__filter--sticky ".concat((props === null || props === void 0 ? void 0 : props.isCurated) ? " inspiration-list__filter-curated" : ""),
                                            children: (props === null || props === void 0 ? void 0 : props.data) && (props === null || props === void 0 ? void 0 : props.data.length) > 0 && facets && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Filter, {
                                                tabIndex: "0",
                                                texts: props === null || props === void 0 ? void 0 : props.staticTexts,
                                                ...props,
                                                facetLabels: facetLabels,
                                                close: setShowFilter,
                                                displayShare: (props === null || props === void 0 ? void 0 : props.displayShare) === "true" ? true : false,
                                                displayPrint: (props === null || props === void 0 ? void 0 : props.displayPrint) === "true" ? true : false,
                                                selectedFilterCount: selectedFilterCount,
                                                handleScroll: executeScroll,
                                                showFilter: showFilter,
                                                addToUrl: true,
                                                removeSearch: removeSearch,
                                                cartId: props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : ref.id,
                                                getVarientProductInfo: getVarientProductInfo
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: tileClass,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row row-cols-".concat(rowCols),
                                                children: (props === null || props === void 0 ? void 0 : props.data) && (props === null || props === void 0 ? void 0 : props.data.length) > 0 && (props === null || props === void 0 ? void 0 : (ref1 = props.data) === null || ref1 === void 0 ? void 0 : ref1.map((product, i)=>{
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col inspiration-list__tile",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductTile, {
                                                                    tabIndex: "0",
                                                                    loading: props === null || props === void 0 ? void 0 : props.loading,
                                                                    data: product,
                                                                    staticTexts: props === null || props === void 0 ? void 0 : props.staticTexts,
                                                                    displayShare: (props === null || props === void 0 ? void 0 : props.displayShare) ? true : false,
                                                                    displayPrint: (props === null || props === void 0 ? void 0 : props.displayPrint) ? true : false,
                                                                    favorites: props === null || props === void 0 ? void 0 : props.favorites,
                                                                    cart: props === null || props === void 0 ? void 0 : props.cart,
                                                                    setIsModalShow: setIsModalShow,
                                                                    isModalShow: isModalShow,
                                                                    onInspirationSelect: onInspirationSelect
                                                                })
                                                            })
                                                        })
                                                    }, i);
                                                }))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row",
                                                children: (props === null || props === void 0 ? void 0 : props.totalResults) > (props === null || props === void 0 ? void 0 : props.curRows) && (props === null || props === void 0 ? void 0 : props.totalResults) > (props === null || props === void 0 ? void 0 : (ref2 = props.data) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: loadMoreClickHandler,
                                                    className: "kf-react-button button small load-more inspiration-list__load-more",
                                                    children: props === null || props === void 0 ? void 0 : (ref3 = props.staticTexts) === null || ref3 === void 0 ? void 0 : ref3.loadMore
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (props === null || props === void 0 ? void 0 : props.totalResults) > 30 ? "inspiration-list__back-to-top" : "inspiration-list__back-to-top inspiration_back-to-top",
                                                    children: [
                                                        lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "inspiration-list__print-and-share",
                                                            children: [
                                                                (props === null || props === void 0 ? void 0 : props.displayPrint) === "true" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    role: "button",
                                                                    onClick: ()=>window.print(),
                                                                    children: [
                                                                        props === null || props === void 0 ? void 0 : props.staticTexts.print,
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: print/* default */.Z,
                                                                            alt: props === null || props === void 0 ? void 0 : props.staticTexts.print
                                                                        })
                                                                    ]
                                                                }),
                                                                (props === null || props === void 0 ? void 0 : props.displayShare) === "true" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    role: "button",
                                                                    onClick: ()=>setShowSocialLink(!showSocialLink),
                                                                    children: [
                                                                        props === null || props === void 0 ? void 0 : props.staticTexts.share,
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: share/* default */.Z,
                                                                            alt: props === null || props === void 0 ? void 0 : props.staticTexts.share
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                                                                    showModal: showSocialLink,
                                                                    id: "kf-product-list",
                                                                    onClose: ()=>setShowSocialLink(false)
                                                                })
                                                            ]
                                                        }),
                                                        !lib/* isMobile */.tq && (props === null || props === void 0 ? void 0 : props.totalResults) > 30 && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductsPerPage, {
                                                            pos: "bottom",
                                                            curRows: props === null || props === void 0 ? void 0 : props.curRows,
                                                            data: props === null || props === void 0 ? void 0 : props.productsPerPage,
                                                            totalResults: props === null || props === void 0 ? void 0 : props.totalResults,
                                                            texts: props === null || props === void 0 ? void 0 : props.staticTexts,
                                                            onChange: props === null || props === void 0 ? void 0 : props.onRows,
                                                            addDataLayer: addDataLayer,
                                                            cartId: props === null || props === void 0 ? void 0 : (ref4 = props.cart) === null || ref4 === void 0 ? void 0 : ref4.id
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            className: "inspiration-list__go-back",
                                                            onClick: backToTopClickHandler,
                                                            children: [
                                                                props === null || props === void 0 ? void 0 : props.staticTexts.backToTop,
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: back_top_arrow/* default.src */.Z.src,
                                                                    alt: ""
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var InspirationLandingList_view = (InspirationLandingList);

;// CONCATENATED MODULE: ./components/InspirationLanding/v1/InspirationLanding.jsx













const InspirationLanding = (props)=>{
    const { data: authorData = {}  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const { inspirations  } = (0,es/* useSelector */.v9)(inspirationSlice/* selectInspirationState */.$5);
    const { favorites  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const [locale, setLocale] = (0,react.useState)("");
    const [currencySign, setCurrencySign] = (0,react.useState)("");
    const [currencyCode, setCurrencyCode] = (0,react.useState)("");
    var ref;
    const favoritesState = (ref = favorites === null || favorites === void 0 ? void 0 : favorites.textLineItems) !== null && ref !== void 0 ? ref : [];
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const { locale , currencySign , currencyCode  } = await (0,constants_config/* getConfig */.i)();
            setLocale(locale);
            setCurrencySign(currencySign);
            setCurrencyCode(currencyCode);
        };
        configFn();
    }, []);
    const persona = (0,helper/* getUserPersona */.shu)();
    const [componentProps, setComponentProps] = (0,react.useState)({});
    const [rows, setRows] = (0,react.useState)(lib/* isMobile */.tq ? 30 : 30);
    const [start, setStart] = (0,react.useState)(0);
    const [sorts, setSorts] = (0,react.useState)([
        {
            name: t("kf.plp.label.bestSellers"),
            query: "productName_t+asc"
        },
        {
            name: t("kf.plp.label.priceDesc"),
            query: "priceList.".concat(persona, ".finalPrice_d+desc")
        },
        {
            name: t("kf.plp.label.priceAsc"),
            query: "priceList.".concat(persona, ".finalPrice_d+asc")
        },
        {
            name: t("kf.plp.label.atoz"),
            query: "Tile_Title+asc"
        },
        {
            name: t("kf.plp.label.ztoa"),
            query: "Tile_Title+desc"
        }
    ]);
    const [selectedSort, setSelectedSort] = (0,react.useState)(null);
    const [curFilterQueries, setCurFilterQueries] = (0,react.useState)([]);
    const [productsPerPage, setProductsPerPage] = (0,react.useState)([
        30,
        60,
        90
    ]);
    const [xfHtml, setXfHtml] = (0,react.useState)("");
    const [urlTitle, setUrlTitle] = (0,react.useState)("");
    const prevSortRef = (0,react.useRef)({
        name: t("kf.plp.label.featured"),
        query: ""
    });
    const prevStartRef = (0,react.useRef)(0);
    const prevRowsRef = (0,react.useRef)(lib/* isMobile */.tq ? 30 : 30);
    const [currentEvent, setCurrentEvent] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        // to scrollup the product list
        window.scrollTo(0, 0);
        try {
            const queries = setFacets();
            getInspirationItems(queries);
        } catch (error) {
            console.error(error);
        }
    }, [
        isAuth
    ]);
    const setFacets = ()=>{
        const urlSearchParams = new URLSearchParams(window.location.search);
        let queries = [];
        urlSearchParams.forEach((values, filterName)=>{
            let multiValues = values.split(",");
            let displayNames = [];
            let displayValues = [];
            multiValues.forEach((facetsValues)=>{
                let displayValue = facetsValues;
                if (facetsValues.includes("|")) {
                    displayValue = facetsValues.split("|")[0];
                }
                displayNames.push(facetsValues);
                displayValues.push(displayValue);
            });
            queries.push({
                facet: filterName,
                value: displayNames,
                display: displayValues
            });
        });
        return queries;
    };
    const sanitizeText = (text)=>text.replace(/<\/?[^>]+(>|$)/g, "");
    const getSearchResult = lodash_debounce_default()((query, update, search, cb)=>{
        dispatch((0,inspirationSlice/* getInspirationDetails */.w4)({
            query,
            update,
            isSingle: false,
            search,
            cb
        }));
    }, 1000);
    const getInspirationItems = function(queries, update) {
        let search = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, cb = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        let newStart = 0;
        // save queries to handle sorting
        if (queries) {
            setCurFilterQueries(queries);
        } else {
            queries = curFilterQueries;
            newStart = start;
        }
        if (!update) {
            setStart(0);
        }
        // build lucid work query and make http request
        let fq = [];
        queries.forEach((q)=>{
            const fc = q.facet.replace(/^\*{2}/, "");
            const encodedFilterValues = q.value.map((queryValue)=>encodeURIComponent(queryValue));
            const tagValue = encodeURIComponent('{!tag="'.concat(fc, '"}'));
            fq.push("".concat(tagValue).concat(fc, ':("').concat(encodedFilterValues.join('" OR "'), '")'));
        });
        let query = {
            fq,
            rows,
            start: newStart
        };
        if (selectedSort) query.sort = selectedSort;
        getSearchResult(query, update, search, cb);
    };
    const handleSort = (query)=>{
        setSelectedSort(query);
        setStart(0);
        setCurrentEvent("sorting");
        getInspirationItems();
    };
    const handleRows = (rows)=>{
        setRows(rows);
        setStart(0);
        setCurrentEvent("pagination");
        sessionStorage.setItem("rows", rows);
    };
    const handleLoadMore = ()=>{
        setStart(start + rows);
        setRows(30);
        setCurrentEvent("loadmore");
    };
    (0,react.useEffect)(()=>{
        var ref;
        // Check if either selectedSort or start or row has changed
        if ((selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name) !== ((ref = prevSortRef.current) === null || ref === void 0 ? void 0 : ref.name) && currentEvent === "sorting") {
            getInspirationItems() // Update the previous values
            ;
            prevSortRef.current = selectedSort;
        }
        if (start !== prevStartRef.current && currentEvent === "loadmore") {
            getInspirationItems(null, true) // Update the previous values
            ;
            prevStartRef.current = start;
        }
        if (rows !== prevRowsRef.current && currentEvent === "pagination") {
            getInspirationItems() // Update the previous values
            ;
            prevRowsRef.current = rows;
        }
    }, [
        selectedSort,
        start,
        rows,
        currentEvent
    ]);
    const handleFilter = function(queries, update) {
        let search = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, cb = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        setStart(0);
        setCurrentEvent("filter");
        getInspirationItems(queries, update, search, cb);
    };
    const { data =[] , total , facets =[] , loading =true , colors , facetLabels  } = inspirations || {};
    const i18n = (0,react.useMemo)(()=>({
            matchNotFound: "Matches not found.",
            otherCombination: "Please try another combination.",
            loading: "Loading ...",
            pleaseWait: "Please wait.",
            noDataFound: "No Data Found."
        }), []);
    const staticTexts = (0,react.useMemo)(()=>({
            totalCount: t("kf.plp.label.totalCount", {
                count: total
            }),
            totalCount: t("kf.plp.label.totalCount"),
            hideFilterAria: t("kf.plp.label.hideFilterAria"),
            showFilterAria: t("kf.plp.label.showFilterAria"),
            clearAllAria: t("kf.plp.label.clearAllAria"),
            listWith: t("kf.plp.label.listWith"),
            items: t("kf.plp.label.inspirationItems"),
            facetListAriaExpandOrCollapse: t("kf.plp.label.facetListAriaExpandOrCollapse"),
            showMoreFiltersAria: t("kf.plp.label.showMoreFiltersAria"),
            sortByAria: t("kf.plp.label.sortByAria", {
                sortByCount: sorts.length
            }),
            salePriceAria: t("kf.plp.label.salePriceAria"),
            originalPriceAria: t("kf.plp.label.originalPriceAria"),
            productDescription: t("kf.plp.label.productDescription"),
            colorsLinkAria: t("kf.plp.label.colorsLinkAria"),
            pageTitleAria: t("kf.plp.label.pageTitleAria", {
                categoryName: componentProps.categoryName,
                brandName: "Kohler"
            }),
            print: t("kf.plp.label.print"),
            share: t("kf.plp.label.share"),
            wishlist: t("kf.plp.label.wishlist"),
            showFilter: t("kf.plp.label.showFilter"),
            hideFilter: t("kf.plp.label.hideFilter"),
            filters: t("kf.plp.label.filters"),
            addToCompare: t("kf.plp.label.addToCompare"),
            colors: t("kf.plp.label.colors"),
            color: t("kf.plp.label.color"),
            view: t("kf.plp.label.view"),
            all: t("kf.plp.label.all"),
            sort: t("kf.plp.label.sort"),
            applyFilters: "Apply Filters",
            results: t("kf.plp.label.results"),
            loadMore: t("kf.plp.label.loadMore"),
            backToTop: t("kf.plp.label.backToTop"),
            showMore: t("kf.plp.label.showMore"),
            showLess: t("kf.plp.label.showLess"),
            viewAll: t("kf.pdp.label.viewMore"),
            viewLess: t("annsacks.orderSample.label.viewLess"),
            clearAll: t("kf.plp.label.clearAll"),
            priceRangeTitle: t("kf.plp.label.priceRangeTitle"),
            priceRangeDesc: t("kf.plp.label.priceRangeDesc"),
            to: t("kf.plp.label.to"),
            minText: t("kf.plp.label.minText"),
            maxText: t("kf.plp.label.maxText"),
            sameCategory: componentProps.sameCategory ? componentProps.sameCategory : t("kf.compare.validation.sameCategory"),
            maxProduct: componentProps.maxProduct ? componentProps.maxProduct : t("kf.compare.validation.maxProducts"),
            favSuccessMsg: t("kf.favorites.success"),
            favErrorMsg: t("kf.favorites.error"),
            errors: {
                validRange: t("kf.plp.error.validRange"),
                minGreaterThanMax: t("kf.plp.error.minGreaterThanMax"),
                maxGreaterThanZero: t("kf.plp.error.maxGreaterThanZero"),
                checkValid: t("kf.error.message.price")
            },
            startingAt: t("kf.plp.label.startingAt"),
            new: componentProps.newBadge ? componentProps.newBadge : t("kf.plp.label.new"),
            sale: componentProps.sale ? componentProps.sale : t("kf.plp.label.sale"),
            viewResults: t("kf.plp.label.viewResults"),
            exclusive: t("kf.plp.label.exclusive"),
            newExclusive: t("kf.plp.label.newExclusive"),
            removeItem: t("kf.favorites.removeItem"),
            removeItemError: t("kf.favorites.removeItemError")
        }), [
        t,
        total,
        componentProps,
        sorts.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationLandingList_view, {
        loading: loading,
        componentProps: componentProps,
        curRows: rows,
        data: data,
        sorts: sorts,
        facets: facets,
        facetLabels: facetLabels,
        totalResults: total,
        onFilter: handleFilter,
        onSort: handleSort,
        onLoadMore: handleLoadMore,
        onRows: handleRows,
        staticTexts: staticTexts,
        i18n: i18n,
        isCurated: (componentProps === null || componentProps === void 0 ? void 0 : componentProps.type) === "curated",
        colors: colors,
        productsPerPage: productsPerPage,
        currFilters: curFilterQueries,
        selectedFilterCount: curFilterQueries && (curFilterQueries === null || curFilterQueries === void 0 ? void 0 : curFilterQueries.reduce((acc, item)=>{
            return acc + item.value.length;
        }, 0)),
        urlTitle: urlTitle,
        displayShare: authorData === null || authorData === void 0 ? void 0 : authorData.share,
        displayPrint: authorData === null || authorData === void 0 ? void 0 : authorData.print,
        enableFilter: authorData === null || authorData === void 0 ? void 0 : authorData.enableFilter,
        favorites: favoritesState
    });
};
/* harmony default export */ var v1_InspirationLanding = (InspirationLanding);

;// CONCATENATED MODULE: ./i18n/useTradeMembershipi18n.js

const useTradeMembershipi18n = (dataProps)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    var ref, ref1, ref2, ref3;
    const i18n = {
        requiredInfoText: t("kf.auth.label.requiredFields"),
        yes: t("kf.contactus.label.yes"),
        no: t("kf.contactus.label.no"),
        contactInformation: t("kf.contactus.label.contactInformation"),
        fname: t("kf.contactus.label.firstName"),
        lname: t("kf.contactus.label.lastName"),
        email: t("kf.contactus.label.emailAddress"),
        typeOf: t("kf.contactus.label.typeOf"),
        address: t("kf.contactus.label.address"),
        aptFloorSuite: t("kf.contactus.label.aptFloorSuite"),
        city: t("kf.contactus.label.city"),
        state: t("kf.contactus.label.state"),
        zipcode: t("kf.contactus.label.zipCode"),
        country: t("kf.contactus.label.country"),
        phoneNumber: t("kf.contactus.label.phoneNumber"),
        uploadCountLimit: (dataProps === null || dataProps === void 0 ? void 0 : dataProps.errorMessage) || t("kf.contactus.label.uploadCountLimit"),
        uploadFileTypes: t("kf.contactus.label.uploadFileTypes"),
        uploadSizeLimit: t("kf.contactus.label.uploadSizeLimit"),
        uploadMBLimit: t("kf.contactus.label.uploadMBLimit"),
        dragAndDrop: t("kf.contactus.label.dragAndDrop"),
        orText: t("kf.contactus.label.orText"),
        uploadFileButton: t("kf.contactus.label.uploadFileButton"),
        submitButton: t("kf.contactus.label.submitButton"),
        privacyPolicy: t("kf.contactus.label.privacyPolicy"),
        subjectAccessRequest: t("kf.contactus.label.subjectAccessRequest"),
        termsOfService: t("kf.contactus.label.termsOfService"),
        messageSent: (ref = dataProps === null || dataProps === void 0 ? void 0 : dataProps.successtitle) !== null && ref !== void 0 ? ref : t("kf.contactus.label.messageSent"),
        responseReceiveTime: (ref1 = dataProps === null || dataProps === void 0 ? void 0 : dataProps.successdescription) !== null && ref1 !== void 0 ? ref1 : t("kf.contactus.label.responseReceiveTime"),
        startShopping: (ref2 = dataProps === null || dataProps === void 0 ? void 0 : dataProps.ctalabel) !== null && ref2 !== void 0 ? ref2 : t("kf.trademembership.label.startShopping"),
        fnameError: t("kf.contactus.error.fnameError"),
        lnameError: t("kf.contactus.error.lnameError"),
        noEmailError: t("kf.contactus.error.noEmailError"),
        validEmail: t("kf.contactus.error.validEmail"),
        noCompanyError: t("kf.contactus.error.noCompanyError"),
        addressError: t("kf.contactus.error.addressError"),
        cityError: t("kf.contactus.error.cityError"),
        stateError: t("kf.contactus.error.stateError"),
        zipcodeError: t("kf.contactus.error.zipcodeError"),
        validZipcode: t("kf.contactus.error.validZipcode"),
        validPhone: t("kf.contactus.error.validPhone"),
        noPhoneError: t("kf.contactus.error.noPhoneError"),
        errorFileType: t("kf.trademembership.error.fileFormatType"),
        errorMaxFileSizeLimit: t("kf.contactus.error.maxFileSizeLimit"),
        serverError: (ref3 = dataProps === null || dataProps === void 0 ? void 0 : dataProps.errorMessage) !== null && ref3 !== void 0 ? ref3 : t("kf.contactus.error.serverError"),
        genError: t("kf.error.message.genericError"),
        ariaLabels: {
            imageRemove: t("kf.registerOfflineProduct.label.aria.removeImage")
        },
        commentBoxPlaceholder: t("kf.registerOfflineProduct.label.addComment"),
        primaryAddress: t("kf.account.label.primaryAddress"),
        jobType: t("kf.trademembership.label.jobType"),
        companyWebsite: t("kf.trademembership.label.companyWebsite"),
        company: t("kf.trademembership.label.company"),
        exHomeLabel: t("kf.trademembership.label.exHomeLabel"),
        asTradeCustomer: t("kf.trademembership.label.asTradeCustomer"),
        businessInformation: t("kf.keyspecifier.label.businessInformation"),
        uploadDoc: t("kf.trademembership.label.uploadBusinessDoc"),
        attachDoc: t("kf.trademembership.label.attachBusinessDoc"),
        designCert: t("kf.trademembership.label.interiorDesignCert"),
        designMembership: t("kf.trademembership.label.membershipDesignOrg"),
        businessLicense: t("kf.trademembership.label.businessLicense"),
        uploadFormatType: t("kf.trademembership.label.supportedFormat"),
        taxMsg: t("kf.trademembership.label.taxMessageText"),
        taxReqLabel: t("kf.trademembership.label.taxRequestLabel"),
        termsAndConsCheck: t("kf.trademembership.label.termsAndConditionCheck"),
        termsAndConsLabel: t("kf.trademembership.label.termsAndCondition"),
        newsletterCheck: t("kf.trademembership.label.newsletterCheck"),
        timeNedded: t("kf.trademembership.label.requiredDuration"),
        companyWebsiteError: t("kf.trademembership.error.companyWebsite"),
        jobTypeError: t("kf.trademembership.error.jobType"),
        subJobTypeError: t("kf.trademembership.error.subJobType")
    };
    return i18n;
};
/* harmony default export */ var i18n_useTradeMembershipi18n = (useTradeMembershipi18n);

// EXTERNAL MODULE: ./src/components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(15740);
// EXTERNAL MODULE: ./src/components/RegisterOnlineProduct/v1/RegisterOnlineHelper.js
var RegisterOnlineHelper = __webpack_require__(407);
// EXTERNAL MODULE: ./src/components/checkout/checkoutHelperFunction.js
var checkoutHelperFunction = __webpack_require__(90164);
// EXTERNAL MODULE: ./src/components/core/Input/Input.jsx
var Input = __webpack_require__(27222);
// EXTERNAL MODULE: ./src/components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(14629);
// EXTERNAL MODULE: ./public/icons/email.svg
var email = __webpack_require__(39306);
// EXTERNAL MODULE: ./public/icons/phone-icon.svg
var phone_icon = __webpack_require__(52324);
;// CONCATENATED MODULE: ./components/TradeMembership/Form/ContactInfo.jsx















const ContactInfo = (props)=>{
    const { data , setData , i18n , error  } = props;
    const [countries, setCountries] = (0,react.useState)([]);
    const [stateList, setStateList] = (0,react.useState)([]);
    const [suggestions, setSuggestions] = (0,react.useState)([]);
    const [addressSelected, setAddressSelected] = (0,react.useState)(false);
    const [primaryAddressChecked, setPrimaryAddressChecked] = (0,react.useState)(false);
    const { countryListPath , stateListPath  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        setData({
            ...data,
            state: {}
        });
    }, [
        data.country
    ]);
    (0,react.useEffect)(()=>{
        try {
            if (!isEmpty_default()(countryListPath) && !isEmpty_default()(stateListPath)) getLocations();
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    }, [
        countryListPath,
        stateListPath
    ]);
    (0,react.useEffect)(()=>{
        if (data.address && !addressSelected) getSuggestions(data.address);
    }, [
        data.address
    ]);
    const getSuggestions = (0,react.useCallback)(lodash_debounce_default()((addr)=>{
        (0,checkoutHelperFunction/* getAddressSuggestions */.We)(addr).then((suggData)=>setSuggestions(suggData));
    }, 300), [
        suggestions
    ]);
    const getLocations = async ()=>{
        if (countryListPath && stateListPath) {
            var ref, ref1;
            const countryData = await dispatch((0,genericSlice/* getCountryList */.Jp)());
            const stateData = await dispatch((0,genericSlice/* getstateList */.lK)());
            const mapList = !isEmpty_default()(countryData === null || countryData === void 0 ? void 0 : countryData.payload) && !isEmpty_default()(stateData === null || stateData === void 0 ? void 0 : stateData.payload) && (0,helper/* mapStateToCountryHandler */.oFy)(countryData === null || countryData === void 0 ? void 0 : countryData.payload, stateData === null || stateData === void 0 ? void 0 : stateData.payload) || [];
            setCountries(mapList);
            const config = await (0,constants_config/* getConfig */.i)();
            var ref2;
            const countryCode = (ref2 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.country) !== null && ref2 !== void 0 ? ref2 : "US";
            var ref3;
            setStateList((ref3 = (ref1 = mapList.find((c)=>{
                return (c === null || c === void 0 ? void 0 : c.code) === countryCode;
            })) === null || ref1 === void 0 ? void 0 : ref1.states) !== null && ref3 !== void 0 ? ref3 : []);
            var ref4;
            setData({
                ...data,
                country: (ref4 = mapList.find((country)=>country.code === "US")) !== null && ref4 !== void 0 ? ref4 : {}
            });
        }
    };
    const onNameChange = (e)=>{
        const { id , value  } = e.target;
        const field = id.split("-");
        if (value === "" || (0,helper/* validateField */.OP$)("name", value)) {
            setData({
                ...data,
                [field[2]]: value
            });
        }
    };
    const onInputChange = function(e) {
        let zipChange = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        const { id , value  } = e.target;
        const field = id.split("-");
        if (zipChange) {
            if (value === "" || (0,helper/* validateField */.OP$)("zipCodeNumeric", value)) {
                setData({
                    ...data,
                    [field[2]]: value
                });
            }
        } else {
            setData({
                ...data,
                [field[2]]: value
            });
        }
        setAddressSelected(false);
    };
    const onSuggestionSelect = async (val)=>{
        const { general: { siteName  } = {}  } = await (0,constants_config/* getConfig */.i)();
        const addr = (0,helper/* destructureAddress */.LY3)(val, siteName);
        var ref;
        setData({
            ...data,
            address: addr.address,
            city: addr.city,
            state: (ref = stateList.find((s)=>{
                return (s === null || s === void 0 ? void 0 : s.code) === (addr === null || addr === void 0 ? void 0 : addr.state);
            })) !== null && ref !== void 0 ? ref : {},
            zipcode: addr.zipcode
        });
        props.setError({
            ...error,
            address: false,
            city: false,
            state: false,
            zipcode: false
        });
        setSuggestions([]);
        setAddressSelected(true);
    };
    const changeCountry = (country)=>{
        var ref;
        var ref1;
        setStateList((ref1 = (ref = countries === null || countries === void 0 ? void 0 : countries.find((c)=>{
            return (c === null || c === void 0 ? void 0 : c.name) === country;
        })) === null || ref === void 0 ? void 0 : ref.states) !== null && ref1 !== void 0 ? ref1 : []);
        setData({
            ...data,
            country: countries === null || countries === void 0 ? void 0 : countries.find((c)=>{
                return (c === null || c === void 0 ? void 0 : c.name) === country;
            })
        });
    };
    const changeState = (state)=>{
        var ref;
        setData({
            ...data,
            state: (ref = {
                code: state
            }) !== null && ref !== void 0 ? ref : {}
        });
        props.setError({
            ...error,
            state: false
        });
    };
    var _code, _name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "contact-title",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "contact-title__fields",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "question",
                                    children: i18n.contactInformation
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "required-fields",
                                children: i18n.requiredInfoText
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container contact-info-form",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row mx-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-fname col-12 col-sm-6 col-md-6 pl-0 pr-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "contact-user-fname",
                                        type: "text",
                                        value: data.fname,
                                        maxLength: 40,
                                        placeholder: "".concat(i18n.fname, "*"),
                                        label: "".concat(i18n.fname, "*"),
                                        onChange: onNameChange,
                                        showError: error.fname,
                                        errorMessage: error.fname,
                                        onBlur: ()=>props.onBlur("fname"),
                                        autoComplete: "given-name"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-lname col-12 col-sm-6 col-md-6 pr-0 pl-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "contact-user-lname",
                                        type: "text",
                                        value: data.lname,
                                        maxLength: 40,
                                        placeholder: "".concat(i18n.lname, "*"),
                                        label: "".concat(i18n.lname, "*"),
                                        onChange: onNameChange,
                                        showError: error.lname,
                                        errorMessage: error.lname,
                                        onBlur: ()=>props.onBlur("lname"),
                                        autoComplete: "family-name"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row mx-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "user-email col-12 px-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: "contact-user-email",
                                    type: "text",
                                    value: data.email,
                                    maxLength: 60,
                                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: email/* default */.Z === null || email/* default */.Z === void 0 ? void 0 : email/* default.src */.Z.src,
                                        alt: "",
                                        "aria-hidden": "true"
                                    }),
                                    placeholder: "".concat(i18n.email, "*"),
                                    label: "".concat(i18n.email, "*"),
                                    onChange: onInputChange,
                                    showError: error.email,
                                    errorMessage: error.email,
                                    onBlur: ()=>props.onBlur("email"),
                                    autoComplete: "email"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row mx-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-address col-12 col-md-12 col-lg-9 pl-0 mobile-pr-0 pr-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "contact-user-address",
                                        type: "text",
                                        value: data.address,
                                        placeholder: "".concat(i18n.address, "*"),
                                        label: "".concat(i18n.address, "*"),
                                        onChange: onInputChange,
                                        showError: error.address,
                                        errorMessage: error.address,
                                        suggestions: suggestions,
                                        onSelect: onSuggestionSelect,
                                        onBlur: ()=>props.onBlur("address"),
                                        autoComplete: "address-line1"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-aptFloor col-12 col-md-12 col-lg-3 col-sm-12 pr-0 mobile-pl-0 pl-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "contact-user-aptFloor",
                                        type: "text",
                                        value: data.aptFloor,
                                        autoComplete: "address-line2",
                                        placeholder: i18n.aptFloorSuite,
                                        label: i18n.aptFloorSuite,
                                        onChange: onInputChange
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row mx-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-city col-12 col-md-12 col-lg-6 pl-0 mobile-pr-0 pr-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "contact-user-city",
                                        type: "text",
                                        value: data.city,
                                        autoComplete: true,
                                        placeholder: "".concat(i18n.city, "*"),
                                        label: "".concat(i18n.city, "*"),
                                        onChange: onInputChange,
                                        showError: error.city,
                                        errorMessage: error.city,
                                        onBlur: ()=>props.onBlur("city")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-state col-6 col-md-6 col-lg-3 pr-10 mobile-pl-0 pl-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                        id: "contact-user-state",
                                        data: stateList !== null && stateList !== void 0 ? stateList : [],
                                        value: (_code = data.state.code) !== null && _code !== void 0 ? _code : "",
                                        label: "".concat(i18n.state, "*"),
                                        onChange: changeState,
                                        showError: error.state,
                                        errorMessage: error.state,
                                        onBlur: ()=>props.onBlur("state"),
                                        ariaStateText: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-zipcode col-6 col-md-6 col-lg-3 pr-0 pl-10 mobile-pr-0 mobile-pl-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "contact-user-zipcode",
                                        type: "text",
                                        value: data.zipcode,
                                        maxLength: 7,
                                        autoComplete: "postal-code",
                                        placeholder: "".concat(i18n.zipcode, "*"),
                                        label: "".concat(i18n.zipcode, "*"),
                                        onChange: (e)=>onInputChange(e, true),
                                        showError: error.zipcode,
                                        errorMessage: error.zipcode,
                                        onBlur: ()=>props.onBlur("zipcode")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row mx-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-country col-12 col-sm-6 col-md-6 pl-0 pr-10 mb-20",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                        id: "contact-user-country",
                                        data: countries.map((country)=>{
                                            return country === null || country === void 0 ? void 0 : country.name;
                                        }),
                                        name: "country",
                                        value: (_name = data.country.name) !== null && _name !== void 0 ? _name : "",
                                        label: "".concat(i18n.country),
                                        onChange: changeCountry,
                                        showError: error.country,
                                        errorMessage: error.country
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-phone col-12 col-sm-6 col-md-6 pr-0 pl-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "contact-user-phone",
                                        type: "text",
                                        maxLength: 60,
                                        placeholder: "".concat(i18n.phoneNumber, "*"),
                                        label: "".concat(i18n.phoneNumber, "*"),
                                        prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: phone_icon/* default */.Z === null || phone_icon/* default */.Z === void 0 ? void 0 : phone_icon/* default.src */.Z.src,
                                            alt: "",
                                            "aria-hidden": "true"
                                        }),
                                        value: data.phone,
                                        onChange: (e)=>setData({
                                                ...data,
                                                phone: (0,RegisterOnlineHelper/* convertToPhoneNumber */["in"])(e.target.value)
                                            }),
                                        showError: error.phone,
                                        errorMessage: error.phone,
                                        onBlur: ()=>props.onBlur("phone")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row mx-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "primary-address-checkbox",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    value: i18n.primaryAddress,
                                    checked: primaryAddressChecked,
                                    onChange: (e)=>{
                                        setPrimaryAddressChecked(!primaryAddressChecked);
                                        setData({
                                            ...data,
                                            isPrimaryAddress: !primaryAddressChecked
                                        });
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row mx-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 px-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: "contact-user-label",
                                    type: "text",
                                    value: data.label,
                                    maxLength: 60,
                                    placeholder: "".concat(i18n.exHomeLabel),
                                    label: "".concat(i18n.exHomeLabel),
                                    onChange: onInputChange
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Form_ContactInfo = (ContactInfo);

// EXTERNAL MODULE: ./src/components/core/RadioButton/RadioButton.jsx
var RadioButton = __webpack_require__(94593);
;// CONCATENATED MODULE: ./components/TradeMembership/Form/BusinessInfo.jsx









const BusinessInfo = (props)=>{
    const { data , i18n , setData , error  } = props;
    const { jobTypePath  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [jobTypes, setJobType] = (0,react.useState)([]);
    const [subJobTypes, setSubJobTypes] = (0,react.useState)([]);
    const radioKeyDown = (e)=>{
        const nextRadio = e.target.nextSibling;
        const previousRadio = e.target.previousSibling;
        if (e.key === "ArrowLeft" && previousRadio) {
            previousRadio.focus();
        } else if (e.key === "ArrowRight" && nextRadio) {
            nextRadio.focus();
        } else if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.target.click();
        }
    };
    (0,react.useEffect)(()=>{
        try {
            if (!isEmpty_default()(jobTypePath)) getJobTypes();
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    }, [
        jobTypePath
    ]);
    const getJobTypes = async ()=>{
        const jobType = await dispatch((0,genericSlice/* getJobTypeList */.Vp)());
        setJobType(jobType === null || jobType === void 0 ? void 0 : jobType.payload);
    };
    const selectJobType = (jobType)=>{
        setData({
            ...data,
            jobType,
            subJobType: ""
        });
        const subTypeL = jobTypes.find((el)=>el.text === jobType).value.split(",").filter((e)=>e);
        setSubJobTypes(subTypeL);
        props.setError({
            ...error,
            jobType: false
        });
    };
    const selectSubJobType = (subJobType)=>{
        setData({
            ...data,
            subJobType
        });
        props.setError({
            ...error,
            subJobType: false
        });
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "optional-form",
        role: "radiogroup",
        "aria-labelledby": "with-professional-radio",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        id: "business-information-section",
                        className: "question",
                        children: i18n.businessInformation
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "business-form-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "kf-company-name",
                            type: "text",
                            value: (data === null || data === void 0 ? void 0 : data.company) || "",
                            maxLength: 50,
                            placeholder: "".concat(i18n.company, "*"),
                            label: "".concat(i18n.company, "*"),
                            onChange: (e)=>{
                                const { value  } = e.target;
                                if ((0,helper/* validateField */.OP$)("company", value) || value === "") {
                                    setData({
                                        ...data,
                                        company: value
                                    });
                                }
                            },
                            showError: error.company,
                            errorMessage: error.company,
                            onBlur: ()=>props.onBlur("company")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "kf-company-website",
                            type: "text",
                            value: (data === null || data === void 0 ? void 0 : data.companyWebsite) || "",
                            maxLength: 50,
                            placeholder: "".concat(i18n.companyWebsite, "*"),
                            label: "".concat(i18n.companyWebsite, "*"),
                            onChange: (e)=>{
                                const { value  } = e.target;
                                if ((0,helper/* validateField */.OP$)("companyWebsite", value) || value === "") {
                                    setData({
                                        ...data,
                                        companyWebsite: value
                                    });
                                }
                            },
                            showError: error.companyWebsite,
                            errorMessage: error.companyWebsite,
                            onBlur: ()=>props.onBlur("companyWebsite")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-pl-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                id: "contact-user-job-type",
                                customClass: "input-field",
                                data: jobTypes === null || jobTypes === void 0 ? void 0 : jobTypes.map((el)=>el.text),
                                value: (ref = data === null || data === void 0 ? void 0 : data.jobType) !== null && ref !== void 0 ? ref : "",
                                label: "".concat(i18n.jobType, "*"),
                                onChange: selectJobType,
                                showError: error.jobType,
                                errorMessage: error.jobType,
                                onBlur: ()=>props.onBlur("jobType")
                            })
                        }),
                        data.jobType && subJobTypes.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-pl-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                id: "contact-user-subJobType",
                                data: subJobTypes,
                                value: data.subJobType,
                                label: "".concat(i18n.typeOf).concat(data.jobType, "*"),
                                onChange: selectSubJobType,
                                showError: error.subJobType,
                                errorMessage: error.subJobType,
                                onBlur: ()=>props.onBlur("subJobType")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "trade-customer-radio-option",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "radio-wrapper",
                        role: "radiogroup",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "trade-customer",
                                children: i18n.asTradeCustomer
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                id: "trade-customer",
                                name: "trade-customer",
                                value: i18n.yes,
                                checked: data.tradeCustomer,
                                onClick: ()=>setData({
                                        ...data,
                                        tradeCustomer: true
                                    }),
                                onKeydown: radioKeyDown,
                                "aria-checked": props.checked,
                                role: "radio"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                id: "not-trade-customer",
                                name: "trade-customer",
                                value: i18n.no,
                                checked: !data.tradeCustomer,
                                onClick: ()=>setData({
                                        ...data,
                                        tradeCustomer: false
                                    }),
                                onKeydown: radioKeyDown,
                                "aria-checked": props.checked,
                                role: "radio"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Form_BusinessInfo = (BusinessInfo);

// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 5 modules
var react_dropzone_dist_es = __webpack_require__(68901);
// EXTERNAL MODULE: ./public/icons/pdf-grey.svg
var pdf_grey = __webpack_require__(1405);
;// CONCATENATED MODULE: ./components/TradeMembership/analytics.js
const analytics_addDataLayer = (params)=>{
    var ref, ref1, ref2, ref3;
    const { title ="" , msg ="" , sts ="" , jobType ="" , subJobType ="" , formTitle ="" , isType ="" , clickInternalLinks ="true" , tradeCustomer =null , taxReq =null , termsAndConsCheck =null , newsletterCheck =null , url =null , uploadedDocs =null , isLink =false , isUpload =false  } = params;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageType = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : (ref1 = ref.pageType) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
    const pageName = "".concat(pageType, ":").concat(page === null || page === void 0 ? void 0 : (ref2 = page.category) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subCategoryID) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase());
    const submitAnalyticsJSON = title === "submit" ? {
        jobType,
        subJobType,
        existingTradeCustomer: tradeCustomer ? "yes" : "no",
        requestTaxExemptionStatus: taxReq ? "yes" : "no",
        termsAndConditions: termsAndConsCheck ? "yes" : "no",
        newsletterSignUp: newsletterCheck ? "yes" : "no"
    } : null;
    const uploadedFiles = title === "upload business documentation" || title === "submit" ? uploadedDocs === null || uploadedDocs === void 0 ? void 0 : uploadedDocs.map((image)=>{
        var ref, ref1, ref2, ref3, ref4;
        return {
            fileName: ((ref1 = image === null || image === void 0 ? void 0 : (ref = image.path) === null || ref === void 0 ? void 0 : ref.split(".")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || "n/a",
            fileType: ((ref4 = image === null || image === void 0 ? void 0 : (ref3 = image.path) === null || ref3 === void 0 ? void 0 : ref3.split(".")) === null || ref4 === void 0 ? void 0 : ref4[1]) || "n/a",
            fileSize: "".concat(((image === null || image === void 0 ? void 0 : image.size) / 1e6).toFixed(3), " mb") || 0
        };
    }) : null;
    const uploadedFilesJSON = uploadedFiles ? {
        uploadedFiles
    } : null;
    let internalLinkType, eventAction, internalLinkZoneName, internalLinkName;
    if (isLink) internalLinkType = "".concat(pageType, ":navigation");
    else if (isUpload) {
        eventAction = "".concat(pageName, ":").concat(formTitle, ":").concat(title, ":").concat(isType);
        internalLinkZoneName = "".concat(pageName, ":").concat(formTitle, ":").concat(title);
        internalLinkName = "".concat(isType);
        internalLinkType = "".concat(pageType, ":navigation");
    }
    const eventInfo = {
        eventAction: eventAction || "".concat(pageName, ":").concat(formTitle, ":").concat(title),
        eventName: eventAction || "".concat(pageName, ":").concat(formTitle, ":").concat(title),
        eventType: "navigation",
        eventMsg: msg || "n/a",
        eventStatus: sts || "n/a",
        internalLinkName: internalLinkName || "".concat(title),
        internalLinkPosition: "".concat(pageName),
        internalLinkType: internalLinkType || "".concat(pageType, ":").concat(title),
        internalLinkZoneName: internalLinkZoneName || "".concat(pageName, ":").concat(formTitle),
        internalLinkURL: url || "n/a",
        clickInternalLinks: clickInternalLinks,
        ...submitAnalyticsJSON,
        ...uploadedFilesJSON
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};

;// CONCATENATED MODULE: ./components/TradeMembership/Form/UploadDocument.jsx







// import { log } from "@Services/logger.service"





const UploadDocument = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const [errors, setErrors] = (0,react.useState)([]);
    const [status, setStatus] = (0,react.useState)("");
    const [isChecked, setIsChecked] = (0,react.useState)(false);
    const [isUploadClick, setIsUploadClick] = (0,react.useState)(false);
    const { imageList =null , updateList , i18n , data , setData , formTitle  } = props;
    const onDrop = async (acceptedFiles, rejectedFiles)=>{
        var ref, ref1, ref2;
        const errList = (ref = rejectedFiles[0]) === null || ref === void 0 ? void 0 : ref.errors.map((el)=>el.message);
        const isType = "".concat(isUploadClick ? "upload file" : "drag and drop");
        errList && setErrors(errList);
        if (!errList && (errors === null || errors === void 0 ? void 0 : errors.length) > 0) setErrors([]);
        if (errList) {
            var ref3, ref4;
            if (((ref4 = (ref3 = rejectedFiles[0]) === null || ref3 === void 0 ? void 0 : ref3.errors[0]) === null || ref4 === void 0 ? void 0 : ref4.code) === "file-invalid-type") {
                var ref5;
                analytics_addDataLayer({
                    title: "upload business documentation",
                    isUpload: true,
                    uploadedDocs: [
                        ...imageList
                    ],
                    sts: "failure",
                    msg: i18n === null || i18n === void 0 ? void 0 : (ref5 = i18n.errorFileType) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase(),
                    formTitle,
                    isType
                });
                setErrors([
                    i18n.errorFileType
                ]);
            }
        } else {
            if ((imageList === null || imageList === void 0 ? void 0 : imageList.length) + (acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles.length) <= 5) {
                setErrors([]);
                try {
                    const newImageList = await Promise.all(acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles.map(async (f)=>{
                        const res = await dispatch((0,genericSlice/* uploadImage */.Ix)(f)).unwrap();
                        return Object.assign(f, {
                            preview: URL.createObjectURL(f),
                            comment: "",
                            link: res === null || res === void 0 ? void 0 : res.path,
                            textCount: 0
                        });
                    }));
                    updateList([
                        ...imageList,
                        ...newImageList
                    ]);
                    analytics_addDataLayer({
                        title: "upload business documentation",
                        isUpload: true,
                        uploadedDocs: [
                            ...imageList,
                            ...newImageList
                        ],
                        sts: "success",
                        formTitle,
                        isType
                    });
                } catch (err) {
                // log.error(err)
                }
            } else {
                var ref6;
                analytics_addDataLayer({
                    title: "upload business documentation",
                    isUpload: true,
                    uploadedDocs: [
                        ...imageList
                    ],
                    sts: "failure",
                    msg: i18n === null || i18n === void 0 ? void 0 : (ref6 = i18n.uploadCountLimit) === null || ref6 === void 0 ? void 0 : ref6.toLowerCase(),
                    formTitle,
                    isType
                });
                setErrors([
                    i18n.uploadCountLimit
                ]);
            }
        }
        if ((rejectedFiles === null || rejectedFiles === void 0 ? void 0 : rejectedFiles.length) > 5 || ((ref1 = rejectedFiles[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.size) > 5e6) {
            (rejectedFiles === null || rejectedFiles === void 0 ? void 0 : rejectedFiles.length) > 5 ? setErrors([
                i18n.uploadCountLimit
            ]) : setErrors([
                i18n.errorMaxFileSizeLimit
            ]);
        }
        setIsUploadClick(false);
    };
    const validator = (file)=>{
        if ((file === null || file === void 0 ? void 0 : file.size) > 5e6) {
            return {
                message: i18n.errorMaxFileSizeLimit
            };
        }
        switch(file === null || file === void 0 ? void 0 : file.type){
            case "image/jpeg":
            case "application/pdf":
                break;
            default:
                return {
                    message: i18n.errorFileType
                };
        }
    };
    const { getRootProps , getInputProps  } = (0,react_dropzone_dist_es/* useDropzone */.uI)({
        accept: "image/jpeg, application/pdf",
        maxFiles: 5,
        multiple: true,
        onDrop,
        validator
    });
    const onAddComment = (v, id)=>{
        let newList = imageList;
        newList[id]["comment"] = v;
        newList[id]["textCount"] = v === null || v === void 0 ? void 0 : v.length;
        updateList([
            ...newList
        ]);
    };
    const onDelete = (id)=>{
        const newList = imageList.filter((l)=>l !== id);
        updateList(newList);
        setStatus(i18n.ariaLabels.imageRemove);
    };
    const handleFocus = (e)=>{
        e.currentTarget.classList.add("active-comment");
    };
    const handleBlur = (e)=>{
        e.currentTarget.classList.remove("active-comment");
    };
    const truncateFileName = function(fileName) {
        let maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
        if (!fileName) return "";
        const parts = fileName.split(".");
        if (parts.length < 2) return fileName;
        const extension = parts.pop();
        const baseName = parts.join(".");
        if (baseName.length <= maxLength) return fileName;
        const visibleLength = maxLength - 3; // Reserve space for "..."
        const start = baseName.slice(0, visibleLength / 2);
        const end = baseName.slice(-visibleLength / 2);
        return "".concat(start, "...").concat(end, ".").concat(extension);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "optional-form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "question",
                children: i18n.uploadDoc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "description",
                children: i18n.attachDoc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "description-list",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: i18n.designCert
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: i18n.designMembership
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: i18n.businessLicense
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "upload-notes",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "upload-notes__supported-formats",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "upload-notes__supported-formats-description",
                                children: "".concat(i18n.uploadFileTypes, " ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "upload-notes__supported-formats-value",
                                children: i18n.uploadFormatType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "upload-notes__supported-size",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "upload-notes__supported-size-description",
                                children: i18n.uploadSizeLimit
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "upload-notes__supported-size-value",
                                children: i18n.uploadMBLimit
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "asset-upload-tax-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "upload-image-container ".concat((imageList === null || imageList === void 0 ? void 0 : imageList.length) < 6 && (imageList === null || imageList === void 0 ? void 0 : imageList.length) !== 0 ? "file-5" : ""),
                        id: "contact-image-preview-container",
                        tabIndex: "-1",
                        role: "presentation",
                        children: [
                            imageList === null || imageList === void 0 ? void 0 : imageList.map((f, i)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    id: "input-id-active",
                                    className: "contact-us-image-preview",
                                    onClick: handleFocus,
                                    onBlur: handleBlur,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "preview-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: classnames_default()({
                                                    "image-box": f.type !== "application/pdf"
                                                }),
                                                src: f.type === "application/pdf" ? pdf_grey/* default */.Z : f.preview,
                                                alt: f.name.length < 12 ? f.name : truncateFileName(f.name, 12)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                            id: "image-placeholder-".concat(i),
                                            placeholder: i18n.commentBoxPlaceholder,
                                            value: f.comment,
                                            onChange: (e)=>onAddComment(e.target.value, i),
                                            maxLength: 100
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "text-count",
                                            children: [
                                                f.textCount,
                                                " / 100"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "image-delete",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                tabIndex: "0",
                                                className: "custom-close-icone",
                                                onClick: ()=>onDelete(f),
                                                src: icons_close/* default */.Z === null || icons_close/* default */.Z === void 0 ? void 0 : icons_close/* default.src */.Z.src,
                                                alt: "close"
                                            })
                                        })
                                    ]
                                }, i);
                            }),
                            (imageList === null || imageList === void 0 ? void 0 : imageList.length) !== 5 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "drag-and-drop-container",
                                ...getRootProps(),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        ...getInputProps()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "drag-and-drop-text-large",
                                        children: i18n.dragAndDrop
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "drag-and-drop-text-small",
                                        children: i18n.orText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "drag-and-drop-upload-btn",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            role: "button",
                                            tabIndex: "0",
                                            type: "ghost",
                                            label: i18n.uploadFileButton,
                                            onClick: ()=>setIsUploadClick(true),
                                            disabled: (imageList === null || imageList === void 0 ? void 0 : imageList.length) === 5 && lib/* isMobile */.tq
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                role: "region",
                                "aria-live": "polite",
                                className: "aria-messages",
                                children: status
                            }),
                            errors && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "upload-image-container__error-msg",
                                children: errors[0]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tax-request-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tax-request-footer__message",
                                children: i18n.taxMsg
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                value: i18n.taxReqLabel,
                                checked: isChecked,
                                onChange: (e)=>{
                                    setIsChecked(!isChecked);
                                    setData({
                                        ...data,
                                        taxReq: !isChecked
                                    });
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Form_UploadDocument = (UploadDocument);

;// CONCATENATED MODULE: ./components/TradeMembership/Form/SubmitFooter.jsx








function SubmitFooter(props) {
    const { data , i18n , setData , onSubmit , formTitle , error: { subJobType =""  } , termsAndConsLink , getInternalLinkURLS , legalPages , recaptchaAnalytics  } = props;
    const [newsletterChecked, setNewsletterChecked] = (0,react.useState)(false);
    const [termsAndConsChecked, setTermsAndConsChecked] = (0,react.useState)(false);
    const [subJobError, setSubJobError] = (0,react.useState)(true);
    const [termsAndConditionsLink, setTermsAndConditionsLink] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (termsAndConsLink) {
            getTermsAndConsLink(termsAndConsLink);
        }
    }, [
        termsAndConsLink
    ]);
    const getTermsAndConsLink = async (url)=>{
        const link = await (0,helper/* getShortenedUrl */.Ppy)(url);
        setTermsAndConditionsLink(link);
    };
    (0,react.useEffect)(()=>{
        document.getElementById("contact-form-subJobType") ? !data.subJobType || subJobType ? setSubJobError(true) : setSubJobError(false) : setSubJobError(false);
    }, [
        data
    ]);
    const footerClickHandler = (e, link, title)=>{
        analytics_addDataLayer({
            clickInternalLinks: getInternalLinkURLS(link),
            title: title.toLowerCase(),
            isLink: true,
            formTitle,
            url: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a"
        });
        (0,helper/* getSiteWideModal */.Ure)(e, link);
    };
    const checkDisabled = (userdata)=>{
        if (userdata.fname.trim() && userdata.lname.trim() && userdata.email.trim() && userdata.phone && userdata.zipcode && userdata.company.trim() && userdata.address.trim() && userdata.city.trim() && userdata.state && userdata.companyWebsite.trim() && userdata.jobType.trim() && userdata.termsAndConsCheck && !subJobError) return false;
        return true;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "trade-membership-footer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "trade-membership-footer__checkbox",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "terms-conditions-check",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                value: i18n.termsAndConsCheck,
                                checked: termsAndConsChecked,
                                onChange: (e)=>{
                                    setTermsAndConsChecked(!termsAndConsChecked);
                                    setData({
                                        ...data,
                                        termsAndConsCheck: !termsAndConsChecked
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: termsAndConditionsLink,
                                className: "terms-conditions-link",
                                label: i18n.termsAndConsLabel,
                                onClick: (e)=>footerClickHandler(e, termsAndConditionsLink, i18n.termsAndConsLabel),
                                children: i18n.termsAndConsLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "newsletter-check",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            value: i18n.newsletterCheck,
                            checked: newsletterChecked,
                            onChange: (e)=>{
                                setNewsletterChecked(!newsletterChecked);
                                setData({
                                    ...data,
                                    newsletterCheck: !newsletterChecked
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "trade-membership-footer__response-recieve-time",
                children: i18n.timeNedded
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "trade-membership-footer__submit-button",
                role: "button",
                id: "submit-membership-form-button",
                disabled: checkDisabled(data),
                onClick: onSubmit,
                type: "black",
                label: i18n.submitButton,
                loading: props.loading,
                flexible: true
            }),
            !isEmpty_default()(recaptchaAnalytics) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {
                getAnalyticsData: recaptchaAnalytics
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "trade-membership-policies",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#",
                        rel: "noreferrer",
                        onClick: (e)=>{
                            return footerClickHandler(e, legalPages === null || legalPages === void 0 ? void 0 : legalPages.privacyPolicy, i18n.privacyPolicy);
                        },
                        children: i18n.privacyPolicy
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#",
                        rel: "noreferrer",
                        onClick: (e)=>{
                            return footerClickHandler(e, legalPages === null || legalPages === void 0 ? void 0 : legalPages.subjectAccessRequest, i18n.subjectAccessRequest);
                        },
                        children: i18n.subjectAccessRequest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#",
                        rel: "noreferrer",
                        onClick: (e)=>footerClickHandler(e, termsAndConditionsLink, i18n.termsOfService),
                        children: i18n.termsOfService
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/TradeMembership/TradeMembershipConfirmation/index.jsx






const TradeMembershipConfirmation = (props)=>{
    (0,react.useEffect)(()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "trade-membership-confirmation-message-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "kf-react-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "trade-membership__success-message",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "trade-membership-success-message",
                        className: "message-content",
                        tabIndex: "0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "success-message-body",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(props.i18n.messageSent)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "trade-membership-response-message",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "response-message-body",
                                children: (0,helper/* sanitizeInnerHtml */.KD0)(props.i18n.responseReceiveTime)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "black",
                                target: (props === null || props === void 0 ? void 0 : props.isNewTab) ? "_blank" : "_self",
                                label: props.i18n.startShopping,
                                to: props === null || props === void 0 ? void 0 : props.continueShoppingUrl,
                                className: "start-shopping-btn",
                                onClick: ()=>{
                                    var ref;
                                    return analytics_addDataLayer({
                                        isLink: true,
                                        clickInternalLinks: props === null || props === void 0 ? void 0 : props.getInternalLinkURLS(props.continueShoppingUrl),
                                        title: (ref = props.i18n.startShopping) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                        formTitle: (0,helper/* cleanHtmlTextForDatalayer */.ZNj)(props.i18n.messageSent),
                                        url: (props === null || props === void 0 ? void 0 : props.continueShoppingUrl) ? ((props === null || props === void 0 ? void 0 : props.continueShoppingUrl.indexOf("http")) === -1 ? window.location.origin : "") + (props === null || props === void 0 ? void 0 : props.continueShoppingUrl) : "n/a"
                                    });
                                }
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TradeMembership_TradeMembershipConfirmation = ((0,lib/* withOrientationChange */.Qe)(TradeMembershipConfirmation));

;// CONCATENATED MODULE: ./components/TradeMembership/Trademembership.view/index.jsx





// import { log } from "@Services/logger.service";







const TradeMembership = (props)=>{
    const { i18n , submitSuccess , brandName , termsAndConsLink , isNewTab , subjectAccessRequest  } = props;
    const [userData, setUserData] = (0,react.useState)({
        fname: "",
        lname: "",
        email: "",
        tradeCustomer: true,
        newsletterCheck: false,
        address: "",
        aptFloor: "",
        city: "",
        state: {},
        subJobType: "",
        zipcode: "",
        country: {},
        phone: "",
        company: "",
        isPrimaryAddress: false,
        companyWebsite: "",
        jobType: "",
        label: "",
        taxReq: false,
        termsAndConsCheck: false
    });
    const [imageFiles, setImageFiles] = (0,react.useState)([]);
    const [error, setError] = (0,react.useState)({});
    const [loading, setLoading] = (0,react.useState)(false);
    const [authoredConfirmSection, setAuthoredConfirmSection] = (0,react.useState)(null);
    const [authoredWelcomeSection, setAuthoredWelcomeSection] = (0,react.useState)(null);
    const [formTitle, setFormTitle] = (0,react.useState)(null);
    const [continueShoppingCTALink, setContinueShoppingCTALink] = (0,react.useState)("");
    const [recaptchaAnalytics, setRecaptchaAnalytics] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        const confirmSection = (document === null || document === void 0 ? void 0 : (ref = document.querySelectorAll) === null || ref === void 0 ? void 0 : (ref1 = ref.call(document, "#confirmation-section")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.parentElement) || null;
        const welcomeSection = (document === null || document === void 0 ? void 0 : (ref3 = document.getElementById) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.call(document, "form-section")) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.querySelectorAll) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.call(ref4, "div.teaser")) === null || ref6 === void 0 ? void 0 : ref6[0]) || null;
        const formTitleText = ((ref9 = document === null || document === void 0 ? void 0 : (ref7 = document.getElementById) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.call(document, "trade-program-form-title")) === null || ref8 === void 0 ? void 0 : ref8.querySelectorAll("h1")) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.innerText) === null || ref11 === void 0 ? void 0 : ref11.toLowerCase()) || null;
        getRecaptchaAnalytics({
            confirmSection,
            welcomeSection,
            formTitleText
        });
        getContinueShoppingUrl();
    }, [
        brandName
    ]);
    const getRecaptchaAnalytics = (obj)=>{
        var ref, ref1, ref2, ref3;
        const { confirmSection , welcomeSection , formTitleText  } = obj;
        const page = (0,helper/* getPageInfo */.UMn)();
        const pageName = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : (ref1 = ref.subCategory1) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
        const pageType = page === null || page === void 0 ? void 0 : (ref2 = page.category) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pageType) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase();
        setRecaptchaAnalytics({
            addNoFooterInAttr: true,
            pageTitle: "".concat(pageName, ":").concat(formTitleText),
            internalLinkPosition: "".concat(pageName),
            internalLinkType: "".concat(pageType, ":navigation")
        });
        setFormTitle(formTitleText);
        setAuthoredConfirmSection(confirmSection);
        setAuthoredWelcomeSection(welcomeSection);
    };
    const getContinueShoppingUrl = async ()=>{
        const url = await (0,helper/* getShortenedUrl */.Ppy)(props === null || props === void 0 ? void 0 : props.continueShoppingUrl) || "/";
        setContinueShoppingCTALink(url);
    };
    const validateExist = (field)=>{
        switch(field){
            case "fname":
            case "lname":
                if (!userData[field].trim() || !(0,helper/* validateField */.OP$)("name", userData[field])) {
                    return field === "fname" ? i18n.fnameError : i18n.lnameError;
                }
                break;
            case "email":
                if (!userData[field]) return i18n.noEmailError;
                else if (!(0,helper/* validateField */.OP$)("email", userData[field])) return i18n.validEmail;
                break;
            case "phone":
                if (!userData.phone) return i18n.noPhoneError;
                else if (!(0,helper/* validatePhone */.a$Q)(userData.phone)) return i18n.validPhone;
                break;
            case "zipcode":
                if (!userData.zipcode.trim()) return i18n.zipcodeError;
                else if (userData.zipcode.length < 5) return i18n.validZipcode;
                break;
            case "company":
                if (userData.company.trim() === "" || !(0,helper/* validateField */.OP$)("company", userData[field])) return i18n.noCompanyError;
                break;
            case "address":
                if (!userData.address.trim()) return i18n.addressError;
                break;
            case "city":
                if (!userData.city.trim()) return i18n.cityError;
                break;
            case "state":
                if (!userData.state || isEmpty_default()(userData.state)) return i18n.stateError;
                break;
            case "companyWebsite":
                if (userData.companyWebsite.trim() === "" || !(0,helper/* validateField */.OP$)("website", userData[field])) return i18n.companyWebsiteError;
                break;
            case "jobType":
                if (userData.jobType.trim() === "") return i18n.jobTypeError;
                break;
            case "subJobType":
                if (document.getElementById("contact-user-subJobType") && userData.subJobType.trim() === "") return i18n.subJobTypeError;
                break;
            default:
                return;
        }
    };
    const onBlurError = (field)=>{
        setError({
            ...error,
            [field]: validateExist(field)
        });
    };
    const getInternalLinkURLS = (url)=>{
        return (url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) ? "true" : "false";
    };
    const getErrorList = ()=>{
        let errorList = {
            fname: validateExist("fname"),
            lname: validateExist("lname"),
            email: validateExist("email"),
            zipcode: validateExist("zipcode"),
            phone: validateExist("phone"),
            company: validateExist("company"),
            address: validateExist("address"),
            city: validateExist("city"),
            state: validateExist("state"),
            companyWebsite: validateExist("companyWebsite"),
            jobType: validateExist("jobType"),
            subJobType: validateExist("subJobType")
        };
        return errorList;
    };
    const onSubmit = ()=>{
        setLoading(true);
        let errorDataList = [];
        const errorList = getErrorList();
        const imageLinks = imageFiles.map((image)=>({
                link: image.link,
                success: true
            }));
        setError(errorList);
        if (errorList.fname) {
            errorDataList.push("contact-user-fname");
        } else if (errorList.lname) {
            errorDataList.push("contact-user-lname");
        } else if (errorList.email) {
            errorDataList.push("contact-user-email");
        } else if (errorList.zipcode) {
            errorDataList.push("contact-user-zipcode");
        } else if (errorList.phone) {
            errorDataList.push("contact-user-phone");
        } else if (errorList.company) {
            errorDataList.push("kf-company-name");
        } else if (errorList.address) {
            errorDataList.push("contact-user-address");
        } else if (errorList.city) {
            errorDataList.push("contact-user-city");
        } else if (errorList.state) {
            errorDataList.push("contact-user-state");
        } else if (errorList.companyWebsite) {
            errorDataList.push("kf-company-website");
        } else if (errorList.jobType) {
            errorDataList.push("contact-user-job-type");
        } else if (errorList.subJobType) {
            errorDataList.push("contact-user-subJobType");
        }
        errorDataList.forEach((item, i)=>{
            if (i === 0) document.getElementById("".concat(item)).focus();
        });
        const isInvalid = Object.values(errorList).find((el)=>el);
        const { fname , lname , email , tradeCustomer , newsletterCheck , address , aptFloor , city , state , subJobType , zipcode , country , phone , company , isPrimaryAddress , companyWebsite , jobType , label , taxReq , termsAndConsCheck  } = userData;
        if (!isInvalid) {
            let body = {
                FirstName: fname,
                LastName: lname,
                Email: email,
                Address1: address,
                Address2: aptFloor,
                City: city,
                StateProvince: state.code,
                PostalCode: zipcode,
                Country: country.code,
                Phone: phone,
                IsPrimaryAddress: isPrimaryAddress,
                AddressLabel: label,
                AttachmentLinks: imageLinks,
                Company: company,
                CompanyWebsite: companyWebsite,
                JobType: jobType,
                JobSubType: subJobType,
                IsUserExistingTradeCustomer: tradeCustomer,
                RequestTaxExemptionStatus: taxReq,
                "Subscribe Ann Sacks": newsletterCheck
            };
            (0,helper/* sanitizeObject */.O0b)(body);
            setLoading(false);
            (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
                if (res.success) {
                    constants_api/* apim.post */.TH.post("/membership/trade?brand=".concat(brandName), body).then(()=>{
                        var ref, ref1;
                        props.handleSubmitMsg(true);
                        authoredWelcomeSection === null || authoredWelcomeSection === void 0 ? void 0 : (ref = authoredWelcomeSection.classList) === null || ref === void 0 ? void 0 : ref.add("trade-membership__success--hidden");
                        authoredConfirmSection === null || authoredConfirmSection === void 0 ? void 0 : (ref1 = authoredConfirmSection.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("container-content-hide");
                        analytics_addDataLayer({
                            title: "submit",
                            sts: "success",
                            formTitle,
                            jobType: jobType === null || jobType === void 0 ? void 0 : jobType.toLowerCase(),
                            subJobType: (subJobType === null || subJobType === void 0 ? void 0 : subJobType.toLowerCase()) || "n/a",
                            tradeCustomer,
                            taxReq,
                            termsAndConsCheck,
                            newsletterCheck,
                            uploadedDocs: imageFiles
                        });
                    }).catch((err)=>{
                        var ref;
                        setLoading(false);
                        props.showToaster(i18n.serverError);
                        //   log.error(err);
                        analytics_addDataLayer({
                            title: "submit",
                            sts: "failure",
                            msg: i18n === null || i18n === void 0 ? void 0 : (ref = i18n.serverError) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                            formTitle,
                            jobType: jobType === null || jobType === void 0 ? void 0 : jobType.toLowerCase(),
                            subJobType: (subJobType === null || subJobType === void 0 ? void 0 : subJobType.toLowerCase()) || "n/a",
                            tradeCustomer,
                            taxReq,
                            termsAndConsCheck,
                            newsletterCheck,
                            uploadedDocs: imageFiles
                        });
                    });
                } else {
                    setLoading(false);
                    props.showToaster(i18n.genError);
                }
            });
        } else {
            analytics_addDataLayer({
                title: "submit",
                sts: "failure",
                msg: isInvalid === null || isInvalid === void 0 ? void 0 : isInvalid.toLowerCase(),
                formTitle,
                jobType: jobType === null || jobType === void 0 ? void 0 : jobType.toLowerCase(),
                subJobType: (subJobType === null || subJobType === void 0 ? void 0 : subJobType.toLowerCase()) || "n/a",
                tradeCustomer,
                taxReq,
                termsAndConsCheck,
                newsletterCheck,
                uploadedDocs: imageFiles
            });
            setLoading(false);
        }
    };
    return !submitSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "kf-react-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "trade-membership-main",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_ContactInfo, {
                    i18n: i18n,
                    data: userData,
                    setData: setUserData,
                    error: error,
                    setError: setError,
                    onBlur: onBlurError
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_BusinessInfo, {
                    i18n: i18n,
                    data: userData,
                    setData: setUserData,
                    error: error,
                    setError: setError,
                    onBlur: onBlurError
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_UploadDocument, {
                    imageList: imageFiles,
                    updateList: setImageFiles,
                    i18n: i18n,
                    data: userData,
                    setData: setUserData,
                    formTitle: formTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitFooter, {
                    i18n: i18n,
                    data: userData,
                    setData: setUserData,
                    onSubmit: onSubmit,
                    error: error,
                    legalPages: props.legalPages,
                    loading: loading,
                    formTitle: formTitle,
                    termsAndConsLink: termsAndConsLink,
                    subjectAccessRequest: subjectAccessRequest,
                    getInternalLinkURLS: getInternalLinkURLS,
                    recaptchaAnalytics: recaptchaAnalytics
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeMembership_TradeMembershipConfirmation, {
        i18n: i18n,
        setSubmitSuccess: props.handleSubmitMsg,
        continueShoppingUrl: continueShoppingCTALink,
        isNewTab: isNewTab,
        getInternalLinkURLS: getInternalLinkURLS
    });
};
/* harmony default export */ var Trademembership_view = (TradeMembership);

;// CONCATENATED MODULE: ./components/TradeMembership/index.jsx









const TradeMembership_TradeMembership = (props)=>{
    var ref, ref1;
    const { data: componentProp  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [submitSuccess, setSubmitSuccess] = (0,react.useState)(false);
    const [brandName, setBrandName] = (0,react.useState)("");
    const [legalPageLinks, setLegalPageLinks] = (0,react.useState)(null);
    const [teaserComponent, setTeaserComponent] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        var ref;
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            setBrandName(get_default()(config, "general.siteName", ""));
            setLegalPageLinks(get_default()(config, "legalPageData.map", {}));
        });
        dispatch((0,genericSlice/* getGenericListPath */.Ln)());
        if (document === null || document === void 0 ? void 0 : (ref = document.getElementById) === null || ref === void 0 ? void 0 : ref.call(document, "aem-lead-gen-container")) {
            var ref1;
            setTeaserComponent(document === null || document === void 0 ? void 0 : (ref1 = document.getElementById) === null || ref1 === void 0 ? void 0 : ref1.call(document, "aem-lead-gen-container"));
        }
    }, []);
    const i18n = i18n_useTradeMembershipi18n(componentProp);
    const handleSubmit = (status)=>{
        setSubmitSuccess(status);
    };
    const showToaster = (msg)=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: msg,
            isVisible: true
        }));
    };
    var ref2, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Trademembership_view, {
        i18n: i18n,
        submitSuccess: submitSuccess,
        legalPages: legalPageLinks,
        handleSubmitMsg: handleSubmit,
        continueShoppingUrl: (ref2 = props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.ctalink) !== null && ref2 !== void 0 ? ref2 : "",
        showToaster: (msg)=>showToaster(msg),
        brandName: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase(),
        isNewTab: (ref3 = props === null || props === void 0 ? void 0 : (ref1 = props.data) === null || ref1 === void 0 ? void 0 : ref1.isnewtab) !== null && ref3 !== void 0 ? ref3 : false,
        teaserComponent: teaserComponent,
        termsAndConsLink: (ref4 = componentProp === null || componentProp === void 0 ? void 0 : componentProp.termsandconditionslink) !== null && ref4 !== void 0 ? ref4 : ""
    }, submitSuccess);
};
/* harmony default export */ var components_TradeMembership = ((0,esm/* withTranslation */.Zh)()(TradeMembership_TradeMembership));

;// CONCATENATED MODULE: ./src/pages/page.jsx































/**
 * renders home page
 * @return {JSX.Element}
 */ function Home(param) {
    let { tmpData: data , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analyticsData , gbhDataLayerCustom , fullUrl , urlNames , data404  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [pageRedirect, setPageRedirect] = (0,react.useState)("");
    const [isScrollMarginRequired, setIsScrollMarginRequired] = (0,react.useState)(false);
    const { pageUrl ="" , redirectTarget: { page: { path =""  } = {}  } = {}  } = data;
    const { scroll  } = constants.DEFAULT_SCROLL;
    (0,react.useEffect)(()=>{
        if (pageUrl) {
            var ref, ref1;
            const containsString = constants.DISABLE_SROLL_PATH.some((str)=>pageUrl.includes(str));
            var ref2;
            const installServiceHash = (ref2 = (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes(constants.INSTALLATION_SERVICES_ASPATH)) && (router === null || router === void 0 ? void 0 : (ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.includes("#"))) !== null && ref2 !== void 0 ? ref2 : false;
            if (containsString) {
                window.scrollTo({
                    top: 1,
                    behavior: "smooth"
                });
            }
            if (installServiceHash) {
                setTimeout(()=>{
                    var ref;
                    var ref1;
                    const hashValue = (ref1 = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("#")[1]) !== null && ref1 !== void 0 ? ref1 : "";
                    var ref2;
                    const element = (ref2 = document.querySelector("#".concat(hashValue))) !== null && ref2 !== void 0 ? ref2 : {};
                    const offsetTop = (0,helper/* getOffsetTop */.oJS)(element) - scroll;
                    window.scrollTo({
                        top: offsetTop,
                        behavior: "smooth"
                    });
                }, 3000);
            }
        }
    }, [
        pageUrl
    ]);
    (0,react.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,usePageAuth/* default */.Z)();
    (0,react.useEffect)(()=>{
        var ref, ref1;
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        if (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes(constants.PRIVACY_ASPATH)) {
            dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(true));
        }
        if (router === null || router === void 0 ? void 0 : (ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.includes(constants.INSTALLATION_SERVICES_ASPATH)) {
            setIsScrollMarginRequired(true);
        }
        return ()=>dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
    }, []);
    (0,react.useEffect)(()=>{
        (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        if (path) {
            setPageRedirect((0,helper/* removeAndCleanLink */.xEh)(path));
        }
    }, [
        path
    ]);
    (0,react.useEffect)(()=>{
        if (!isSsr && pageRedirect) {
            router.push(pageRedirect);
        }
    }, [
        isSsr,
        pageRedirect
    ]);
    (0,react.useEffect)(()=>{
        (0,helper/* getScriptsAndStyles */.csL)(data);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* default */.Z, {
                ...data,
                fullUrl: fullUrl
            }) : null,
            header ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
                header: header,
                title: data.title,
                globalScripting: globalScript
            }) : null,
            data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
                isScrollMarginRequired: isScrollMarginRequired,
                data: data,
                count: 0,
                breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumb["default"], {
                        data: data,
                        fullData: fullData
                    }),
                productAccordion: (data, fullData)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion/* default */.Z, {
                        data: data,
                        fullData: fullData
                    }),
                contactUsFiller: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(KnowledgeArticleFiller/* default */.Z, {}),
                contactUs: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUs/* default */.Z, {
                        data: data
                    }),
                leadGeneration: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGeneration/* default */.Z, {
                        data: data
                    }),
                tradeMembership: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_TradeMembership, {
                        data: data
                    }),
                keySpecifier: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(KeySpecifier/* default */.Z, {
                        data: data
                    }),
                associateMembership: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(AssociateMembership/* default */.Z, {
                        data: data
                    }),
                friendsAndFamily: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FriendsAndFamily/* default */.Z, {
                        data: data
                    }),
                literature: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Literature/* default */.Z, {
                        data: data
                    }),
                inspirationLanding: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_InspirationLanding, {
                        data: data
                    }),
                inspirationDetail: (data)=>{
                    var ref;
                    if (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes(constants.COMPONENT_TYPES.INSPIRATION_DETAIL)) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-component": "InspirationDetail",
                            "data-static-text": JSON === null || JSON === void 0 ? void 0 : JSON.stringify(data),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_InspirationDetail, {
                                data: data,
                                isDetailsPage: true
                            })
                        });
                    } else {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-component": "InspirationDetail",
                            "data-static-text": JSON === null || JSON === void 0 ? void 0 : JSON.stringify(data)
                        });
                    }
                },
                technicalSpecifications: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "main-content",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalSpecs/* default */.Z, {
                            data: data
                        })
                    }),
                knowledgeArticle: (data, urlNames)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(KnowledgeArticle/* default */.Z, {
                        data: data,
                        urlNames: urlNames,
                        data404: data404
                    }),
                knowledgeArticleFiller: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(KnowledgeArticleFiller/* default */.Z, {}),
                urlNames: urlNames,
                browseAllStores: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BrowseAllStores/* default */.Z, {
                        data: data
                    }),
                installDesignServices: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(InstallDesignServices/* default */.Z, {
                        data: data
                    }),
                findStore: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FindStore/* default */.Z, {
                        data: data
                    }),
                findashowroom: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Findashowroom, {
                        data: data
                    })
            }) : null,
            footer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
                footer: footer,
                footerScripting: footerScript
            }) : null
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var page = (Home);


/***/ }),

/***/ 20711:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productTileWrapper":"ProductTile_productTileWrapper__slRQS"};

/***/ }),

/***/ 77360:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"original-price":"DisplayDiscountPrice_original-price__NHYKU","discountprice":"DisplayDiscountPrice_discountprice__mIQmW"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,6351,4432,7333,361,8153,2252,5675,4303,6331,5535,3668,5531,1304,1934,9342,3236,3707,9786,3104,9774,2888,179], function() { return __webpack_exec__(65449); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);